export const SUPPORTED_LANGUAGES = ['es', 'en'];
export const DEFAULT_LANGUAGE = 'es';
export const LANGUAGE_STORAGE_KEY = 'language';

export const translations = {
  es: {
    common: {
      the: 'El',
      was: 'fue de',
      reached: 'alcanzó',
      points: 'puntos',
      of: 'de',
      delete: 'Eliminar',
      save: 'Guardar',
      cancel: 'Cancelar',
      areYouSure: '¿Estás seguro?',
      deleted: 'Eliminado',
      athlete: 'Atleta',
      trainer: 'Entrenador',
      dashboard: 'Dashboard',
      username: 'Usuario',
      password: 'Contraseña',
      login: 'Iniciar sesión',
      athleteGroup: 'Grupo de Atletas',
      send: 'Enviar',
      backToHome: 'Volver al inicio',
      pagina_no_encontrada: 'Página no encontrada',
      pagina_no_encontrada_descripcion: 'La página que buscas no existe o fue movida.',
    },
    physio: {
      cyclingSession: 'Durante esta sesión de ciclismo, el atleta logró una',
      np: 'potencia normalizada',
      npSuffix: 'W, lo cual refleja la carga fisiológica sostenida. Su',
      wkg: 'relación W/kg',
      wkgSuffix: 'W/kg, indicando un rendimiento relativo acorde a su peso.',
      vo2max: 'VO₂ máx',
      vo2Suffix: 'ml/kg/min, lo que ofrece una visión general de su capacidad aeróbica. Además, el',
      if: 'Factor de Intensidad (IF)',
      ifHigh: 'sesión de alta intensidad.',
      ifMed: 'sesión de intensidad moderada.',
      ifLow: 'sesión de baja intensidad.',
      tss: 'TSS',
      tssDuration: 'con una duración total de',
      tssMinutes: 'minutos, lo que se alinea con una carga de entrenamiento',
      loadVeryHigh: 'muy alta.',
      loadHigh: 'moderada-alta.',
      loadMed: 'moderada.',
      loadLow: 'liviana.',
      avgHR: 'FC Promedio',
      avgHRSuffix: 'bpm, alcanzando un máximo de',
      avgHREnd: 'bpm, lo que permite validar el esfuerzo cardiovascular sostenido.',
    },
    fileUpload: {
      selectFile: 'Seleccionar archivo .fit',
      upload: 'Cargar',
      uploading: 'Subiendo...',
      onlyFitFiles: 'Solo se permiten archivos .fit',
      pleaseSelectFile: 'Por favor selecciona un archivo .fit',
      noUserId: 'No se encontro el ID del usuario (userId)',
      uploadError: 'Error al subir archivo',
      noFileIdReturned: 'El servidor no retorno un fileId. Verifica que el archivo sea valido.',
      saveFileIdError: 'Error guardando fileId en actividad',
      activityUpdated: 'Actividad actualizada',
      syncSuccess: 'Los datos del archivo .fit fueron sincronizados correctamente.',
      fileUploaded: 'Archivo subido',
    },

	home: {
	  title: 'Bienvenido a Tzone',
	  subtitle: 'Plataforma para atletas y entrenadores: planificación, seguimiento y análisis del entrenamiento.',
	  enter: 'Ingresar',
	  register: 'Registrarse',
	  community: 'Comunidad Tzone',
	  companyPrefix: '© 2025 TZONE Corp SpA · RUT 77.923.319-7 · Lo Barnechea, Santiago de Chile',
	  privacyPolicy: 'Política de privacidad',
	  privacyPolicyEs: 'Política de privacidad',
	  privacyPolicyEn: 'Privacy Policy',
	  metricsNotice: 'Aviso sobre métricas y marcas registradas'
	},

    login: {
      title: 'Iniciar sesión',
      forgotPassword: '¿Olvidaste tu contraseña?',
      blockedUser: 'Usuario bloqueado. Contacta a tu entrenador.',
      invalidCredentials: 'Nombre de usuario o contraseña incorrectos.'
    },

    register: {
      title: 'Registro de usuario',
      alreadyHaveAccount: '¿Ya tienes cuenta?',
      loginLink: 'Inicia sesión',
      name: 'Nombre',
      lastName: 'Apellido',
      selectRole: 'Selecciona tu rol',
      passwordsDontMatch: 'Las contraseñas no coinciden',
      submitError: 'Error al registrar. Intenta de nuevo.'
    },

    forgotPassword: {
      title: 'Recuperar contraseña',
      submitSuccess: 'Correo de recuperación enviado. Revisa tu bandeja de entrada.',
      submitError: 'Error al enviar el correo. Intenta de nuevo.'
    },

    resetPassword: {
      title: 'Restablecer contraseña',
      success: 'Contraseña restablecida correctamente. Inicia sesión ahora.',
      submit: 'Restablecer',
      error: 'Error al restablecer la contraseña.'
    },

    passwordReset: {
      title: 'Recuperar contraseña',
      success: 'Correo de recuperación enviado. Revisa tu bandeja de entrada.',
      error: 'Error al solicitar la recuperación de contraseña.'
    },

    changePassword: {
      title: 'Cambiar contraseña',
      confirmNewPassword: 'Confirmar nueva contraseña',
      submit: 'Actualizar contraseña',
      mismatch: 'Las nuevas contraseñas no coinciden.',
      success: 'Contraseña actualizada exitosamente.',
      error: 'Error al actualizar la contraseña. Verifica tus datos.'
    },
	
	
	weeklySummaryChart: {
	  planned: 'Planificado',
	  completed: 'Completado',
          noPlan: 'Sin plan',
	  title: 'Planificado vs Completado',
	  ariaLabel: 'Planificado vs Completado por disciplina',
	  metrics: {
		distance: 'Distancia (km)',
		time: 'Duración (hh:mm)',
		calories: 'Calorías kcal',
		elevation: 'Desnivel positivo (m)',
		tss: 'TSS'
	  },
	  short: {
		distance: 'Distancia',
		time: 'Duración',
		calories: 'Calorías',
		elevation: 'Desnivel',
		tss: 'TSS'
	  },
	  units: {
		hours: 'h',
		minutes: 'min'
	  }
	},

	weeklySummary: {
	  title: 'Cumplimiento Semanal',
	  subtitle: 'Resumen Semanal',
	  metric: 'Métrica',
	  sessions: 'Sesiones',
	  distance: 'Distancia',
	  duration: 'Duración',
	  calories: 'Calorías kcal',
	  elevation: 'Desnivel positivo',
	  tss: 'TSS'
	},
	
	summary: {
	  loading: 'Cargando...',
	  noData: 'No se encontraron datos',
	  loadError: 'Hubo un error al cargar los datos',
	  title: 'Resumen de Running',
	  date: 'Fecha',
	  sport: 'Deporte',
	  duration: 'Duración',
	  distance: 'Distancia',
	  calories: 'Calorías',
	  ascent: 'Ascenso',
	  descent: 'Descenso',
	  elevationGain: 'Desnivel Positivo',
	  avgHR: 'FC Promedio',
	  maxHR: 'FC Máxima',
	  avgPace: 'Ritmo Promedio',
	  maxPace: 'Ritmo Máximo',
	  avgSpeed: 'Vel. Promedio',
	  maxSpeed: 'Vel. Máxima',
	  notAvailable: 'No disponible'
	},
	
    backend: {
      requiredFields: 'Todos los campos son obligatorios',
      emailOrUsernameExists: 'El correo o nombre de usuario ya está registrado',
      registerSuccess: 'Usuario registrado correctamente',
      internalError: 'Error interno del servidor',
      invalidCredentials: 'Nombre de usuario o contraseña incorrectos',
      blockedUser: 'Usuario bloqueado',
      loginSuccess: 'Inicio de sesión exitoso',
      userNotFound: 'Usuario no encontrado',
      recoverySubject: 'Recuperación de contraseña',
      recoverySent: 'Correo enviado para restablecer la contraseña',
      invalidOrExpiredToken: 'Token inválido o expirado',
      passwordResetSuccess: 'Contraseña restablecida correctamente',
      profileUpdated: 'Perfil actualizado exitosamente',
      athleteProfileUpdated: 'Perfil del atleta actualizado exitosamente',
      currentPasswordIncorrect: 'Contraseña actual incorrecta.',
      passwordUpdated: 'Contraseña actualizada correctamente.'
    },

    trainerDashboard: {
      trainerPhotoAlt: 'Foto del entrenador',
      title: 'Dashboard del Entrenador',
      manageAthletes: 'Administrar Atletas',
      viewProfile: 'Ver Perfil',
      plans: 'Planes',
      athleteGroup: 'Grupo de Atletas',
      community: 'Comunidad',
      notifications: 'Notificaciones',
      logout: 'Cerrar sesión',
      backToDashboard: '← Volver al dashboard',
      pmcOverviewTitle: 'CTL / ATL / TSB — todos los atletas',
      acwrTitle: 'ACWR — Carga aguda vs crónica',
      myAthletes: 'Mis Atletas ({{count}})',
      clearSelection: 'Limpiar selección',
      inviteAthlete: 'Invitar atleta',
      emailPlaceholder: 'Correo electrónico',
      sendInvite: 'Enviar invitación',
      noAthletesTitle: 'Aún no tienes atletas',
      noAthletesText: 'Invita atletas para ver gráficos, ranking y métricas.',
      loadingData: 'Cargando datos…',
      topDetail: 'Top 10 (detalle con perfiles)',

      viewingAthlete: 'Viendo a: {{name}}',
      viewCalendar: 'Ver Calendario',
      viewZones: 'Ver Zonas',
      performance: 'Rendimiento',

      missingInviteData: 'Faltan datos para enviar la invitación',
      inviteSent: '✅ Invitación enviada correctamente',
      inviteError: '❌ Error al enviar la invitación',

      dropDateNotDetected: 'No pude detectar el día de destino. Intenta soltar sobre el cuadro del día.',
      selectAthleteBeforeAssign: 'Selecciona un atleta antes de asignar.',
      templateReadError: '⚠️ No pude leer la plantilla (sin días/actividades).',

      planAppliedResult: '✅ Plan aplicado: {{ok}} actividad(es) creada(s){{fail}}',
      failedCount: ' · ❌ fallidas: {{fail}}',

      unknownError: 'Error desconocido',
      assignError: '❌ No se pudo asignar. {{message}}',

      noPerformanceData: 'Sin datos de rendimiento para mostrar.',
      performanceLoadHttpError: 'No se pudo cargar rendimiento (HTTP {{status}}).',
      performanceLoadNoResponse: 'No se pudo cargar rendimiento (sin respuesta).',

      showingSampleCompliance: 'Mostrando cumplimiento de ejemplo mientras conectas el endpoint.',

      aiError: 'Error: {{message}}',

      viewLabel: 'Vista:',
      pmcSelectorAria: 'Selector de PMC',
      simple: 'Simple',
      advancedAmcharts: 'Avanzado (amCharts)',
      both: 'Ambos',

      consultingAi: 'Consultando IA…',
      testAi: 'Probar IA (CTL/ATL/TSB)',

      aiDemoNotice: {
        before: 'Si el backend no tiene ',
        after: ', verás respuesta en ',
        demoMode: 'modo demo'
      },

      addGroup: 'Agregar Grupo',
      searchAthlete: 'Buscar atleta...',
      groups: 'Grupos',
      loadingGroups: 'Cargando grupos...',
      noGroups: 'No hay grupos',
      noAthletes: 'Sin atletas',
      noMembers: 'Sin integrantes',
      athlete: 'Atleta',
      athletesShort: 'at.',
      errorLoadingGroups: 'No se pudieron cargar los grupos',
      banisterModelTitle: 'PMC Avanzado (amCharts)',
      classicPmcTitle: 'PMC Simple'
    },

	athleteDashboard: {
	  profilePhotoAlt: 'Foto de perfil',
	  loadingProfile: 'Cargando...',
	  title: 'Mi Entrenamiento',
	  community: 'Comunidad',
	  settings: 'Configuración del Atleta',
	  logout: 'Cerrar sesión',
	  updatingSummary: 'Actualizando resumen (backend)…',
	  emptySummary: 'Resumen semanal aún no poblado (backend).',
	  coachAssistant: 'Asistente del Entrenador',
	  garminSync: 'Sincronizar Garmin',
	  myProfile: 'Mi Perfil',
	  settingsShort: 'Ajustes',
	  weeklySummaryTitle: 'Resumen semanal',
	  weeklyVisualAria: 'Resumen semanal visual',
	  sport: 'Deporte',
	  plannedDistanceShort: 'Dist P',
	  completedDistanceShort: 'Dist R',
	  plannedDurationShort: 'Dur P',
	  completedDurationShort: 'Dur R',
	  runningShort: 'Correr',
	  cyclingShort: 'Cicl.',
	  swimmingShort: 'Nad.',
	  strengthShort: 'Fuerza',
	  total: 'TOTAL',
	  distanceShort: 'Dist',
	  timeShort: 'Tiempo',
	  caloriesShort: 'Cal',
	  elevationShort: 'Elev',
	  planned: 'Planificado',
	  completed: 'Completado',
	  distance: 'Distancia',
	  duration: 'Duración',
	  calories: 'Calorías',
	  calendarHint: 'Click en evento -> detalle · Click en día vacío -> agregar',
	  pmcTitle: 'PMC - Gestión de Rendimiento',
	  whatIfNext7: 'What-if - próximos 7 días',
	  tss7d: 'TSS 7d:',
	  projectedCtlLoad: 'CTL proyectado: {{ctl}} · TSB: {{tsb}}',
	  aiSessionAnalysis: 'Análisis IA de sesión',
	  copy: 'Copiar',
	  recalculate: 'Recalcular',
	  aiSource: 'Fuente',
	  aiSessionTitle: 'Sesión de calidad - Running Z2',
	  aiSessionText: 'FC media 148 bpm (Z2). Pace 5:12/km. CTL +0.8. Carga adecuada para el plan actual.',
	  aiRealTss: 'TSS real: 82 (plan: 80)',
	  aiHrVariability: 'Variabilidad FC normal',
	  coachAiAssistant: 'Asistente Coach IA (Groq)',
        
        runningPhysio: {
          title: 'Análisis Fisiológico de la Sesión',
          vo2Sentence: 'El VO₂ max estimado fue de {{value}} ml/kg/min, lo que ofrece una visión general de su capacidad aeróbica.',
          tssSentence: 'El TSS fue de {{tss}} puntos, con una duración total de {{duration}} minutos, lo que se alinea con una carga de entrenamiento {{load}}.',
          loadHigh: 'muy alta',
          loadModerate: 'moderada',
          hrSentence: 'La sesión mostró una frecuencia cardíaca promedio de {{avg}} bpm, alcanzando un máximo de {{max}} bpm.',
          npSentence: 'La Potencia Normalizada fue de {{value}} W, reflejando mejor la exigencia fisiológica de la sesión.',
          avgPowerSentence: 'La Potencia Promedio fue de {{value}} W, útil para observar la carga sostenida general.',
          maxPowerSentence: 'La Potencia Máxima registrada fue de {{value}} W, indicando el pico de esfuerzo en la sesión.',
          ftpSentence: 'El FTP estimado fue de {{value}} W, una referencia clave para evaluar el rendimiento sostenido.',
          tteSentence: 'El TTE fue de {{value}}, indicando que:',
          teaSentence: 'El TEA fue de {{value}}, lo que sugiere que:',
          chartTitle: 'Resumen Visual de Métricas Fisiológicas',
        },
        coachBot: {
          greeting: 'Hola 👋 Soy el asistente del entrenador. ¿En qué te ayudo hoy?',
          welcomeNote: 'Encantado, {{name}}. Puedo ayudarte con tu planificación, métricas y progreso semanal.',
          noAnswer: 'No tengo respuesta ahora mismo.',
          connectError: 'No pude conectar con el asistente. Intenta de nuevo.',
          inputPlaceholder: 'Escribe tu pregunta…',
          sending: 'Enviando…',
          trainerView: 'Vista entrenador',
          athleteView: 'Vista atleta',
          quickTsb: '¿Cómo está mi TSB hoy y qué significa?',
          quickTsbLabel: 'TSB hoy',
          quickWeek: 'Dame un resumen de mi semana planificada (duración, distancia y TSS).',
          quickWeekLabel: 'Resumen semana plan',
          quickLoad: '¿Cuánta carga (TSS) tengo esta semana y cómo impacta en CTL/ATL?',
          quickLoadLabel: 'Carga semanal (TSS)',
          quickTomorrow: '¿Qué entrenamiento tengo mañana?',
          quickTomorrowLabel: 'Entreno de mañana',
        },

	  training: 'Entrenamiento',
	  session: 'Sesión',
	  notAvailable: 'No disponible',

	  success: {
		activitySaved: 'Actividad guardada'
	  },


	  // AthleteHeader
	  panelTitle: 'Panel del Atleta',
	  navLibrary: 'Biblioteca',
	  navStatistics: 'Estadísticas',
	  navZones: 'Zonas de Entrenamiento',
	  navSettings: 'Ajustes',
	  // AthleteSettings
	  settingsTitle: 'Configuración del Atleta',
	  backToDashboard: 'Volver al Dashboard',
	  tabProfile: 'PERFIL',
	  tabZones: 'ZONAS',
	  tabImages: 'IMÁGENES',
	  tabSecurity: 'SEGURIDAD',
	  backToSettings: 'Volver a Configuración del Atleta',
	  profileTabTitle: 'Perfil del Atleta',
	  goToProfile: 'Ir a Perfil',
	  zonesTabTitle: 'Zonas de Entrenamiento',
	  configureZones: 'Configurar Zonas',
	  imagesTabTitle: 'Cambio de Imagen',
	  changeImage: 'Cambiar Imagen',
	  // ZoneDistributionChart
	  zonesSummary: 'Resumen de Zonas',
	  zonesHR: '❤️ Zona de FC',
      zonesSwimPace: '🏊 Zona de Ritmo (SWIM)',
	  zonesPace: '🏃‍ Zona de Ritmo',
	  zonesTimeHR: '🕒 Tiempo por zona de FC',
	  zonesTimePace: '🏃‍ Tiempo por zona de Ritmo',
	  zonesLoadingError: 'No se pudo cargar la distribución de zonas.',
	  zonesLoading: 'Cargando distribución de zonas...',
	  // ZoneDistributionChartCycling
	  zonesCyclingSummary: 'Resumen de Zonas de Ciclismo',
	  zonesCyclingPower: '🚴‍ Zona de Potencia',
	  zonesCyclingTimePower: '🕒 Tiempo por zona de Potencia',
	  zonesCyclingLoadingError: 'No se pudo cargar la distribución de zonas de ciclismo.',
	  zonesCyclingLoading: 'Cargando distribución de zonas de ciclismo...',
	  zonesCyclingNoData: 'No hay datos de zonas de ciclismo disponibles.',
	  // ActivityModal
	  addActivity: 'Agregar actividad',
	  activityName: 'Nombre:',
	  activityDate: 'Fecha:',
	  activityDescription: 'Descripción:',
	  // ActivityList
	  noActivities: 'No hay actividades disponibles.',
	  errors: {
		missingAthleteId: 'No se puede guardar la actividad: falta el ID del atleta',
		saveErrorTitle: 'Error al guardar',
		saveError: 'No se pudo guardar la actividad',
		moveError: 'No se pudo mover la actividad'
	  }
	},

    athleteAdmin: {
      title: 'Administración de Atletas',
      backToDashboard: '← Volver al dashboard',
      inviteNewAthlete: 'Invitar nuevo atleta',
      emailPlaceholder: 'Correo electrónico del atleta',
      sendInvite: 'Enviar invitación',
      name: 'Nombre',
      email: 'Email',
      status: 'Estado',
      actions: 'Acciones',
      active: 'activo',
      unblock: 'Desbloquear',
      block: 'Bloquear',
      delete: 'Eliminar',
      missingData: 'Faltan datos para enviar la invitación',
      inviteSuccess: '✅ Invitación enviada correctamente',
      inviteError: '❌ Error al enviar la invitación',
      confirmDelete: '¿Estás seguro de que deseas eliminar este atleta?',
      changeStatusError: 'No se pudo cambiar el estado del atleta.'
    },

	athleteProfile: {
	  loading: 'Cargando perfil...',
	  profileAlt: 'Perfil',
	  personalInfo: 'Foto y Datos Personales',
	  viewingProfileOf: 'Viendo perfil de',
	  name: 'Nombre',
	  lastName: 'Apellido',
	  email: 'Correo',
	  username: 'Usuario',
	  physicalInfo: 'Información Física',
	  gender: 'Sexo',
	  genderOptions: { male: 'Masculino', female: 'Femenino', other: 'Otro' },
	  birthDate: 'Fecha de nacimiento',
	  age: 'Edad',
	  weight: 'Peso (kg)',
	  height: 'Altura (cm)',
	  locationClub: 'Ubicación y Club',
	  country: 'País',
	  city: 'Ciudad',
	  club: 'Club',
	  coach: 'Entrenador',
	  disciplines: 'Disciplinas',
	  disciplinesLabels: {
		trail: 'Trail',
		running: 'Running',
		cycling: 'Ciclismo',
		swimming: 'Natación',
		triathlon: 'Triatlón'
	  },
	  notAvailable: 'No disponible',
	  notSpecified: 'No especificado',
	  notRegistered: 'No registrado',
	  trainingZones: 'Zonas de Entrenamiento',
	  heartRate: 'Frecuencia Cardíaca',
	  pace: 'Paso',
	  power: 'Potencia',
	  swimmingCss: 'Natación (CSS)',
	  zone: 'Zona',
	  min: 'Min',
	  max: 'Max',
	  thresholdHeartRate: 'Threshold Heart Rate',
	  thresholdSpeed: 'Threshold Speed',
	  thresholdPower: 'Threshold Power',
	  threshold: 'Threshold',
	  saveChanges: 'Guardar Cambios',
	  editProfile: 'Editar Perfil',
	  backToDashboard: 'Volver al Dashboard',
	  messages: {
		userIdNotFound: 'Error: ID de usuario no encontrado.',
		invalidBirthDate: '❌ Debes ingresar una fecha de nacimiento válida.',
		genderRequired: 'Error: El campo de género es obligatorio.',
		profileSaved: '✅ Perfil guardado exitosamente.',
		imageUpdated: '✅ Imagen actualizada.',
		imageUploadError: '❌ Error al subir la imagen.',
		onlyJpgPng: '❌ Solo se permiten imágenes JPG o PNG.',
		loadError: '❌ Error al cargar el perfil. Intenta nuevamente.',
		saveError: 'Error al guardar el perfil. Intenta nuevamente.',
		imageTooLarge: '❌ La imagen no debe exceder 2MB.'
	  }
	},

    calendar: {
      title: 'Calendario del Atleta',
      selectSport: 'Selecciona el deporte',
      selectRequiredOption: 'Seleccione la opción requerida:',
      defineMetric: 'Define la métrica',
      planByMetric: 'Para {{sport}}, ¿quieres planificar por distancia o por duración?',
      distanceKm: 'Distancia (km)',
      duration: 'Duración',
      next: 'Siguiente',
      enterKmExample: 'Ej.: 10, 10.5, 21.1',
      enterKmPlaceholder: 'Ingresa km',
      enterDistanceGreaterThanZero: 'Ingresa una distancia mayor a 0',
      enterDurationExample: 'Ej.: 45 (min) o 0:45 o 01:30',
      enterDurationPlaceholder: 'Minutos o HH:MM',
      enterDurationGreaterThanZero: 'Ingresa una duración mayor a 0',
      copy: 'Copiar',
      paste: 'Pegar',
      delete: 'Eliminar',
      copied: 'Copiado',
      copiedText: 'Se copió "{{title}}".',
      pasted: 'Pegado',
      activityCreated: 'Actividad creada',
      activityMoved: 'Actividad movida',
      unknownError: 'Error desconocido',
      errorTitle: 'Error',
      missingAssignedAthlete: 'Falta el atleta destino (assignedTo).',
      couldNotCreateActivity: 'No se pudo crear la actividad.\n{{message}}',
      couldNotDeleteActivity: 'No se pudo eliminar la actividad.',
      couldNotMoveActivity: 'No se pudo mover la actividad.',
      pasteActivityTitle: '¿Pegar actividad?',
      pasteActivityText: '¿Quieres pegar "{{title}}" en esta fecha?',
      yesPaste: 'Sí, pegar',
      deleteActivityText: 'Esta acción eliminará la actividad "{{title}}".',
      yesDelete: 'Sí, eliminar',
      pasteCopiedActivityOn: '¿Pegar actividad copiada en<br><b>{{date}}</b>?',
      completedActivityWithFit: 'Actividad completada con archivo FIT ✅',
      pendingActivity: 'Actividad pendiente',
      completedAria: 'completado'
    },

	activityLabels: {
	  running: 'Correr',
	  cycling: 'Ciclismo',
	  swimming: 'Nadar',
	  rest: 'Día de descanso',
	  strength: 'Fuerza',
	  walking: 'Caminar',
	  other: 'Otro',
	  competition: 'Competencia',
	  lab: {
	    tabs: { dashboard: 'Dashboard', calendar: 'Calendario', profile: 'Perfil', pmc: 'PMC', zones: 'Zonas HR', wellness: 'Wellness', ia: 'IA', banister: 'Banister', competitions: 'Competencia' },
	    currentState: 'Estado Actual · Temporada',
	    fitness: 'CTL (Fitness)',
	    fatigue: 'ATL (Fatiga)',
	    form: 'TSB (Forma)',
	    tssTotal: 'TSS Total',
	    formPositive: 'Forma positiva — apto para competencia',
	    formNeutral: 'Forma neutral',
	    formFatigue: 'Fatiga alta — recuperación recomendada',
	    weeklyTss: 'TSS semanal últimas 8 semanas',
	    seasonSummary: 'Resumen temporada',
	    kmRun: 'km corridos',
	    kmBike: 'km en bici',
	    mSwim: 'm nadados',
	    hoursRun: 'Horas running',
	    hoursBike: 'Horas bici',
	    hoursSwim: 'Horas natación',
	    hoursStrength: 'Horas fuerza',
	    pmcTitle: 'Performance Management Chart — últimas 8 semanas',
	    pmcInterpretation: 'Interpretación PMC',
	    ctlCurrent: 'CTL actual',
	    atlCurrent: 'ATL actual',
	    tsbCurrent: 'TSB actual',
	    hrDistribution: 'Distribución HR — Temporada completa',
	    hrAvgBySport: 'FC promedio por disciplina',
	    hrChart: 'Distribución en gráfico',
	    monitorForm: 'Monitorear forma.',
	    positiveForm: 'Forma positiva.',
	    wellnessTitle: 'Registro Wellness',
	    today: 'Hoy',
	    sleepQuality: 'Calidad de sueño',
	    energy: 'Energía',
	    muscleTension: 'Tensión muscular',
	    mentalState: 'Estado mental',
	    restHR: 'FC reposo',
	    perceivedStress: 'Estrés percibido',
	    wellnessScore: 'Score Wellness',
	    moderate: 'Moderado — monitorear',
	    banisterTitle: 'Modelo Banister — Fitness-Fatiga',
	    ctlFitness: 'CTL Fitness',
	    atlFatigue: 'ATL Fatiga',
	    tsbForm: 'TSB Forma',
	    competitionsTitle: 'Competencias agendadas',
	    noCompetitions: 'No hay competencias agendadas',
	    compDate: 'Fecha', compEvent: 'Evento', compSport: 'Deporte', compDistance: 'Distancia', compPriority: 'Prioridad', compCity: 'Ciudad', compTarget: 'Objetivo',
	    iaTitle: 'Análisis IA · Primer Umbral LAB',
	    iaBasedOn: 'Análisis basado en datos actuales.',
	    iaForm: 'Forma:',
	    coachReport: 'Reporte para el coach',
	    generateReport: 'Generar análisis',
	    reportPlaceholder: 'Presiona "Generar análisis" para obtener un reporte interpretativo basado en los datos del atleta.',
	    askIA: 'Preguntarle a la IA',
	    noPmcData: 'Sin datos PMC suficientes. Importa actividades y recalcula el PMC.',
	    noBanisterData: 'Sin datos suficientes para el modelo Banister. Importa actividades y recalcula el PMC.',
	    generating: 'Generando...',
	  },
	  training: 'Entrenamiento',
	  untitled: 'sin título',
	  untitledActivity: 'actividad sin título',
	},
	activitySelector: {
	  selectActivityType: 'Selecciona un tipo de actividad'
	},

    groupsPanel: {
      groups: 'Grupos',
      newGroup: '+ Nuevo grupo',
      detailEdit: 'Detalle y edición',
      name: 'Nombre',
      sport: 'Deporte',
      description: 'Descripción',
      optional: '(opcional)',
      members: 'Miembros',
      loadingGroups: 'Cargando grupos…',
      noGroups: 'No hay grupos. Crea uno con "+ Nuevo grupo".',
      newUnsaved: 'Nuevo grupo (sin guardar)',
      addAthletesPlaceholder: 'Añadir atletas…',
      dropHint: 'También puedes arrastrar atletas aquí para agregarlos.',
      saving: 'Guardando…',
      savedChanges: 'Cambios guardados ✓',
      noResults: 'Sin resultados',
      viewAll: 'Ver todos ({{count}})',
      addAll: 'Agregar todos',
      removeAll: 'Quitar todos',
      noAthletes: 'No se encontraron atletas para este entrenador.',
      noChanges: 'Sin cambios',
      confirmDelete: '¿Eliminar este grupo? Esta acción no se puede deshacer.',
      triathlon: 'Triatlón',
      applyPlan: 'Aplicar plan…',
      hideList: 'Ocultar lista',
      all: 'Todos',
      run: 'Correr',
      cycling: 'Ciclismo',
      swim: 'Nadar',
      strength: 'Fuerza',
      other: 'Otro',
      defaultGroup: 'Grupo',
      errorLoadingGroups: 'No se pudieron cargar los grupos.',
      athlete: 'Atleta',
      athletesShort: 'at.',
      localGroupCreated: '⚠️ No hay endpoint de creación. Se creó un grupo local (No guardado). Pulsa "Guardar" cuando el backend esté listo.',
      saveError: '❌ No se pudo guardar. Verifica los endpoints de creación/actualización.',
      deleteError: '❌ No se pudo eliminar el grupo (no hay endpoint disponible).',
      localGroupWarningPrefix: 'Este grupo es local (no guardado en el servidor). Pulsa',
      localGroupWarningSuffix: 'cuando el backend esté listo.',
      groupNamePlaceholder: 'Nombre del grupo',
      descriptionPlaceholder: 'Notas, objetivos del grupo, reglas, etc.',
      remove: 'Quitar',
      member: 'Miembro',
      addAtLeastOneAthlete: 'Agrega al menos un atleta al grupo para aplicar un plan.',
      saveAsNew: 'Guardar como nuevo',
      appliedToAthletes: 'Aplicado a {{okCount}}/{{total}} atletas.',
      couldNotApplyTemplate: 'No se pudo aplicar la plantilla.',
      viewDetails: 'Ver detalles'
    },
	
	inviteAthlete: {
	  title: "Invitar atleta",
	  placeholder: "Correo electrónico del atleta",
	  send: "Enviar invitación",
	  errorTitle: "Error",
	  successTitle: "Éxito",
	  invalidEmail: "Por favor ingresa un correo electrónico válido.",
	  successMessage: "Invitación enviada con éxito.",
	  errorMessage: "Ocurrió un error al enviar la invitación."
	},

    trainerTemplates: {
      library: 'Librería de Planillas',
      openManager: 'Abrir gestor',
      searchTemplate: 'Buscar planilla…',
      noResults: 'Sin resultados.',
      viewActivitiesDays: 'Ver actividades / días',
      noCategory: '(sin categoría)',
      oneDay: '1 día',
      multipleDays: '{{count}} días',
      noPlanning: 'sin planificación',
      edit: 'EDITAR',
      configure: 'CONFIGURAR',
      applyTemplate: 'Aplicar…',
      loadingActivities: 'Cargando actividades…',
      templateWithoutPlanning: 'Esta plantilla no trae planificación. Usa “CONFIGURAR” o impórtala desde Excel.',
      day: 'Día',
      dragToCalendar: 'Arrastra al calendario',
      untitled: '(sin título)',
      applyTemplateTitle: 'Aplicar plantilla',
      template: 'Plantilla',
      startDate: 'Fecha de inicio',
      destination: 'Destino',
      currentAthlete: 'Atleta actual',
      selectAthlete: 'selecciona un atleta',
      group: 'Grupo',
      noGroupsOption: '(no hay grupos)',
      applying: 'Aplicando…',
      apply: 'Aplicar',
      selectStartDate: 'Selecciona una fecha de inicio.',
      selectAthleteOrGroup: 'Selecciona un atleta o elige "Grupo".',
      chooseGroup: 'Elige un grupo.',
      groupHasNoMembers: 'Ese grupo no tiene miembros.',
      templateAppliedToAthletes: '✅ Planilla aplicada a {{count}} atleta(s).',
      backendApplyMissing: '⚠️ El backend no tiene /cycles/apply-template aún. El payload ya se envió a consola.',
      backendApplyEndpointMissing: '⚠️ Falta el endpoint /cycles/apply-template en el backend. El payload ya se genera bien.',
      errorApplyingTemplate: '❌ Error aplicando planilla. {{message}}',
      metricDuration: 'Duración (min)',
      metricDistance: 'Distancia (km)',
      metricElevation: 'Desnivel (m)',
      metricTss: 'TSS'
    },

    trainerLibrary: {
      title: 'Librería de actividades',
      useIAWeek: 'Usar IA (semana)',
      baseAerobic: 'Base aeróbica',
      thresholds: 'Umbrales',
      noTemplates: 'No hay plantillas',
      local: 'local',
      add: 'Agregar',
      selectAthlete: 'Selecciona un atleta.',
      activityAddedBackend: '✅ Actividad agregada al calendario (backend/IA)',
      activityCreatedLocal: '✅ Actividad creada desde plantilla local',
      weeklyPlanApplied: '🤖✅ Plan IA semanal aplicado'
    },
	
	trainingLibraryPanel: {
	  mini: 'Mini',
	  compact: 'Compacto',
	  showLibrary: 'Mostrar librería',
	  hideLibrary: 'Ocultar librería',
	  libraryShort: 'Librería',
	  easyRun: 'Rodaje fácil',
	  z2Easy: 'Z2 suave',
	  threshold: 'Umbral',
	  thresholdBlocks: 'Bloques a umbral',
	  strength: 'Fuerza',
	  fullBody: 'Cuerpo completo',
	  localTemplate: 'Plantilla local',
	  untitled: 'Sin nombre',
	  days: 'días',
	  daysShort: 'd',
	  hideDetail: 'Ocultar detalle',
	  viewDetail: 'Ver detalle',
	  loadingDetail: 'Cargando detalle…',
	  hide: 'Ocultar'
	},
	
	trainingPlans: {
	  filters: 'Filtros',
	  filtersAll: 'Todos',
	  sport: 'Deporte',
	  distanceType: 'Distancia/Tipo',
	  level: 'Nivel',
	  search: 'Búsqueda',
	  searchPlaceholder: 'Nombre, notas...',
	  title: 'Planes de Entrenamiento',
	  empty: 'No hay plantillas con esos filtros.',
	  untitled: 'Sin nombre',
	  weeksShort: 'sem',
	  sportLabel: 'Deporte',
	  distanceLabel: 'Distancia',
	  phase: 'Fase',
	  preview: 'Preview',
	  apply: 'Aplicar',
	  selectTemplateForPreview: 'Selecciona una plantilla para ver el detalle.',
	  triathlon: 'Triatlón',
	  levelNovice: 'Novato',
	  levelIntermediate: 'Intermedio',
	  levelAdvanced: 'Avanzado',
	  distanceAll: 'Todas',
	  ultra50k: 'Ultra 50K',
	  ultra7080k: 'Ultra 70–80K',
	  ultra90120k: 'Ultra 90–120K',
	  ultra160k: 'Ultra 160K',
	  sprint: 'Sprint',
	  olympic: 'Olímpico',
	  middle703: 'Medio (70.3)',
	  ironman1406: 'Ironman (140.6)'
	},
	
	trainerLibraryManager: {
	  title: 'Librería de Entrenamientos',
	  back: 'Volver',
	  backToDashboardTitle: 'Volver al Dashboard del Entrenador (Esc)',
	  filters: 'Filtros',
	  scope: 'Alcance',
	  scopeMine: 'Mis plantillas',
	  scopeClub: 'Del club',
	  scopeAll: 'Todas',
	  sport: 'Deporte',
	  tag: 'Tag',
	  tagBase: 'Base',
	  tagThreshold: 'Umbrales',
	  tagVo2: 'VO2 max',
	  search: 'Buscar',
	  searchPlaceholder: 'Nombre o descripción… ( / para enfocar )',
	  limit: 'Límite',
	  applying: 'Aplicando…',
	  applyFilters: 'Aplicar filtros',
	  editTemplate: 'Editar plantilla',
	  newTemplate: 'Nueva plantilla',
	  name: 'Nombre',
	  intensityText: 'Intensidad (texto)',
	  durationMin: 'Duración (min)',
	  distanceKm: 'Distancia (Km)',
	  tss: 'TSS',
	  description: 'Descripción',
	  descriptionPlaceholder: 'Escribe la pauta del entrenamiento…',
	  update: 'Actualizar',
	  templates: 'Plantillas',
	  of: 'de',
	  previous: 'Anterior',
	  next: 'Siguiente',
	  noTemplatesForFilters: 'No hay plantillas para los filtros actuales.',
	  edit: 'Editar',
	  duplicate: 'Duplicar',
	  disable: 'Desactivar',
	  updatedShort: 'act.',
	  page: 'Página',
	  template: 'Plantilla',
	  copy: 'copia',
	  templateNameRequired: 'Ponle un nombre a la plantilla',
	  templateUpdated: '✅ Plantilla actualizada',
	  templateCreated: '✅ Plantilla creada',
	  templateSaveError: 'No se pudo guardar la plantilla',
	  confirmDisableTemplate: '¿Desactivar esta plantilla?',
	  templateDisabled: '🗑️ Plantilla desactivada',
	  templateDisableError: 'No se pudo desactivar'
	},
	
	trainerProfile: {
	  loading: 'Cargando perfil...',
	  photos: 'Fotos',
	  profilePhoto: 'Foto de perfil',
	  profilePhotoAlt: 'Foto de perfil del entrenador',
	  clubPhoto: 'Foto del club',
	  clubPhotoAlt: 'Foto del club',
	  generalInfo: 'Información general',
	  username: 'Nombre de usuario',
	  email: 'Correo electrónico',
	  club: 'Club',
	  trainer: 'Entrenador',
	  firstName: 'Nombre',
	  lastName: 'Apellido',
	  gender: 'Género',
	  country: 'País',
	  city: 'Ciudad',
	  disciplines: 'Disciplinas',
	  changePassword: 'Cambiar contraseña',
	  currentPasswordPlaceholder: 'Contraseña actual',
	  newPasswordPlaceholder: 'Nueva contraseña',
	  update: 'Actualizar',
	  saveChanges: 'Guardar cambios',
	  editProfile: 'Editar perfil',
	  backToDashboard: 'Volver al Dashboard',
	  select: 'Selecciona una opción',
	  notSpecified: 'No especificado',
	  genderOptions: {
		male: 'Masculino',
		female: 'Femenino',
		other: 'Otro'
	  },
	  disciplinesLabels: {
		trail: 'Trail',
		running: 'Running',
		cycling: 'Ciclismo',
		swimming: 'Natación',
		triathlon: 'Triatlón'
	  },
	  messages: {
		userIdNotFound: 'Error: ID de usuario no encontrado.',
		loadError: 'No se pudo cargar el perfil del entrenador.',
		profilePhotoUpdated: '✅ Foto de perfil actualizada.',
		clubPhotoUpdated: '✅ Foto del club actualizada.',
		profilePhotoUploadError: '❌ Error al subir la foto de perfil.',
		clubPhotoUploadError: '❌ Error al subir la foto del club.',
		profileSaved: '✅ Perfil guardado exitosamente.',
		saveError: '❌ Error al guardar el perfil.',
		passwordFieldsRequired: 'Debes completar ambos campos de contraseña.',
		passwordMismatch: 'Las contraseñas no coinciden.',
		passwordUpdated: '✅ Contraseña actualizada exitosamente.',
		passwordUpdateError: '❌ Error al actualizar la contraseña.'
	  },
	  disciplineOptions: {
		Trail: 'Trail',
		Running: 'Running',
		Ciclismo: 'Ciclismo',
		Natación: 'Natación',
		Triatlón: 'Triatlón'
	  }
	},
  	
	
	cycleTemplatesPanel: {
	  title: 'Gestión de Plantillas de Planes',
	  downloadTemplate: 'Descargar plantilla + guía',
	  downloadTemplateTitle: 'Descarga la planilla vacía con guía y ejemplos',
	  importExcel: 'Importar Excel',
	  backToDashboard: 'Volver al Dashboard',
	  createTemplate: 'Crear nueva plantilla',
	  editTemplate: 'Editar plantilla',
	  planName: 'Nombre del plan',
	  distanceCategory: 'Distancia / categoría (10K, 21K, 42K, 70.3…)',
	  totalDays: 'Días totales',
	  notes: 'Notas / objetivo del bloque (opcional)',
	  activities: 'Actividades de la plantilla',
	  totalActivities: 'Total actividades',
	  noPlanningYet: 'Esta plantilla no tiene planificación aún. Agrega actividades manualmente o importa un Excel.',
	  day: 'Día',
	  sport: 'Deporte',
	  activityTitle: 'Título / Tarea',
	  metric: 'Métrica planificada',
	  value: 'Valor',
	  valuePlaceholder: 'min / km / m / pts',
	  description: 'Descripción',
	  activityTitlePlaceholder: 'Ej. Rodaje suave, Series 6x1000, Fuerza tren inferior…',
	  activityDescriptionPlaceholder: 'Descripción detallada de la sesión',
	  addActivity: 'Añadir actividad',
	  saveActivity: 'Guardar',
	  validationDuration: 'Duracion debe ser hh:mm:ss (ej. 01:30:00).',
	  validationDistance: 'Distancia debe ser un numero en km (ej. 13 o 13.5).',
	  createButton: 'Crear plantilla',
	  saveChanges: 'Guardar cambios',
	  cancelEdit: 'Cancelar edición',
	  loading: 'Cargando…',
	  loadingShort: 'Cargando...',
	  noTemplatesYet: 'No hay plantillas todavía.',
	  copy: 'Copiar',
	  move: 'Mover',
	  selectActivityType: 'Selecciona un tipo de actividad',
	  serverPlanMissing:
		'El servidor no devuelve la planificación de esta plantilla. Si la creaste desde este navegador, se guardó una copia local; de lo contrario, importa un Excel para reconstruirla.',
	  confirmDeleteTemplate: '¿Eliminar plantilla?',
	  alerts: {
		activityTitleRequired: 'Debes indicar un título/tarea.',
		activityDescriptionRequired: 'La descripción es obligatoria.',
		activityValueRequired: 'Debes indicar un valor planificado.',
		completeTitleDescriptionValue: 'Completa título, descripción y valor.',
		excelNoRows: 'El Excel no contiene filas.',
		importedActivities: 'Importadas {{count}} actividades en {{days}} días.',
		excelReadError: 'No pude leer el Excel. Revisa el archivo.',
		planNameRequired: 'Debes indicar el nombre del plan.',
		addAtLeastOneActivityToTemplate: 'Añade al menos una actividad a la plantilla.',
		addAtLeastOneActivity: 'Añade al menos una actividad.',
		templateCreated: 'Plantilla creada con planificación.',
		templateUpdated: 'Plantilla actualizada.',
		updateError: 'No se pudo actualizar la plantilla.',
		editLoadError: 'No pude cargar la plantilla para editar.',
		deleteError: 'No pude eliminar la plantilla.',
		copyPending: 'Copiar pendiente',
		movePending: 'Mover pendiente'
	  },
	  errors: {
		loadingTemplates: 'Error cargando plantillas',
		createTemplate: 'No se pudo crear la plantilla',
		unauthenticatedReload: 'No autenticado (401). Re-login y vuelve a cargar esta pantalla.',
		unauthenticatedCreate: 'No autenticado (401). Re-login y vuelve a intentar crear.',
		unauthenticatedEdit: 'No autenticado (401). Re-login y vuelve a intentar editar.',
		unauthenticatedSave: 'No autenticado (401). Re-login y vuelve a intentar guardar cambios.',
		unauthenticatedDelete: 'No autenticado (401). Re-login y vuelve a intentar eliminar.'
	  }
	},
	
	trainerEmailPanel: {
	  title: "Notificaciones por correo",
	  subtitle: "Configura cuándo y a quién se envían tus correos (digest / semanal / al crear).",
	  sendMode: "Modo de envío",
	  rollingDays: "Días rodantes",
	  onlyTheseWeekdays: "Sólo estos días de la semana",
	  hour: "Hora",
	  minute: "Minuto",
	  protectionWindow: "Ventana de protección (min)",
	  digestCreateHint: "“Al crear/actualizar” envía casi al momento, pero sólo si está fuera de la ventana de protección.",
	  digestDailyHint: "“Digest diario” manda hoy y los 2 siguientes (si existen).",
	  protectionExample: "Ejemplo: si el digest está programado a las 07:00 y tú cambias una sesión a las 06:40, no gatilla un correo extra. Si la cambias a las 07:20, sí gatilla uno.",
	  sendTo: "Enviar a",
	  targets: {
		all: "Todos mis atletas",
		groups: "Sólo estos grupos",
		athletes: "Sólo estos atletas"
	  },
	  noGroups: "No hay grupos disponibles para este entrenador.",
	  noAthletes: "No hay atletas asignados a este entrenador.",
	  options: {
		digest3d: "Digest diario de 3 días (como TP)",
		digest1d: "Digest diario (1 día)",
		weekly: "Resumen semanal",
		onCreate: "Enviar al crear / actualizar"
	  },
	  onComplete: {
		title: "Correo al completar el entrenamiento",
		enabled: "Enviar correo de resultados cuando el atleta marque completado"
	  },
	  metrics: {
		duration: "Duración",
		distance: "Distancia",
		calories: "Calorías",
		pace: "Ritmo medio",
		hr: "FC media"
	  },
	  warnings: {
		defaultPrefs: "No se pudieron cargar las preferencias (usando valores por defecto)."
	  },
	  success: {
		saved: "✅ Preferencias guardadas.",
		testSent: "✓ Correo de prueba enviado correctamente."
	  },
	  errors: {
		noTrainerInSession: "No hay trainerId en sesión.",
		saveNoEndpoint: "⚠️ No se pudo guardar en ningún endpoint. Revisa que exista la ruta en el backend.",
		saveGeneric: "❌ Error al guardar las preferencias.",
		testSendFailed: "⚠️ No se pudo enviar la prueba. Revisa el backend."
	  },
	  sending: "Enviando..."
	},
	
	weekSelector: {
	  week: 'Semana',
	groupApplyPlan: {
		title: 'Aplicar plan al grupo',
		searchPlan: 'Buscar plan…',
		templatePlan: 'Plantilla / Plan',
		startDate: 'Fecha de inicio',
		overwrite: 'Sobrescribir si existe',
		applyToGroup: 'Aplicar al grupo',
		loading: 'Cargando…',
		noResults: 'Sin resultados',
		successSummary: '✅ Plan aplicado correctamente a {{athletes}} atleta(s). Actividades creadas/actualizadas: {{createdOrUpdated}}{{skipped}}',
		skipped: 'omitidas',
		noMembers: 'Este grupo no tiene miembros.',
		generalError: 'No se pudo aplicar la plantilla.',
		haveIdQuestion: '¿Tienes un ID?',
		enterManually: 'Ingresar manualmente',
		backToList: 'Volver a la lista',
		idPlaceholder: 'ID de plantilla / plan',
		includeLibrary: 'Incluir biblioteca pública',
		selected: 'Seleccionado',
		session: 'Sesión'
	},
	  selectDate: 'Selecciona una fecha (ancla de semana)',
	  today: 'Hoy',
	  prev: 'ANT.',
	  next: 'SIG.'
	},
	
	activitySummary: {
	  loading: 'Cargando...',
	  noData: 'No se encontraron datos',
	  loadError: 'Hubo un error al cargar los datos',
	  title: 'Resumen de la Actividad',
	  routeMap: 'Mapa de la Ruta',
      charts: 'Gráfico Consolidado de Actividad',
	  altimetry: 'Resumen de Altimetría',
	  elevationGain: 'Ganancia de elevación',
	  zones: 'Distribución por Zonas',
	  trainingEffects: 'Efectos del Entrenamiento',
	  laps: 'Detalles por Vueltas',
	  indicator: 'Indicador',
	  value: 'Valor',
	  interpretation: 'Interpretación',
	  notAvailable: 'No disponible',
	  vo2max: 'VO₂ máx',
	  vo2Description: 'Estimación basada en distancia y duración.'
	},

	pmcPane: {
	  title: 'Modelo de Banister – CTL / ATL / TSB',
	  range: 'Rango',
	  rangeDaysAriaLabel: 'Rango días',
	  whatIf: 'What-if (proyección)',
	  days: 'Días',
	  totalTss: 'TSS total (próximos días)',
	  pattern: 'Patrón',
	  patternEven: 'Uniforme',
	  patternPolarized: 'Polarizado (picos marcados)',
	  todayTsb: 'Hoy TSB',
	  ctlToday: 'CTL hoy',
	  whatIfLabel: 'What-if',
	  whatIfDisabled: 'Desactivado',
	  whatIfProjection: 'TSB proyectado en {{days}}d: {{tsb}} (TSS {{tss}}, patrón {{pattern}})',
	  whatIfHint: 'Usa la proyección para ajustar volumen/intensidad.',
	  loading: 'Cargando…',
	  noData: 'Sin datos en el rango seleccionado.',
	  chartAriaLabel: 'Gráfico de CTL, ATL (eje izq.) y TSB (eje der., con bandas) – amCharts 5',
	  chartAriaLabelAmCharts: 'Gráfico de ATL/CTL (eje izq.) y TSB (eje der.) con fines de semana y proyección sombreados – amCharts 5',
	  chartFootnote: 'Eje izquierdo: CTL/ATL. Eje derecho: TSB con bandas de color (≤−20 riesgo, −20…−10 cansancio, −10…+10 óptimo, ≥+10 fresco). Líneas punteadas = proyección.',
	  chartFootnoteAmCharts: 'Eje izquierdo: CTL/ATL. Eje derecho: TSB con líneas guía ±10. Fondo miel = fines de semana. Fondo azul = proyección.',
	  seriesFitness: 'Fitness (CTL)',
	  seriesFatigue: 'Fatigue (ATL)',
	  seriesForm: 'Form (TSB)',
	  seriesCtlProj: 'CTL (proyección)',
	  seriesAtlProj: 'ATL (proyección)',
	  seriesTsbProj: 'TSB (proyección)',
	  seriesProjection: 'Proyección',
	  yLeftLabel: 'CTL / ATL',
	  yRightLabel: 'TSB',
	  tsb: {
	    highRiskLevel: 'Alto riesgo',
	    highRiskMsg: 'Fatiga elevada, reduce carga (descanso/rodaje suave).',
	    tiredLevel: 'Cansancio',
	    tiredMsg: 'Monitorea; mantén intensidad controlada.',
	    optimalLevel: 'Óptimo',
	    optimalMsg: 'Buen rango para sesiones clave.',
	    freshLevel: 'Fresh',
	    freshMsg: 'Fresco; puedes planificar carga intensa si el ciclo lo requiere.',
	  },
	  ramp: {
	    highLevel: 'Alto',
	    highMsg: 'Aumento de CTL > +8 en 7d (agresivo).',
	    moderateLevel: 'Moderado',
	    moderateMsg: 'Aumento de CTL moderado (+5 a +8).',
	    softLevel: 'Suave',
	    softMsg: 'Aumento suave de CTL.',
	    declineLevel: 'Bajando',
	    declineMsg: 'CTL descendiendo (posible taper/recuperación).',
	  },
	  diagButton: 'Diagnóstico IA',
	  diagAnalyzing: 'Analizando…',
	  diagButtonTitle: 'Analiza CTL/ATL/TSB y sugiere acciones',
	  diagMarkersLabel: 'Marcadores en gráfico',
	  diagTitle: 'Diagnóstico IA:',
	  diagSourceLLM: 'Modelo LLM',
	  diagSourceHeuristic: 'Heurística local',
	  diagFindings: 'Hallazgos',
	  diagSuggestions: 'Sugerencias',
	  diagLegendRisk: 'Riesgo',
	  diagLegendTired: 'Cansancio',
	  diagLegendFresh: 'Fresco',
	  diagErrorTimeout: 'La IA tardó demasiado; se mostró diagnóstico con heurística.',
	  diagErrorDemoMode: 'Modo demo: agrega una OPENAI_API_KEY válida en el backend para respuestas del modelo.',
	  diagErrorNoText: 'Sin texto de IA.',
	  diagError401: 'La clave de OpenAI no tiene permisos suficientes (401). Usa una API key con el scope adecuado.',
	  diagError429: 'Se superó la cuota de OpenAI (429). Revisa plan y facturación.',
	  diagErrorFrontTimeout: 'Tiempo de espera agotado en la llamada de IA (timeout).',
	  diagErrorGeneric: 'Error de diagnóstico',
	},

	activityDetails: {
	  // ActivityActions
	  copyNotImplemented: 'Función de Copiar actividad aún no implementada.',
	  movePrompt: 'Introduce la nueva fecha (YYYY-MM-DD):',
	  movedTo: 'Actividad movida a: {{date}}',
	  saving: 'Guardando...',
	  close: 'Cerrar',
	  // ActivityDetailsForm
	  titleLabel: 'Título',
	  untitled: 'Sin título',
	  descriptionLabel: 'Descripción',
	  descriptionPlaceholder: 'Introduce una descripción',
	  preComments: 'Comentarios pre-actividad',
	  postComments: 'Comentarios post-actividad',
	  // ActivityDuration
	  durationLabel: 'Duración',
	  // ActivityFileUpload / ActivityProfile
	  uploadFit: 'Subir Archivo FIT',
	  profileAlt: 'Perfil',
	  nameNotAvailable: 'Nombre no disponible',
	  dateNotSelected: 'Fecha no seleccionada',
	  // ActivityHeader
	  detailsOf: 'Detalles de la Actividad: {{title}}',
	  // ActivityMetricsTable
	  additionalMetrics: 'Métricas adicionales',
	  metricLabel: 'Métrica',
	  avgLabel: 'Avg',
	  maxLabel: 'Max',
	  unitLabel: 'Unidad',
	  avgPaceMetric: 'Ritmo Medio',
	  heartRateMetric: 'Ritmo Cardíaco',
	  cadenceMetric: 'Cadencia',
	  speedMetric: 'Velocidad',
	  vo2maxMetric: 'VO₂ máx estimado',
	  gapMetric: 'GAP (ritmo ajustado)',
	  gapAdjusted: 'GAP ajustado',
	  gapAdjustedFormula: 'Ritmo + GAP',
	  gapTitle: 'GAP (Grade Adjusted Pace)',
	  gapDescription: 'estima cómo sería tu ritmo en terreno plano. El GAP ajustado representa la suma de tu ritmo medio más ese ajuste estimado por altimetría.',
	  // ActivityPlannedCompletedTable
	  plannedVsCompleted: 'Planificado vs Completado',
	  plannedLabel: 'Planificado',
	  completedLabel: 'Completado',
	  durationField: 'Duración',
	  distanceField: 'Distancia',
	  avgPaceField: 'Ritmo medio',
	  caloriesField: 'Calorías',
	  elevationGainField: 'Desnivel positivo',
	  // RunningActivityModal
	  fitFileLoaded: 'Archivo .fit cargado',
	  noFitFile: 'Sin archivo .fit',
	  sportsTabsAriaLabel: 'Deportes',
	  // RunningActivityModal
	  loadingActivity: '⏳ Cargando actividad...',
	  activityModalTitle: 'Actividad: {{title}}',
	  // Validaciones
	  validationDescriptionRequired: 'La descripción es obligatoria.',
	  validationPlannedRequired: 'Debes completar al menos un campo en "Planificado".',
	  validationTitleRequired: 'El título es obligatorio.',
	  validationTypeRequired: 'El tipo de actividad es obligatorio.',
	  validationAthleteNotFound: 'No se ha encontrado el atleta (assignedTo).',
	},

	running: {
	  // RunningActivityModal
	  plannedVsCompleted: 'Planificado vs Completado (Correr)',
	},

	cycling: {
	  // CyclingMetricsTable & CyclingMetricsSummary
	  metricsTitle: 'Métricas de Ciclismo',
	  metric: 'Métrica',
	  value: 'Valor',
	  maxLabel: 'Máximo',
	  unit: 'Unidad',
	  speed: 'Velocidad',
	  cadence: 'Cadencia',
	  heartRate: 'Frecuencia Cardíaca',
	  temperature: 'Temperatura',
	  power: 'Potencia',
	  vo2max: 'VO₂ máx estimado',
	  normalizedPower: 'Potencia Normalizada (NP)',
	  ftp: 'FTP',
	  intensityFactor: 'Factor de Intensidad (IF)',
	  totalWork: 'Trabajo Total',
	  wkg: 'W/kg',
	  tss: 'Training Stress Score (TSS)',
	  lthr: 'Umbral FC (LTHR)',
	  maxHR: 'FC Máxima',
	  ftpZones: 'FTP (Zonas)',
	  avgSpeed: 'Velocidad Promedio',
	  maxSpeed: 'Velocidad Máxima',
	  avgCadence: 'Cadencia Promedio',
	  maxCadence: 'Cadencia Máxima',
	  avgHR: 'FC Promedio',
	  aerobicTE: 'TE Aeróbico',
	  anaerobicTE: 'TE Anaeróbico',
	  avgGap: 'GAP promedio',
	  // PlannedVsCompletedCycling
	  plannedVsCompleted: 'Planificado vs Completado (Ciclismo)',
	  planned: 'Planificado',
	  completed: 'Completado',
	  duration: 'Duración',
	  distance: 'Distancia',
	  avgPace: 'Ritmo medio',
	  calories: 'Calorías',
	  elevationGain: 'Desnivel positivo',
	  // CyclingSummary
	  summaryTitle: 'Resumen de Ciclismo',
	  // CyclingActivityModal
	  activityMetrics: 'Métricas de la Actividad',
	  activitySummary: 'Resumen de Actividad',
	  tssInterpretation: 'Interpretación TSS:',
	  geoMap: 'Mapa de Geolocalización',
	  elevationProfile: 'Perfil de Elevación',
	  powerChart: 'Gráfica de Potencia',
	  lapsDetail: 'Detalles por Vueltas',
	  zoneDistribution: 'Distribución por Zonas',
	  physiologicalAnalysis: 'Análisis Fisiológico',
	  validationTitle: 'El título es obligatorio.',
	  validationDescription: 'La descripción es obligatoria.',
	  validationPlanned: 'Completa al menos un campo en "Planificado".',
	  saveError: 'No se pudo guardar',
	  // CyclingSummary fields
	  date: 'Fecha:',
	  sport: 'Deporte:',
	  durationLabel: 'Duración:',
	  distanceLabel: 'Distancia:',
	  caloriesLabel: 'Calorías:',
	  ascentLabel: 'Ascenso:',
	  descentLabel: 'Descenso:',
	  tempAvg: 'Temp. Promedio:',
	  tempMax: 'Temp. Máxima:',
	  tssLabel: 'TSS:',
	  ftpLabel: 'FTP:',
	  thrLabel: 'THR:',
	  avgHRLabel: 'FC Promedio:',
	  maxHRLabel: 'FC Máxima:',
	  avgSpeedLabel: 'Vel. Promedio:',
	  maxSpeedLabel: 'Vel. Máxima:',
	  avgCadenceLabel: 'Cadencia Promedio:',
	  maxCadenceLabel: 'Cadencia Máxima:',
	  avgPowerLabel: 'Pot. Promedio:',
	  maxPowerLabel: 'Pot. Máxima:',
	  npLabel: 'NP:',
	  ifLabel: 'IF:',
	  vo2maxLabel: 'VO₂max:',
	  wkgLabel: 'W/kg:',
	},

	laps: {
	  // LapsTable (running)
	  dashboardTitle: 'Dashboard de Vueltas',
	  dashboardCyclingTitle: 'Dashboard de Vueltas - Ciclismo',
	  gapFormula: 'Fórmula GAP:',
	  total: 'Total',
	  lap: 'Vuelta',
	  duration: 'Duración',
	  accumulatedTime: 'Tiempo Acumulado',
	  distance: 'Distancia',
	  distanceKm: 'Distancia (km)',
	  avgPace: 'Ritmo Promedio',
	  maxPace: 'Ritmo Máximo',
	  avgGap: 'GAP Medio',
	  calories: 'Calorías',
	  ascent: 'Ascenso',
	  ascentM: 'Ascenso (m)',
	  descent: 'Descenso',
	  descentM: 'Descenso (m)',
	  avgHR: 'Frec. Cardiaca Promedio',
	  maxHR: 'Frec. Cardiaca Máxima',
	  avgHRShort: 'FC Promedio',
	  maxHRShort: 'FC Máxima',
	  avgSpeed: 'Velocidad Promedio',
	  maxSpeed: 'Velocidad Máxima',
	  avgSpeedKmh: 'Velocidad Promedio (km/h)',
	  maxSpeedKmh: 'Velocidad Máxima (km/h)',
	  avgSpeedShort: 'Vel. Prom. (km/h)',
	  maxSpeedShort: 'Vel. Máx (km/h)',
	  avgCadence: 'Cadencia Promedio',
	  avgCadenceShort: 'Cadencia Prom.',
	  avgTemp: 'Temp. Promedio',
	  maxTemp: 'Temp. Máxima',
	  avgTempShort: 'Temp. Prom.',
	  maxTempShort: 'Temp. Máx',
	  np: 'NP',
	  avgPower: 'Potencia Prom.',
	  maxPower: 'Potencia Máx',
	  wkg: 'W/kg',
	},

	swimming: {
		strokeExcellent: '🥇 Técnica excelente',
		strokeGood: '👍 Buena eficiencia',
		strokeAcceptable: '👌 Aceptable',
		strokeImprove: '⚠️ Puede mejorar',
	  metricsTitle: 'Métricas de Natación',
	  summaryTitle: 'Resumen de Natación',
	  plannedVsCompleted: 'Planificado vs Completado (Natación)',
	  lapsTitle: '🏊 Dashboard de Vueltas - Natación',
	  metric: 'Métrica',
	  planned: 'Planificado',
	  completed: 'Completado',
	  unit: 'Unidad',
	  avg: 'Avg',
	  max: 'Max',
	  speed: 'Velocidad',
	  cadence: 'Cadencia',
	  heartRate: 'Ritmo Cardíaco',
	  power: 'Potencia',
	  loading: 'Cargando...',
	  noData: 'No se encontraron datos',
	  loadError: 'Hubo un error al cargar los datos',
	  notAvailable: 'No disponible',
	  notCalculated: 'No calculado',
	  date: 'Fecha:',
	  sport: 'Deporte:',
	  totalTime: 'Tiempo total:',
	  movingTime: 'En movimiento:',
	  elapsedTime: 'Transcurrido:',
	  distance: 'Distancia:',
	  calories: 'Calorías:',
	  avgHR: 'FC Promedio:',
	  maxHR: 'FC Máxima:',
	  cadenceLabel: 'Cadencia:',
	  laps: 'Vueltas:',
	  lengths: 'Longitudes:',
	  poolLength: 'Largo piscina:',
	  tte: 'TTE:',
	  tea: 'TEA:',
	  tss: 'TSS:',
	  vo2max: 'VO₂max:',
	  avgPace: 'Ritmo medio:',
	  swolf: 'Swolf:',
	  totalStrokes: 'Brazadas Totales:',
	  strokesPer100m: 'Brazadas/100m:',
	  strokesPerMin: 'Velocidad de brazada:',
	  duration: 'Duración',
	  distanceM: 'Distancia (m)',
	  avgHRShort: 'FC Prom.',
	  maxHRShort: 'FC Max.',
	  avgSpeedKmh: 'Vel. Prom. (km/h)',
	  maxSpeedKmh: 'Vel. Máx (km/h)',
	  avgCadence: 'Cadencia',
	  strokes: 'Brazadas',
	  accumulatedTime: 'Tiempo Acumulado',
	  lap: 'Vuelta',
	  total: 'Total',
	  durationField: 'Duración',
	  distanceField: 'Distancia',
	  avgPaceField: 'Ritmo medio',
	  caloriesField: 'Calorías',

	  // SwimmingHeartRateHistogram
	  heartRateHistogramTitle: 'Histograma de Frecuencia Cardíaca (por Vuelta)',
	  heartRateAxisLabel: 'FC Promedio (bpm)',
	  heartRateSeries: 'FC Prom',
	  // SwimmingDashboard
	  dashboardTitle: 'Resumen del Entrenamiento de Natación',
	  paceLabel: 'Ritmo (s/100m)',
	  strokesLabel: 'Brazadas Totales',
	  hrLabel: 'FC Promedio',
	  distanceLabel: 'Distancia (m)',
	  swolfLabel: 'Swolf',
	  paceAxisLabel: 'Ritmo (s/100m)',
	  rightAxisLabel: 'Brazadas / FC / Distancia',
	  swolfAxisLabel: 'Swolf',
	  // SwimmingMetricsTable
	  sessionMetrics: 'Métricas de la Sesión',
	  avgSpeed: 'Velocidad Promedio',
	  maxSpeed: 'Velocidad Máxima',
	  avgCadenceLabel: 'Cadencia Promedio',
	  trainingEffect: 'Training Effect',
	  // SwimmingPhysiologicalAnalysis
	  physiologicalTitle: '📊 Análisis Fisiológico de la Natación',
	  physiologicalChartTitle: '📈 Visualización de Métricas Fisiológicas',
	  physioP1: 'Durante esta sesión, el atleta nadó {{distance}} metros en {{duration}}, logrando un ritmo promedio de {{pace}}.',
	  physioP2TTE: 'El Training Effect (TTE) fue de {{tte}}, lo cual indica {{ttInterp}}. Mientras que el Efecto Anaeróbico (TEA) alcanzó {{tea}}, sugiriendo {{teaInterp}}.',
	  physioP3TSS: 'El TSS fue de {{tss}}, lo que representa una carga de entrenamiento {{load}} en una sesión de {{duration}} minutos.',
	  physioLoadHigh: 'alta',
	  physioLoadModHigh: 'moderada-alta',
	  physioLoadMod: 'moderada o baja',
	  physioP4VO2: 'El VO₂ max estimado fue de {{vo2}} ml/kg/min{{msg}}, útil para evaluar la capacidad aeróbica. Además, el Swolf promedio fue de {{swolf}}, indicador de eficiencia técnica.',
	  physioP5HR: 'La frecuencia cardíaca promedio fue de {{avgHR}} bpm, alcanzando un máximo de {{maxHR}} bpm.',
	  validationTitle: 'El título es obligatorio.',
	  validationDescription: 'La descripción es obligatoria.',
	  validationPlanned: 'Completa al menos un campo en "Planificado".',
	  saveError: 'No se pudo guardar',
	  activityMetrics: 'Métricas de la Actividad',
	  activitySummary: 'Resumen de Actividad',
	  tssInterpretation: 'Interpretación TSS:',
	  lapsDetail: 'Detalles por Vueltas',
	  zoneDistribution: 'Distribución por Zonas',
	  physiologicalAnalysis: 'Análisis Fisiológico',
	},

	strength: {
		noHRZones: 'No se registraron datos de zonas de FC en esta sesión.',
	  metricsTitle: 'Métricas de Fuerza',
	  summaryTitle: 'Resumen de Fuerza',
	  plannedVsCompleted: 'Planificado vs Completado (Fuerza)',
	  lapsTitle: '💪 Dashboard de Vueltas - Fuerza',
	  metric: 'Métrica',
	  planned: 'Planificado',
	  completed: 'Completado',
	  unit: 'Unidad',
	  avg: 'Avg',
	  max: 'Max',
	  loading: 'Cargando...',
	  noData: 'No se encontraron datos',
	  loadError: 'Hubo un error al cargar los datos',
	  notAvailable: 'No disponible',
	  date: 'Fecha:',
	  sport: 'Deporte:',
	  totalTime: 'Tiempo total:',
	  movingTime: 'En movimiento:',
	  elapsedTime: 'Transcurrido:',
	  calories: 'Calorías:',
	  avgHR: 'FC Promedio:',
	  maxHR: 'FC Máxima:',
	  tempAvg: 'Temp Promedio:',
	  tempMax: 'Temp Máxima:',
	  totalCycles: 'Ciclos Totales:',
	  numLaps: 'Número de Laps:',
	  tte: 'TTE:',
	  tea: 'TEA:',
	  hrTss: 'hrTSS:',
	  ftp: 'FTP:',
	  maxHRTarget: 'FC Máxima Objetivo:',
	  thresholdHR: 'Umbral FC:',
	  duration: 'Duración',
	  repetitions: 'Repeticiones',
	  sets: 'Series',
	  caloriesField: 'Calorías',
	  te: 'TE',
	  lap: 'Vuelta',
	  total: 'Total',
	  distanceM: 'Distancia (m)',
	  avgHRShort: 'FC Prom.',
	  maxHRShort: 'FC Max.',
	  avgSpeedKmh: 'Vel. Prom. (km/h)',
	  maxSpeedKmh: 'Vel. Máx (km/h)',
	  avgCadence: 'Cadencia',
	  strokes: 'Brazadas',
	  accumulatedTime: 'Tiempo Acumulado',
	  validationTitle: 'El título es obligatorio.',
	  validationDescription: 'La descripción es obligatoria.',
	  validationPlanned: 'Completa al menos un campo en "Planificado".',
	  saveError: 'No se pudo guardar',
	  activityMetrics: 'Métricas de la Actividad',
	  activitySummary: 'Resumen de Actividad',
	  tssInterpretation: 'Interpretación TSS:',
	  lapsDetail: 'Detalles por Vueltas',
	  zoneDistribution: 'Distribución por Zonas',
	  physiologicalAnalysis: 'Análisis Fisiológico',
	},

	trainingZones: {
	  // Títulos de sección
	  thresholdValues: 'Valores Umbral',
	  thresholdHR: 'Threshold Speed',
	  thresholdPower: 'Threshold Power (CP)',
	  thresholdSwim: 'Critical Swim Speed (CSS)',
	  // Labels de inputs
	  thresholdHeartRate: 'Threshold Heart Rate',
	  maxHeartRate: 'Max Heart Rate',
	  restingHeartRate: 'Resting Heart Rate',
	  thresholdSpeed: 'Threshold Speed (mm:ss)',
	  ftpWatts: 'FTP (Watts)',
	  cssLabel: 'CSS (min/100m)',
	  ftpPlaceholder: 'Ej: 220',
	  cssPlaceholder: 'Ej: 1:45',
	  speedPlaceholder: 'mm:ss',
	  // Botones
	  calcFC: 'Calcular Frecuencia Cardíaca',
	  saveFC: 'Guardar Datos FC',
	  calcVP: 'Calcular Velocidad/Paso',
	  saveVP: 'Guardar Datos VP',
	  calcCP: 'Calcular Zonas de Potencia',
	  saveCP: 'Guardar Datos CP',
	  calcSWIM: 'Calcular Zonas de Natación',
	  saveSWIM: 'Guardar Datos de Natación',
	  backToDashboard: 'Volver al Dashboard',
	  // Tabla
	  colZone: 'Zona',
	  colMin: 'Min',
	  colMax: 'Max',
	  thresholdBpm: 'Threshold: {{value}} bpm',
	  thresholdMinKm: 'Threshold: {{value}} min/km',
	  thresholdWatts: 'Threshold: {{value}} watts',
	  thresholdMinPer100m: 'Threshold: {{value}} min/100m',
	  // Alertas validación
	  invalidUserId: 'Error: ID de usuario no válido',
	  noZonesFC: 'Por favor, calcula las zonas de FC antes de guardar.',
	  noZonesVP: 'Por favor, calcula las zonas de Velocidad/Paso antes de guardar.',
	  noZonesCP: 'Por favor, calcula las zonas de potencia antes de guardar.',
	  noZonesSWIM: 'Por favor, calcula las zonas de natación antes de guardar.',
	  invalidFtp: 'Por favor ingresa un valor de FTP válido.',
	  invalidCss: 'Por favor ingresa un tiempo válido en formato mm:ss',
	  // Mensajes éxito/error
	  savedFC: 'Datos de Frecuencia Cardíaca guardados exitosamente.',
	  savedVP: 'Datos de Velocidad/Paso guardados exitosamente.',
	  savedCP: 'Datos de Potencia guardados exitosamente.',
	  savedSWIM: 'Datos de Ritmo de Natación guardados exitosamente.',
	  saveError: 'Error al guardar los datos: {{message}}',
	  // Nombres de zonas FC
	  zoneFC: {
	    z1: 'Z1 Recuperación',
	    z2: 'Z2 Aeróbico',
	    z3: 'Z3 Tempo',
	    z4: 'Z4 Sub-Umbral',
	    z5a: 'Z5a Súper-Umbral',
	    z5b: 'Z5b Capacidad Aeróbica',
	    z5c: 'Z5c Capacidad anaeróbica',
	  },
	  // Nombres de zonas VP
	  zoneVP: {
	    z1: 'Z1 Recuperación',
	    z2: 'Z2 Aeróbico',
	    z3: 'Z3 Tempo',
	    z4: 'Z4 Sub-Umbral',
	    z5a: 'Z5a Súper-Umbral',
	    z5b: 'Z5b Capacidad Aeróbica',
	    z5c: 'Z5c Capacidad anaeróbica',
	  },
	  // Nombres de zonas CP
	  zoneCP: {
	    z1: 'Z1 Recuperación',
	    z2: 'Z2 Aeróbico',
	    z3: 'Z3 Tempo',
	    z4: 'Z4 Sub-Umbral',
	    z5: 'Z5 Límite Umbral',
	    z6: 'Z6 Capacidad Anaeróbica',
	    z7: 'Z7 Potencia Neuromuscular',
	  },
	  // Nombres de zonas SWIM
	  zoneSWIM: {
	    z1: 'Z1 Recuperación',
	    z2: 'Z2 Aeróbico',
	    z3: 'Z3 Tempo',
	    z4: 'Z4 Umbral',
	    z5: 'Z5 Velocidad',
	    z6: 'Z6 Anaeróbica',
	  },
	},

	elevationProfile: {
          axisPowerBpm: 'W / bpm',
          seriesAltitudePlain: 'Altitud (m)',
          seriesSpeed: 'Velocidad (KPH)',
          seriesPowerCycling: 'Potencia (W)',
          axisAltFcTemp: 'Altitud / FC / Temp',
          axisSpeedCadPower: 'Velocidad / Cadencia / Potencia',
          axisPower: 'Potencia (W)',
          axisLap: 'Vuelta',
          axisAltitude: 'Altitud (m)',
          axisCadence: 'Cadencia (rpm)',
          axisTemp: 'Temp (°C)',
          seriesAltitudeImproved: 'Altitud Mejorada (m)',
          seriesPaceAvg: 'Ritmo Prom. (min/km)',
          seriesCadence: 'Cadencia (rpm)',
          seriesTemp: 'Temperatura (°C)',
          altMax: 'Alt. Máx',
          altMin: 'Alt. Mín',
          hrLapSeriesLabel: 'FC promedio por vuelta',
          axisDistance: 'Distancia (km)',
          axisElevation: 'Elevación (m)',
          axisBpm: 'bpm',
          axisPaceMinKm: 'min/km',
          seriesElevation: 'Elevación (m)',
          seriesHr: 'FC (bpm)',
          seriesPaceReal: 'Ritmo real (min/km)',
          seriesGapAdjusted: 'Ritmo ajustado — GAP',
          consolidatedChartTitle: 'Gráfico Consolidado de Actividad',
          hrLapHistogramTitle: 'Histograma de Frecuencia Cardíaca (por Vuelta)',
          hrTimeChartTitle: 'Frecuencia Cardíaca (por Tiempo)',
	  loading: 'Cargando perfil altimetrico...',
	  loadingCycling: 'Cargando perfil altimetrico de ciclismo...',
	  title: 'Perfil Altimetrico',
	  titleCycling: 'Perfil Altimetrico de Ciclismo con Potencia',
	  totalDistance: 'Distancia Total:',
	  maxElevation: 'Elevacion Maxima:',
	  minElevation: 'Elevacion Minima:',
	  positiveSlope: 'Desnivel Positivo Acumulado:',
	  normalizedPower: 'Potencia Normalizada (NP):',
	  intensityFactor: 'Intensidad Relativa (IF):',
	},

	social: {
	  tzoneCommunity: 'Comunidad Tzone',
	  myCommunityProfile: 'Mi perfil en la Comunidad Tzone',
	  community: 'Comunidad',
	  myAthlete: 'Mi atleta',
	  backToCommunity: 'Volver a Comunidad',
	  backToCommunityHome: 'Volver al Home de Comunidad',
	  backToTzoneCommunity: 'Volver a Comunidad Tzone',
	  publishOnSocialMedia: 'Publicar en RRSS',
	  shareRoute: 'Compartir ruta (FIT)',
	  shareActivityFit: 'Compartir actividad (FIT)',
	  shareInChat: 'Compartir en el chat',
	  shareWithContact: 'Compartir con un contacto',
	  share: 'Compartir',
	  generating: 'Generando…',
	  shareSession: 'Compartir sesión',
	  sharePng: 'Compartir PNG (Web Share si existe)',
	  shareSelectedEvent: 'Compartir evento seleccionado',


	  loadingResumen: 'Cargando resumen...',
	  duracion: 'Duracion',
	  verDetalleDia: 'Ver detalle del dia',
	  diaDescanso: 'Dia de descanso',
	  sesionLabel: 'Sesion',
	  elvMas: 'ELV +',
	  comparteConContactos: 'Comparte una sesion con tus contactos match.',
	  compartirSesionTitle: 'Compartir sesion',
	  compartirSesionSteps: '1) Elige sesion - 2) Elige contacto - 3) Enviar',
	  sesionDelDia: 'Sesion del dia',
	  cargandoContactos: 'Cargando contactos...',
	  escribeMensaje: 'Escribe un mensaje...',
	  generaPng: 'Genera PNG (sin enviar)',
	  vistaPrevia: 'Vista previa (esto se captura)',
	  tzoneDomain: 'tzone.run',
	  generaCard: 'Genera la card 1080x1920 y compartela',
	  noSoportaCompartir: 'Tu navegador no soporta compartir archivos. Se descargo el PNG.',
	  noPudoCompartir: 'No se pudo compartir. Intenta Descargar PNG.',
	  seleccionaContacto: 'Selecciona un contacto primero.',
	  selectRequiredOption: 'Seleccione la opcion requerida:',
	  pasteActivityText: 'Pegar actividad copiada en',

	  descriptionRequired: 'La descripcion es obligatoria.',
	  indicateValue: 'Indica el valor planificado.',
	  durationFormat: 'Duracion debe ser hh:mm:ss (ej. 01:30:00).',
	  distanceFormat: 'Distancia debe ser un numero en kilometros (ej. 13 o 13.5).',
	  completeTitleDescriptionValue: 'Completa descripcion y valor.',
	  excelReadError: 'No pude leer el Excel. Revisa el archivo.',
	  planNameRequired: 'Indica el nombre del plan.',
	  totalDaysMustBePositive: 'Dias totales debe ser mayor a 0.',
	  addAtLeastOneActivity: 'Anade al menos una actividad.',
	  templateCreatedWithPlanning: 'Plantilla creada con planificacion.',
	  couldNotCreateTemplate: 'No se pudo crear la plantilla.',
	  activityTitlePlaceholder: 'Ej. Rodaje suave, Series 6x1000, Fuerza tren inferior...',
	  plannedMetric: 'Metrica planificada',
	  activityDescriptionPlaceholder: 'Descripcion detallada de la sesion',
	  supportsValueRight: 'Soporta valor a la derecha de Planificado.',
	  planWizard: {
	    step1: '1. Objetivo',
	    step2: '2. Anclaje y Disponibilidad',
	    step3: '3. Parametros',
	    step4: '4. Previsualizacion',
	    includesBricks: 'Incluye bricks y distribucion por disciplina.',
	    wednesday: 'Miercoles',
	    saturday: 'Sabado',
	    elevPlaceholder: 'ej. 1200',
	    elevGoal: 'm+ objetivo',
	  },
	  importExcel: {
	    title: 'Guia de Importacion Excel',
	    sportRequired: 'Sport (obligatorio) debe escribirse exactamente como en esta lista.',
	    sportExample: 'Ej: Nadar correcto, Natacion incorrecto.',
	    allowedValues: 'Valores permitidos (tal cual)',
	    expectedColumns: 'Columnas esperadas',
	    exampleBySpot: 'Ejemplo por deporte',
	  },
	  elevationProfile: {
          axisPowerBpm: 'W / bpm',
          seriesAltitudePlain: 'Altitud (m)',
          seriesSpeed: 'Velocidad (KPH)',
          seriesPowerCycling: 'Potencia (W)',
          axisAltFcTemp: 'Altitud / FC / Temp',
          axisSpeedCadPower: 'Velocidad / Cadencia / Potencia',
          axisPower: 'Potencia (W)',
          axisLap: 'Vuelta',
          axisAltitude: 'Altitud (m)',
          axisCadence: 'Cadencia (rpm)',
          axisTemp: 'Temp (°C)',
          seriesAltitudeImproved: 'Altitud Mejorada (m)',
          seriesPaceAvg: 'Ritmo Prom. (min/km)',
          seriesCadence: 'Cadencia (rpm)',
          seriesTemp: 'Temperatura (°C)',
          altMax: 'Alt. Máx',
          altMin: 'Alt. Mín',
          hrLapSeriesLabel: 'FC promedio por vuelta',
          axisDistance: 'Distancia (km)',
          axisElevation: 'Elevación (m)',
          axisBpm: 'bpm',
          axisPaceMinKm: 'min/km',
          seriesElevation: 'Elevación (m)',
          seriesHr: 'FC (bpm)',
          seriesPaceReal: 'Ritmo real (min/km)',
          seriesGapAdjusted: 'Ritmo ajustado — GAP',
          consolidatedChartTitle: 'Gráfico Consolidado de Actividad',
          hrLapHistogramTitle: 'Histograma de Frecuencia Cardíaca (por Vuelta)',
          hrTimeChartTitle: 'Frecuencia Cardíaca (por Tiempo)',
	    loading: 'Cargando perfil altimetrico...',
	    loadingCycling: 'Cargando perfil altimetrico de ciclismo...',
	    title: 'Perfil Altimetrico',
	    titleCycling: 'Perfil Altimetrico de Ciclismo con Potencia',
	    totalDistance: 'Distancia Total:',
	    maxElevation: 'Elevacion Maxima:',
	    minElevation: 'Elevacion Minima:',
	    positiveSlope: 'Desnivel Positivo Acumulado:',
	    normalizedPower: 'Potencia Normalizada (NP):',
	    intensityFactor: 'Intensidad Relativa (IF):',
	  },
	  shareBoard: {
	    availableEvents: 'Eventos disponibles (arrastra o clic)',
	    dragToAthlete: 'Arrastra a un atleta (o clic para seleccionar)',
	    myAthletes: 'Mis atletas (suelta o boton)',
	    noAthletes: 'No tienes atletas asignados o no se pudo cargar.',
	    dropEvent: 'Suelta aqui un evento',
	  },
	  meetupForm: {
	    gpxFile: 'Archivo GPX (opcional)',
	    showAddressOnly: 'Mostrar direccion exacta y telefono solo a participantes inscritos',
	  },
	  messagesInbox: {
	    sharedMessages: 'Aqui apareceran los mensajes compartidos (texto + mapa).',
	    loadingConversation: 'Cargando conversacion...',
	  },
	  adminPanel: {
	    noPermission: 'No tienes permisos para ver este panel.',
	    confirmDelete: 'Estas seguro de que deseas eliminar este entrenador?',
	    enterEmail: 'Ingresa un correo para invitar.',
	    title: 'Administracion de Entrenadores',
	    emailPlaceholder: 'Correo electronico del entrenador',
	    searchPlaceholder: 'Buscar por nombre o email...',
	  },

    superAdmin: {
      title: "Super Admin",
      users: "usuarios",
      trainers: "entrenadores",
      withLab: "con LAB",
      blocked: "bloqueados",
      logout: "Cerrar sesión",
      allRoles: "Todos los roles",
      refresh: "Actualizar",
      results: "resultados",
      searchPlaceholder: "Buscar por nombre, email, username...",
      colUser: "Usuario",
      colEmail: "Email",
      colRole: "Rol",
      colStatus: "Estado",
      colLab: "LAB",
      colRegistered: "Registro",
      colActions: "Acciones",
      active: "activo",
      block: "Bloquear",
      unblock: "Activar",
      delete: "Eliminar",
      protected: "Protegido",
      noUsers: "No hay usuarios",
      confirmDelete: "¿Eliminar a {{name}}? Esta acción no se puede deshacer.",
      confirmDeleteTitle: "Confirmar eliminación",
      confirmDeleteBtn: "Sí, eliminar",
      cancel: "Cancelar",
      labActivated: "Acceso LAB activado",
      labRevoked: "Acceso LAB revocado",
      labError: "Error actualizando acceso LAB",
      actionError: "Error ejecutando acción",
      loadError: "Error cargando usuarios",
    },
	  lapsStrength: {
	    distanceM: 'Distancia (m)',
	    avgHR: 'FC Prom.',
	    maxHR: 'FC Max.',
	  },
	  meetupDetail: {
	    emergencyPhone: 'Telefono de seguridad:',
	    meetingMap: 'Mapa del encuentro:',
	  },
	  physio: {
	    vo2max: 'VO2 max estimado',
	    intensityFactor: 'Factor de Intensidad (IF)',
	    tss: 'Training Stress Score (TSS)',
	    avgHR: 'Frecuencia cardiaca promedio',
	    normalizedPower: 'Potencia Normalizada (NP)',
	    tte: 'Tiempo hasta el agotamiento (TTE)',
	    anaerobicTE: 'Training Effect Anaerobico (TEA)',
	    trainingEffect: 'Training Effect (TTE)',
	  },
	  cycleWizard: {
	    swimming: 'Natacion',
	    triathlon: 'Triatlon',
	    raceDay: 'Dia de carrera (recomendado)',
	    longDay: 'Dia del largo (run)',
	    timeGoal: 'Objetivo de tiempo (opcional)',
	    back: 'Atras',
	  },
	  shareTrainingCard: {
	    autoPhoto: 'Auto: foto si existe; si no, mapa',
	    generatingMap: 'Generando mapa...',
	  },
	  activityMetrics: {
	    cycling: 'Metricas de Ciclismo',
	    metric: 'Metrica',
	    additional: 'Metricas Adicionales',
	  },
	  insights: {
	    next24h: 'Proximas 24-48h',
	    nextKeySession: 'Siguiente sesion clave',
	  },
	  workoutModal: {
	    selectWorkout: 'Selecciona un entrenamiento:',
	  },
	  summary: {
	    vo2max: 'VO2 max:',
	    debugTss: 'Debug TSS:',
	  },
	  trainerLibrary: {
	    intensityPlaceholder: 'base | threshold | vo2 | easy | tempo...',
	  },
	  guest: 'Invitado',
	  athleteFallback: 'Atleta',
	  trainerFallback: 'Entrenador',
	  tzoneUser: 'Usuario Tzone',
	  searchPartner: 'Buscar partner',
	  myContacts: 'Mis contactos',
	  messages: 'Mensajes',
	  meetups: 'Meetups',
	  myProfile: 'Mi perfil',
	  logout: 'Cerrar sesión',
	  findTrainingPartner: 'Encuentra tu partner de entrenamiento',
	  heroDescription: 'Conecta con atletas que compartan tu deporte, nivel y objetivos: correr, ciclismo, triatlón, preparación física y más. Solo para usuarios registrados de Tzone.',
	  organizeMeetup: 'Organizar encuentro',
	  viewMeetupsBoard: 'Ver tablero de encuentros',
	  heroNote: 'Usaremos tus datos de entrenamiento (ritmo, distancia, ubicación general) solo para sugerirte partners compatibles.',
	  last7DaysResult: 'Resultado de tus últimos 7 días.',

	  weeklySpotlight: {
	    title: 'Tu semana',
	    weekRange: 'Semana: {{start}} → {{end}} (Lun–Dom)',
	    weekNavAriaLabel: 'Navegación semanal',
	    goToBoard: 'Ir al tablero',
	    backToBoard: 'Volver al tablero',
	    share: 'Compartir',
	    shareWithContact: 'Compartir con un contacto',
	    generating: 'Generando…'
	  },
	  contact: 'Contacto',
	  loadingMutualContacts: 'Cargando contactos en común...',
	  viewMutualContacts: 'Ver contactos en común',
	  searchingMutualContacts: 'Buscando contactos en común…',
	  mutualContacts: 'contactos en común',
	  connectedBy: 'Conectado por:',
	  and: 'y',
	  viewAll: 'Ver todo',
	  goal: 'Objetivo',
	  noMorePartners: 'No hay más partners para mostrar por ahora.',
	  loadingRecommendations: 'Cargando recomendaciones…',
	  mutualConnections: 'Conexiones en común',
	  mutualConnectionsDescription: 'Estos contactos tienen match contigo y con {{name}}.',
	  connectionPath: 'Tú ↔ {{name}} ↔ {{currentCardName}}',
	  close: 'Cerrar',
	  itsAMatch: '¡Es un match!',
	  matchDescription: {
		before: 'Ahora pueden conversar en',
		after: 'En matches hombre–mujer, la mujer envía el primer mensaje.'
	  },
	  goToMessages: 'Ir a mensajes',
	  keepSearching: 'Seguir buscando',

	  search: 'Buscar',
	  closeSearch: 'Cerrar búsqueda',
	  searchPartnersPlaceholder: 'Buscar partners...',
	  explore: 'Explorar',
	  results: 'Resultados',
	  searching: 'buscando…',
	  noResultsFound: 'No encontramos resultados.',
	  noUsersToExplore: 'No hay usuarios para explorar.',
	  ignore: 'Ignorar',
	  connect: 'Conectar',
	  block: 'Bloquear',
	  report: 'Reportar',
	  userFallback: 'Usuario',
	  invalidSessionUserId: 'Sesión inválida: userId no encontrado o corrupto (localStorage).',
	  matchReviewMessages: '¡Es un match! Revisa Mensajes 😉',
	  requestSent: 'Solicitud enviada ✅',
	  blockPendingEndpoint: 'Bloqueo: pendiente de endpoint ✅',
	  reportPendingEndpoint: 'Reporte: pendiente de endpoint ✅',
	  partner: 'Partner',
	  partnerTzone: 'Partner Tzone',
	  loading: 'Cargando…',

	  errors: {
		loadRecommendations: 'No pudimos cargar recomendaciones. Intenta más tarde.',
		searchFailed: 'No pudimos buscar en este momento.',
		connectFailed: 'No se pudo conectar.',
		sendRequestFailed: 'Error enviando solicitud.'
	  },

	  profile: {
		loading: 'Cargando tu perfil…',
		subtitle: 'Activa tu perfil para aparecer en las búsquedas de partners de entrenamiento.',
		savedSuccess: 'Perfil actualizado correctamente.',
		enableProfile: 'Activar mi perfil en la comunidad',
		displayName: 'Nombre a mostrar',
		displayNamePlaceholder: 'Ej: Carla, runner de Las Condes',
		city: 'Ciudad',
		cityPlaceholder: 'Ciudad',
		country: 'País',
		countryPlaceholder: 'País',
		bio: 'Bio',
		bioPlaceholder: 'Cuenta cómo entrenas y qué buscas en un partner.',
		partnerPreferences: 'Preferencias de partner',
		partnerPreferencesHint: '¿Con quién te interesa conectar en la comunidad?',
		basicInfo: 'Información básica',
		sportsSection: 'Deportes',
		sportsHint: 'Selecciona los deportes que practicas. Esto ayuda a encontrar mejores partners.',
		sportsOptions: {
		  running: 'Running',
		  cycling: 'Ciclismo',
		  trail: 'Trail',
		  swimming: 'Natación',
		  strength: 'Fuerza',
		  triathlon: 'Triatlón'
		},
		addCustomSportPlaceholder: 'Otro deporte…',
		addCustomSport: '+ Agregar',
		removeSport: 'Quitar {{sport}}',
		preview: 'Así te verán otros atletas',
		previewDisabledHint: 'Tu perfil está desactivado. Actívalo para aparecer en las búsquedas de la comunidad.',
		preferredGender: {
		  any: 'Cualquier género',
		  women: 'Solo mujeres',
		  men: 'Solo hombres'
		},
		privacy: 'Privacidad',
		showAge: 'Mostrar mi edad',
		showGender: 'Mostrar mi género',
		showCity: 'Mostrar mi ciudad',
		saving: 'Guardando…',
		saveProfile: 'Guardar perfil',
		errors: {
		  userIdNotFound: 'No se encontró userId en localStorage.',
		  loadProfile: 'No se pudo cargar tu perfil de comunidad.',
		  serverConnectionLoad: 'No se pudo conectar con el servidor de Tzone. Verifica que el backend esté encendido y sin errores de CORS.',
		  loadGeneric: 'Error al cargar el perfil.',
		  userIdMissingSave: 'No se encontró userId para guardar el perfil.',
		  saveProfile: 'No se pudo guardar tu perfil de comunidad.',
		  serverConnectionSave: 'No se pudo conectar con el servidor de Tzone al guardar. Revisa que esté activo y accesible.',
		  saveGeneric: 'Error al guardar el perfil.'
		}
	  },
	  
	  gpx: {
		  errors: {
			download: 'No se pudo descargar el GPX (HTTP {{status}}).',
			invalidRoute: 'El GPX no trae una ruta válida.',
			generic: 'No pudimos cargar el GPX.'
		  }
		},

	  contacts: {
		myContactsCount: 'Mis contactos ({{count}})',
		activeCount: 'Activos ({{count}})',
		blockedCount: 'Bloqueados ({{count}})',
		noContacts: 'Aún no tienes contactos.',
		noContactsYet: 'Aún no tienes contactos.',
		loading: 'Cargando contactos…',
		loadingContacts: 'Cargando contactos…',
		errorLoad: 'No pudimos cargar tus contactos.',
		emptyState: 'Todavía no tienes contactos o matches activos.',
		message: 'Mensaje',
		block: 'Bloquear',
		unblock: 'Desbloquear',
		delete: 'Eliminar',
		deleteMatch: 'Eliminar match',
		communityBadge: 'Comunidad',
		mutualContacts: 'contactos en común',
		connectedBy: 'Conectado por:',
		viewProfile: 'Ver perfil',
		relationship: 'Relación',
		blocked: 'Bloqueado',
		openChat: 'Abrir chat',
		chatUnavailable: 'Chat no disponible',
		notCommunityMatchShort: 'No es un match de comunidad',
		confirmDeleteMatch: '¿Quieres eliminar el match con {{name}}?',
		errors: {
		  currentUserNotFound: 'No se encontró el usuario actual.',
		  loadContacts: 'No pudimos cargar tus contactos.',
		  blockUser: 'No se pudo bloquear el usuario.',
		  unblockUser: 'No se pudo desbloquear el usuario.',
		  notCommunityMatch: 'Este contacto no corresponde a un match de comunidad.',
		  deleteMatch: 'No se pudo eliminar el match.'
		}
	  },

	  messagesPage: {
		sharedRoute: '📍 Ruta compartida',
		activity: 'Actividad',
		loadingSummary: 'Cargando resumen…',
		you: 'Tú',
		athleteTzone: 'Atleta Tzone',
		conversations: 'Conversaciones',
		noConversations: 'Aún no tienes conversaciones. ¡Empieza dando like en la comunidad!',
		user: 'Usuario',
		selectConversation: 'Selecciona una conversación para empezar a chatear.',
		matchNowCanChat: '🔔 ¡Es un match! Ahora pueden conversar.',
		startChat: 'Empezar a chatear',
		blockedUserNoMessages: 'Usuario bloqueado (no recibirás mensajes)',
		trainingPartner: 'Partner de entrenamiento',
		loadingMessages: 'Cargando mensajes…',
		viewMap: 'Ver mapa',
		viewSummary: 'Ver resumen',
		downloadGpx: 'Descargar GPX',
		copyFileId: 'Copiar fileId',
		copy: 'Copiar',
		writeMessage: 'Escribe un mensaje…',
		unblockToWrite: 'Este usuario está bloqueado. Desbloquéalo para escribir.',
		activityDetail: 'Detalle de actividad',
		map: 'Mapa',
		summaryTab: 'Resumen',
		noFileIdToShow: 'No hay fileId para mostrar.',
		title: 'Título',
		fileIdFit: 'fileId (FIT)',
		routeTitlePlaceholder: 'Ej: 🏁 Fondo Chamisero',
		fileIdPlaceholder: 'Ej: 1765676279504.fit ó 66f3abc123...',
		fileIdHint: 'Tip: si ya subiste el FIT en Actividades, copia su fileId y pégalo aquí.',
		optionalUploadFitNow: '(Opcional) Subir .fit ahora',
		uploading: 'Subiendo…',
		preview: 'Previsualización',
		defaultRouteCaption: '🏁 Ruta compartida',
		unblockToShareRoutes: 'Este usuario está bloqueado. Desbloquéalo para compartir rutas.',
		confirmUnblockUser: '¿Quieres desbloquear a este usuario y permitir mensajes nuevamente?',
		confirmBlockUser: '¿Seguro que quieres bloquear a este usuario? No podrán seguir chateando ni aparecerá en tus recomendaciones.',
		confirmReportUser: '¿Quieres denunciar a este usuario por comportamiento inapropiado?',
		reportSuccess: 'Gracias, hemos recibido tu denuncia.',
		summary: {
		  title: 'Resumen',
		  date: 'Fecha',
		  sport: 'Deporte',
		  duration: 'Duración',
		  distance: 'Distancia',
		  avgPace: 'Ritmo medio',
		  avgSpeed: 'Vel. promedio',
		  maxSpeed: 'Vel. máxima',
		  calories: 'Calorías',
		  ascent: 'Ascenso',
		  descent: 'Descenso',
		  avgHeartRate: 'FC Promedio',
		  maxHeartRate: 'FC Máxima',
		  avgCadence: 'Cadencia prom.',
		  maxCadence: 'Cadencia máx.',
		  avgPower: 'Pot. prom.',
		  maxPower: 'Pot. máx.'
		},
		errors: {
		  loadActivitySummary: 'No pudimos cargar el resumen de esta actividad.',
		  userIdNotFound: 'No se encontró userId en localStorage.',
		  uploadFit: 'No se pudo subir el .fit. Si tu backend requiere activityId, sube el FIT desde Actividades y pega el fileId aquí.',
		  serverDidNotReturnFileId: 'El servidor no retornó fileId.',
		  blockedUserCannotMessage: 'No puedes enviar mensajes a un usuario bloqueado. Primero desbloquéalo.',
		  invalidMatchId: 'No se puede enviar: matchId inválido.',
		  cannotSendYet: 'No puedes enviar este mensaje aún.',
		  invalidConversationMatchId: 'Esta conversación no tiene un matchId válido para cargar mensajes.',
		  loadMessages: 'No pudimos cargar los mensajes de esta conversación.',
		  currentUserNotFound: 'No se encontró el usuario actual.',
		  loadConversations: 'No pudimos cargar tus conversaciones.',
		  sendMessage: 'No pudimos enviar el mensaje.',
		  validFileIdRequired: 'Debes indicar un fileId válido.',
		  shareRoute: 'No pudimos compartir la ruta. Intenta nuevamente.',
		  blockUser: 'No pudimos bloquear a este usuario. Intenta nuevamente.',
		  unblockUser: 'No pudimos desbloquear a este usuario. Intenta nuevamente.',
		  reportUser: 'No pudimos enviar la denuncia. Intenta nuevamente.',
		  downloadGpx: 'No se pudo descargar GPX'
		}
	  },
	  
	  	 
		 
	  geoLocation: {
		  loading: 'Cargando...',
		  emptySession: 'No se han encontrado datos de sesión.',
		  noCoordinates: 'No hay coordenadas para mostrar el mapa.',
		  elevation: {
			title: 'Altimetría de la Ruta',
			max: 'Altura máxima',
			min: 'Altura mínima'
		  },
		  map: {
			location: 'Ubicación',
			startPoint: 'Punto de inicio de la ruta',
			endPoint: 'Punto de fin de la ruta'
		  },
		  errors: {
			fetch: 'Error al obtener los datos. Intenta nuevamente más tarde.',
			missingFileId: 'No se recibió fileId.'
		  }
		},

	  groupApplyPlan: {
		title: 'Aplicar plan al grupo',
		searchPlan: 'Buscar plan…',
		templatePlan: 'Plantilla / Plan',
		startDate: 'Fecha de inicio',
		overwrite: 'Sobrescribir si existe',
		applyToGroup: 'Aplicar al grupo',
		loading: 'Cargando…',
		noResults: 'Sin resultados',
		successSummary: '✅ Plan aplicado correctamente a {{athletes}} atleta(s). Actividades creadas/actualizadas: {{createdOrUpdated}}{{skipped}}',
		skipped: 'omitidas',
		noMembers: 'Este grupo no tiene miembros.',
		generalError: 'No se pudo aplicar la plantilla.',
		haveIdQuestion: '¿Tienes un ID?',
		enterManually: 'Ingresar manualmente',
		backToList: 'Volver a la lista',
		idPlaceholder: 'ID de plantilla / plan',
		includeLibrary: 'Incluir biblioteca pública',
		selected: 'Seleccionado',
		session: 'Sesión'
	  },

	  meetupsBoard: {
		title: 'Tablero de encuentros',
		subtitle: '1) Arrastra contactos al grupo. 2) Arrastra un encuentro al grupo.',
		loading: 'Cargando grupos, encuentros y contactos…',

		actions: {
		  refresh: 'Actualizar',
		  refreshing: 'Actualizando…',
		  reloadData: 'Recargar datos',
		  openMeetupForm: 'Abrir formulario completo de encuentro'
		},

		tabs: {
		  all: 'Todo',
		  groups: 'Mis grupos',
		  meetups: 'Librería de encuentros',
		  contacts: 'Contactos y Match'
		},

		groups: {
		  title: 'Mis grupos',
		  hint: 'Suelta aquí un contacto para agregarlo al grupo, o un encuentro para asociarlo.',
		  create: 'Crear grupo',
		  createTooltip: 'Crear un nuevo grupo',
		  empty: 'Aún no tienes grupos.',
		  dropHere: 'Suelta aquí',
		  dropContact: 'Suelta para agregar contacto',
		  dropMeetup: 'Suelta para asociar encuentro',
		  unnamed: 'Grupo sin nombre',
		  athletesCount: '{{count}} atletas',
		  meetupsCount: '{{count}} encuentros',
		  manageMembers: 'Gestionar miembros',
		  closeManagement: 'Cerrar gestión',
		  members: 'Miembros',
		  remove: 'Quitar'
		},

		meetups: {
		  title: 'Librería de encuentros',
		  hint: 'Arrastra un encuentro al grupo.',
		  empty: 'Aún no has creado encuentros.',
		  untitled: 'Encuentro sin título',
		  noPermissionEdit: 'Sin permisos (organizer distinto)',
		  fullFormEdit: 'Editar en formulario completo',
		  deleteTitle: 'Eliminar encuentro',
		  dragToGroup: 'Arrastra hacia un grupo →',
		  thisMeetup: 'este encuentro'
		},
		
		gpx: {
		  errors: {
			download: 'Could not download GPX (HTTP {{status}}).',
			invalidRoute: 'GPX does not contain a valid route.',
			generic: 'We could not load the GPX.'
		  }
		},
		
		contacts: {
		  title: 'Contactos y Match',
		  hint: 'Arrastra un contacto al grupo para agregarlo.',
		  empty: 'A medida que generes matches, aparecerán aquí.',
		  athleteFallback: 'Atleta Tzone',
		  origin: 'Origen',
		  unknownOrigin: 'desconocido',
		  originTitle: 'Origen: {{source}}',
		  matchSource: 'Match',
		  nextStep: 'Próximo paso: sumar “Entrenado” (lista de atletas del entrenador) y mostrar ambos orígenes.'
		},

		modals: {
		  createGroup: 'Crear grupo',
		  editGroup: 'Editar grupo',
		  groupName: 'Nombre',
		  description: 'Descripción',
		  backendNote: 'Nota: si tu backend aún no tiene PUT/POST /api/social/groups, te indicará error HTTP.',
		  deleteGroupTitle: 'Eliminar grupo',
		  deleteGroupConfirm: '¿Seguro que deseas eliminar {{name}}?',
		  deleteMeetupTitle: 'Eliminar encuentro',
		  deleteMeetupConfirm: '¿Seguro que deseas eliminar {{title}}?'
		},

	messages: {
	  loadingGroupsError: 'Error al cargar grupos (HTTP {{status}})',
	  attachingMeetup: '⏳ Asociando encuentro al grupo…',
	  meetupAttached: '✅ Encuentro asociado al grupo.',
	  addingContact: '⏳ Agregando "{{name}}" al grupo…',
	  contactAdded: '✅ "{{name}}" agregado al grupo.',
	  draggedContactNotFound: 'No encontré el contacto arrastrado.',
	  dropWithoutPayload: 'DROP llegó sin payload (ni meetupId ni contactId).',
	  groupNameRequired: 'El grupo debe tener nombre.',
	  groupCreated: '✅ Grupo creado.',
	  groupUpdated: '✅ Grupo actualizado.',
	  groupDeleted: '✅ Grupo eliminado.',
	  meetupDeleted: '✅ Encuentro eliminado.',
	  removeMemberLoading: '⏳ Quitando miembro...',
	  memberRemoved: '✅ Miembro removido.',
	  missingMemberId: 'memberId vacío.',
	  missingContactUserId: 'No pude determinar el ID del contacto (userId vacío).',
	  noAddMemberEndpoint: 'No existe endpoint de add member'
	},

	memberLabel: 'Miembro',
	lastResponse: 'Última respuesta',
	log: 'Log'
	  },

	  meetupsPanel: {
		title: 'Encuentros de comunidad',
		subtitleLine1: 'Crear/editar encuentro + invitaciones + mapas.',
		subtitleLine2: 'Grupos y drag & drop se gestionan en el Tablero.',
		activeGroup: 'Grupo activo:',
		backToBoard: 'Volver al Tablero',

		form: {
		  title: 'Crear o editar encuentro social',
		  create: 'Crear encuentro',
		  saveChanges: 'Guardar cambios del encuentro',
		  newEvent: '+ Nuevo encuentro',
		  currentGpx: 'GPX actual:',
		  download: 'Descargar',
		  fields: {
			title: 'Título',
			sport: 'Deporte',
			description: 'Descripción',
			dateTime: 'Fecha y hora',
			maxParticipants: 'Máx. participantes (0 = sin límite)',
			meetingAddress: 'Dirección de encuentro',
			city: 'Ciudad',
			commune: 'Comuna / sector',
			country: 'País',
			emergencyPhone: 'Teléfono de seguridad / contacto',
			routeUrl: 'URL de la ruta (Strava, GPX, etc.)',
			gpxFile: 'Archivo GPX (opcional)',
			registeredOnly: 'Mostrar dirección exacta y teléfono solo a participantes inscritos'
		  },
		  sports: {
			running: 'Running',
			cycling: 'Ciclismo',
			swimming: 'Natación',
			trailrunning: 'Trail',
			strength: 'Fuerza',
			walking: 'Caminata',
			other: 'Otro'
		  },
		  placeholders: {
			title: 'Salida larga domingo 20K',
			description: 'Ritmo suave 5:30-6:00/km, apto para nivel intermedio...',
			meetingAddress: 'Parque Bicentenario 3236',
			city: 'Santiago',
			commune: 'Vitacura',
			country: 'Chile',
			emergencyPhone: '+56 9 1234 5678',
			routeUrl: 'https://www.strava.com/routes/...'
		  }
		},

		events: {
		  title: 'Encuentros de este grupo',
		  noActiveGroup: 'No hay grupo activo. Vuelve al Tablero.',
		  loading: 'Cargando encuentros…',
		  empty: 'Aún no hay encuentros para este grupo.',
		  edit: 'Editar'
		},

		location: {
		  title: 'Lugar de Encuentro',
		  mapTitle: 'Mapa del encuentro',
		  viewOnMap: 'Ver en OpenStreetMap',
		  previewTitle: 'Vista previa del lugar',
		  previewError: 'No se pudo ubicar esta dirección en el mapa. Revisa país / ciudad / dirección, guarda el encuentro e inténtalo de nuevo.'
		},

		route: {
		  title: 'Mapa de la ruta (GPX)',
		  points: 'Puntos de ruta: {{count}}',
		  downloadGpx: 'Descargar GPX'
		},

		invites: {
		  title: 'Invitar miembros al encuentro',
		  additionalEmails: 'Correos adicionales',
		  emailsLabel: 'Correos de atletas (uno por línea o separados por coma)',
		  emailsPlaceholder: 'atleta1@mail.com\natleta2@mail.com\natleta3@mail.com',
		  send: 'Enviar invitaciones'
		},

		tips: {
		  title: 'Consejos de seguridad Tzone',
		  item1: 'Prefiere puntos de encuentro públicos y bien iluminados.',
		  item2: 'Comparte tu ruta y horario con un contacto de confianza.',
		  item3: 'No publiques tu dirección exacta en redes abiertas.',
		  item4: 'Ten siempre un teléfono de contacto de emergencia disponible.'
		},

		messages: {
		  noActiveGroup: 'No hay grupo activo. Vuelve al Tablero y abre el encuentro desde un grupo.',
		  eventCreated: '✅ Encuentro creado.',
		  eventUpdated: '✅ Encuentro actualizado.',
		  gpxUploaded: 'GPX adjuntado correctamente.',
		  editingExisting: 'Editando encuentro existente. Ajusta y guarda los cambios.',
		  creatingNew: 'Listo para crear un nuevo encuentro.',
		  saveBeforeInvites: 'Primero crea o guarda un encuentro.',
		  enterAtLeastOneEmail: 'Ingresa al menos un correo de atleta.',
		  invitesSent: '✅ Invitaciones enviadas correctamente.'
		},

		errors: {
		  loadGroups: 'No pudimos cargar tus grupos.',
		  loadEvents: 'Error al obtener encuentros.',
		  createEvent: 'Error al crear encuentro',
		  updateEvent: 'Error al actualizar el encuentro',
		  uploadGpx: 'Error subiendo GPX',
		  saveEvent: 'Error al guardar el encuentro.',
		  sendInvites: 'Error al enviar invitaciones.'
		}
	  }
	}
  },


  en: {
    common: {
      the: 'The',
      was: 'was',
      reached: 'reached',
      points: 'points',
      of: 'of',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel',
      areYouSure: 'Are you sure?',
      deleted: 'Deleted',
      athlete: 'Athlete',
      trainer: 'Coach',
      dashboard: 'Dashboard',
      username: 'Username',
      password: 'Password',
      login: 'Log in',
      athleteGroup: 'Athlete Group',
      send: 'Send',
      backToHome: 'Back to home',
      pagina_no_encontrada: 'Page not found',
      pagina_no_encontrada_descripcion: 'The page you are looking for does not exist or was moved.',
    },
    physio: {
      cyclingSession: 'During this cycling session, the athlete achieved a',
      np: 'normalized power',
      npSuffix: 'W, reflecting the sustained physiological load. Their',
      wkg: 'W/kg ratio',
      wkgSuffix: 'W/kg, indicating relative performance consistent with their weight.',
      vo2max: 'VO₂ max',
      vo2Suffix: 'ml/kg/min, providing an overview of aerobic capacity. Additionally, the',
      if: 'Intensity Factor (IF)',
      ifHigh: 'high-intensity session.',
      ifMed: 'moderate-intensity session.',
      ifLow: 'low-intensity session.',
      tss: 'TSS',
      tssDuration: 'with a total duration of',
      tssMinutes: 'minutes, consistent with a',
      loadVeryHigh: 'very high training load.',
      loadHigh: 'moderate-high training load.',
      loadMed: 'moderate training load.',
      loadLow: 'light training load.',
      avgHR: 'Average HR',
      avgHRSuffix: 'bpm, reaching a maximum of',
      avgHREnd: 'bpm, validating the sustained cardiovascular effort.',
    },
    fileUpload: {
      selectFile: 'Select .fit file',
      upload: 'Upload',
      uploading: 'Uploading...',
      onlyFitFiles: 'Only .fit files are allowed',
      pleaseSelectFile: 'Please select a .fit file',
      noUserId: 'User ID not found (userId)',
      uploadError: 'Error uploading file',
      noFileIdReturned: 'The server did not return a fileId. Verify the file is valid.',
      saveFileIdError: 'Error saving fileId to activity',
      activityUpdated: 'Activity updated',
      syncSuccess: '.fit file data was synced successfully.',
      fileUploaded: 'File uploaded',
    },

	home: {
	  title: 'Welcome to Tzone',
	  subtitle: 'Platform for athletes and coaches: planning, tracking and training analysis.',
	  enter: 'Log in',
	  register: 'Sign up',
	  community: 'Tzone Community',
	  companyPrefix: '© 2025 TZONE Corp SpA · RUT 77.923.319-7 · Lo Barnechea, Santiago de Chile',
	  privacyPolicy: 'Privacy Policy',
	  privacyPolicyEs: 'Privacy Policy (ES)',
	  privacyPolicyEn: 'Privacy Policy',
	  metricsNotice: 'Metrics and trademarks notice'
	},

    login: {
      title: 'Log in',
      forgotPassword: 'Forgot your password?',
      blockedUser: 'User blocked. Contact your coach.',
      invalidCredentials: 'Incorrect username or password.'
    },

    register: {
      title: 'Create account',
      alreadyHaveAccount: 'Already have an account?',
      loginLink: 'Log in',
      name: 'First name',
      lastName: 'Last name',
      selectRole: 'Choose your role',
      passwordsDontMatch: 'Passwords do not match',
      submitError: 'Registration failed. Please try again.'
    },

    forgotPassword: {
      title: 'Recover password',
      submitSuccess: 'Recovery email sent. Check your inbox.',
      submitError: 'Error sending email. Please try again.'
    },

    resetPassword: {
      title: 'Reset password',
      success: 'Password reset successfully. You can log in now.',
      submit: 'Reset',
      error: 'Error resetting password.'
    },

    passwordReset: {
      title: 'Recover password',
      success: 'Recovery email sent. Check your inbox.',
      error: 'Error requesting password recovery.'
    },

    changePassword: {
      title: 'Change password',
      confirmNewPassword: 'Confirm new password',
      submit: 'Update password',
      mismatch: 'The new passwords do not match.',
      success: 'Password updated successfully.',
      error: 'Error updating password. Check your details.'
    },
	
	
	weeklySummaryChart: {
	  planned: 'Planned',
	  completed: 'Completed',
          noPlan: 'No plan',
	  title: 'Planned vs Completed',
	  ariaLabel: 'Planned vs Completed by discipline',
	  metrics: {
		distance: 'Distance (km)',
		time: 'Duration (hh:mm)',
		calories: 'Calories',
		elevation: 'Elevation gain (m)',
		tss: 'TSS'
	  },
	  short: {
		distance: 'Distance',
		time: 'Duration',
		calories: 'Calories',
		elevation: 'Elevation',
		tss: 'TSS'
	  },
	  units: {
		hours: 'h',
		minutes: 'min'
	  }
	},
	
	weeklySummary: {
	  title: 'Weekly Compliance',
	  subtitle: 'Weekly Summary',
	  metric: 'Metric',
	  sessions: 'Sessions',
	  distance: 'Distance',
	  duration: 'Duration',
	  calories: 'Calories',
	  elevation: 'Elevation gain',
	  tss: 'TSS'
	},
	
	summary: {
	  loading: 'Loading...',
	  noData: 'No data found',
	  loadError: 'There was an error loading the data',
	  title: 'Running Summary',
	  date: 'Date',
	  sport: 'Sport',
	  duration: 'Duration',
	  distance: 'Distance',
	  calories: 'Calories',
	  ascent: 'Ascent',
	  descent: 'Descent',
	  elevationGain: 'Elevation Gain',
	  avgHR: 'Avg HR',
	  maxHR: 'Max HR',
	  avgPace: 'Avg Pace',
	  maxPace: 'Max Pace',
	  avgSpeed: 'Avg Speed',
	  maxSpeed: 'Max Speed',
	  notAvailable: 'Not available'
	},

    backend: {
      requiredFields: 'All fields are required',
      emailOrUsernameExists: 'The email or username is already registered',
      registerSuccess: 'User registered successfully',
      internalError: 'Internal server error',
      invalidCredentials: 'Incorrect username or password',
      blockedUser: 'User blocked',
      loginSuccess: 'Login successful',
      userNotFound: 'User not found',
      recoverySubject: 'Password recovery',
      recoverySent: 'Recovery email sent to reset your password',
      invalidOrExpiredToken: 'Invalid or expired token',
      passwordResetSuccess: 'Password reset successfully',
      profileUpdated: 'Profile updated successfully',
      athleteProfileUpdated: 'Athlete profile updated successfully',
      currentPasswordIncorrect: 'Current password is incorrect.',
      passwordUpdated: 'Password updated successfully.'
    },

    trainerDashboard: {
      trainerPhotoAlt: 'Coach photo',
      title: 'Coach Dashboard',
      manageAthletes: 'Manage Athletes',
      viewProfile: 'View Profile',
      plans: 'Plans',
      athleteGroup: 'Athlete Group',
      community: 'Community',
      notifications: 'Notifications',
      logout: 'Log out',
      backToDashboard: '← Back to dashboard',
      pmcOverviewTitle: 'CTL / ATL / TSB — all athletes',
      acwrTitle: 'ACWR — Acute vs chronic load',
      myAthletes: 'My Athletes ({{count}})',
      clearSelection: 'Clear selection',
      inviteAthlete: 'Invite athlete',
      emailPlaceholder: 'Email address',
      sendInvite: 'Send invitation',
      noAthletesTitle: 'You do not have athletes yet',
      noAthletesText: 'Invite athletes to see charts, rankings and metrics.',
      loadingData: 'Loading data…',
      topDetail: 'Top 10 (profile details)',

      viewingAthlete: 'Viewing: {{name}}',
      viewCalendar: 'View Calendar',
      viewZones: 'View Zones',
      performance: 'Performance',

      missingInviteData: 'Missing data to send the invitation',
      inviteSent: '✅ Invitation sent successfully',
      inviteError: '❌ Error sending invitation',

      dropDateNotDetected: 'Could not detect the target date. Try dropping onto the day cell.',
      selectAthleteBeforeAssign: 'Select an athlete before assigning.',
      templateReadError: '⚠️ Could not read the template (no days/activities).',

      planAppliedResult: '✅ Plan applied: {{ok}} activity(ies) created{{fail}}',
      failedCount: ' · ❌ failed: {{fail}}',

      unknownError: 'Unknown error',
      assignError: '❌ Could not assign. {{message}}',

      noPerformanceData: 'No performance data to display.',
      performanceLoadHttpError: 'Could not load performance data (HTTP {{status}}).',
      performanceLoadNoResponse: 'Could not load performance data (no response).',

      showingSampleCompliance: 'Showing sample compliance while you connect the endpoint.',

      aiError: 'Error: {{message}}',

      viewLabel: 'View:',
      pmcSelectorAria: 'PMC selector',
      simple: 'Simple',
      advancedAmcharts: 'Advanced (amCharts)',
      both: 'Both',

      consultingAi: 'Consulting AI…',
      testAi: 'Test AI (CTL/ATL/TSB)',

      aiDemoNotice: {
        before: 'If the backend does not have ',
        after: ', you will see a response in ',
        demoMode: 'demo mode'
      },

      addGroup: 'Add Group',
      searchAthlete: 'Search athlete...',
      groups: 'Groups',
      loadingGroups: 'Loading groups...',
      noGroups: 'No groups',
      noAthletes: 'No athletes',
      noMembers: 'No members',
      athlete: 'Athlete',
      athletesShort: 'ath.',
      errorLoadingGroups: 'Could not load groups',
      banisterModelTitle: 'Advanced PMC (amCharts)',
      classicPmcTitle: 'Classic PMC'
    },

	athleteDashboard: {
	  profilePhotoAlt: 'Profile photo',
	  loadingProfile: 'Loading...',
	  title: 'My Training',
	  community: 'Community',
	  settings: 'Athlete Settings',
	  logout: 'Log out',
	  updatingSummary: 'Updating summary (backend)…',
	  emptySummary: 'Weekly summary not populated yet (backend).',
	  coachAssistant: 'Coach Assistant',
	  garminSync: 'Sync Garmin',
	  myProfile: 'My Profile',
	  settingsShort: 'Settings',
	  weeklySummaryTitle: 'Weekly summary',
	  weeklyVisualAria: 'Weekly summary visual',
	  sport: 'Sport',
	  plannedDistanceShort: 'Dist P',
	  completedDistanceShort: 'Dist C',
	  plannedDurationShort: 'Dur P',
	  completedDurationShort: 'Dur C',
	  runningShort: 'Run',
	  cyclingShort: 'Bike',
	  swimmingShort: 'Swim',
	  strengthShort: 'Strength',
	  total: 'TOTAL',
	  distanceShort: 'Dist',
	  timeShort: 'Time',
	  caloriesShort: 'Cal',
	  elevationShort: 'Elev',
	  planned: 'Planned',
	  completed: 'Completed',
	  distance: 'Distance',
	  duration: 'Duration',
	  calories: 'Calories',
	  calendarHint: 'Click event -> details · Click empty day -> add',
	  pmcTitle: 'PMC - Performance Management',
	  whatIfNext7: 'What-if - next 7 days',
	  tss7d: 'TSS 7d:',
	  projectedCtlLoad: 'Projected CTL: {{ctl}} · TSB: {{tsb}}',
	  aiSessionAnalysis: 'AI session analysis',
	  copy: 'Copy',
	  recalculate: 'Recalculate',
	  aiSource: 'Source',
	  aiSessionTitle: 'Quality session - Running Z2',
	  aiSessionText: 'Avg HR 148 bpm (Z2). Pace 5:12/km. CTL +0.8. Appropriate load for the current plan.',
	  aiRealTss: 'Real TSS: 82 (plan: 80)',
	  aiHrVariability: 'Normal HR variability',
	  coachAiAssistant: 'Coach AI Assistant (Groq)',
        
        runningPhysio: {
          title: 'Session Physiological Analysis',
          vo2Sentence: 'Estimated VO₂ max was {{value}} ml/kg/min, providing a general overview of aerobic capacity.',
          tssSentence: 'TSS was {{tss}} points, with a total duration of {{duration}} minutes, consistent with a {{load}} training load.',
          loadHigh: 'very high',
          loadModerate: 'moderate',
          hrSentence: 'The session showed an average heart rate of {{avg}} bpm, reaching a maximum of {{max}} bpm.',
          npSentence: 'Normalized Power was {{value}} W, better reflecting the physiological demands of the session.',
          avgPowerSentence: 'Average Power was {{value}} W, useful for observing overall sustained load.',
          maxPowerSentence: 'Maximum Power recorded was {{value}} W, indicating the peak effort of the session.',
          ftpSentence: 'Estimated FTP was {{value}} W, a key reference for evaluating sustained performance.',
          tteSentence: 'TTE was {{value}}, indicating that:',
          teaSentence: 'TEA was {{value}}, suggesting that:',
          chartTitle: 'Visual Summary of Physiological Metrics',
        },
        coachBot: {
          greeting: 'Hi 👋 I am the coach assistant. How can I help you today?',
          welcomeNote: 'Nice to meet you, {{name}}. I can help you with your planning, metrics and weekly progress.',
          noAnswer: 'I have no answer right now.',
          connectError: 'Could not connect to the assistant. Please try again.',
          inputPlaceholder: 'Write your question…',
          sending: 'Sending…',
          trainerView: 'Coach view',
          athleteView: 'Athlete view',
          quickTsb: 'How is my TSB today and what does it mean?',
          quickTsbLabel: 'TSB today',
          quickWeek: 'Give me a summary of my planned week (duration, distance and TSS).',
          quickWeekLabel: 'Weekly plan summary',
          quickLoad: 'How much load (TSS) do I have this week and how does it affect CTL/ATL?',
          quickLoadLabel: 'Weekly load (TSS)',
          quickTomorrow: 'What training do I have tomorrow?',
          quickTomorrowLabel: "Tomorrow's training",
        },

	  training: 'Training',
	  session: 'Session',
	  notAvailable: 'Not available',

	  success: {
		activitySaved: 'Activity saved'
	  },


	  // AthleteHeader
	  panelTitle: 'Athlete Panel',
	  navLibrary: 'Library',
	  navStatistics: 'Statistics',
	  navZones: 'Training Zones',
	  navSettings: 'Settings',
	  // AthleteSettings
	  settingsTitle: 'Athlete Settings',
	  backToDashboard: 'Back to Dashboard',
	  tabProfile: 'PROFILE',
	  tabZones: 'ZONES',
	  tabImages: 'IMAGES',
	  tabSecurity: 'SECURITY',
	  backToSettings: 'Back to Athlete Settings',
	  profileTabTitle: 'Athlete Profile',
	  goToProfile: 'Go to Profile',
	  zonesTabTitle: 'Training Zones',
	  configureZones: 'Configure Zones',
	  imagesTabTitle: 'Change Image',
	  changeImage: 'Change Image',
	  // ZoneDistributionChart
	  zonesSummary: 'Zone Summary',
	  zonesHR: '❤️ HR Zone',
      zonesSwimPace: '🏊 Swim Pace Zone',
	  zonesPace: '🏃‍ Pace Zone',
	  zonesTimeHR: '🕒 Time per HR zone',
	  zonesTimePace: '🏃‍ Time per Pace zone',
	  zonesLoadingError: 'Could not load zone distribution.',
	  zonesLoading: 'Loading zone distribution...',
	  // ZoneDistributionChartCycling
	  zonesCyclingSummary: 'Cycling Zone Summary',
	  zonesCyclingPower: '🚴‍ Power Zone',
	  zonesCyclingTimePower: '🕒 Time per Power zone',
	  zonesCyclingLoadingError: 'Could not load cycling zone distribution.',
	  zonesCyclingLoading: 'Loading cycling zone distribution...',
	  zonesCyclingNoData: 'No cycling zone data available.',
	  // ActivityModal
	  addActivity: 'Add activity',
	  activityName: 'Name:',
	  activityDate: 'Date:',
	  activityDescription: 'Description:',
	  // ActivityList
	  noActivities: 'No activities available.',
	  errors: {
		missingAthleteId: 'Cannot save activity: missing athlete ID',
		saveErrorTitle: 'Error saving',
		saveError: 'Could not save activity',
		moveError: 'Could not move activity'
	  }
	},

    athleteAdmin: {
      title: 'Athlete Administration',
      backToDashboard: '← Back to Dashboard',
      inviteNewAthlete: 'Invite new athlete',
      emailPlaceholder: 'Athlete email address',
      sendInvite: 'Send invitation',
      name: 'Name',
      email: 'Email',
      status: 'Status',
      actions: 'Actions',
      active: 'active',
      unblock: 'Unblock',
      block: 'Block',
      delete: 'Delete',
      missingData: 'Missing data to send the invitation',
      inviteSuccess: '✅ Invitation sent successfully',
      inviteError: '❌ Error sending invitation',
      confirmDelete: 'Are you sure you want to delete this athlete?',
      changeStatusError: 'Could not change the athlete status.'
    },

	athleteProfile: {
	  loading: 'Loading profile...',
	  profileAlt: 'Profile',
	  personalInfo: 'Photo and Personal Information',
	  viewingProfileOf: 'Viewing profile of',
	  name: 'First name',
	  lastName: 'Last name',
	  email: 'Email',
	  username: 'Username',
	  physicalInfo: 'Physical Information',
	  gender: 'Gender',
	  genderOptions: { male: 'Male', female: 'Female', other: 'Other' },
	  birthDate: 'Date of birth',
	  age: 'Age',
	  weight: 'Weight (kg)',
	  height: 'Height (cm)',
	  locationClub: 'Location and Club',
	  country: 'Country',
	  city: 'City',
	  club: 'Club',
	  coach: 'Coach',
	  disciplines: 'Disciplines',
	  disciplinesLabels: {
		trail: 'Trail',
		running: 'Running',
		cycling: 'Cycling',
		swimming: 'Swimming',
		triathlon: 'Triathlon'
	  },
	  notAvailable: 'Not available',
	  notSpecified: 'Not specified',
	  notRegistered: 'Not registered',
	  trainingZones: 'Training Zones',
	  heartRate: 'Heart Rate',
	  pace: 'Pace',
	  power: 'Power',
	  swimmingCss: 'Swimming (CSS)',
	  zone: 'Zone',
	  min: 'Min',
	  max: 'Max',
	  thresholdHeartRate: 'Threshold Heart Rate',
	  thresholdSpeed: 'Threshold Speed',
	  thresholdPower: 'Threshold Power',
	  threshold: 'Threshold',
	  saveChanges: 'Save Changes',
	  editProfile: 'Edit Profile',
	  backToDashboard: 'Back to Dashboard',
	  messages: {
		userIdNotFound: 'Error: user ID not found.',
		invalidBirthDate: '❌ You must enter a valid date of birth.',
		genderRequired: 'Error: gender is required.',
		profileSaved: '✅ Profile saved successfully.',
		imageUpdated: '✅ Image updated.',
		imageUploadError: '❌ Error uploading the image.',
		onlyJpgPng: '❌ Only JPG or PNG images are allowed.',
		loadError: '❌ Error loading profile. Please try again.',
		saveError: 'Error saving profile. Please try again.',
		imageTooLarge: '❌ Image must not exceed 2MB.'
	  }
	},

    calendar: {
      title: 'Athlete Calendar',
      selectSport: 'Select sport',
      selectRequiredOption: 'Select the required option:',
      defineMetric: 'Choose the metric',
      planByMetric: 'For {{sport}}, do you want to plan by distance or duration?',
      distanceKm: 'Distance (km)',
      duration: 'Duration',
      next: 'Next',
      enterKmExample: 'Ex.: 10, 10.5, 21.1',
      enterKmPlaceholder: 'Enter km',
      enterDistanceGreaterThanZero: 'Enter a distance greater than 0',
      enterDurationExample: 'Ex.: 45 (min) or 0:45 or 01:30',
      enterDurationPlaceholder: 'Minutes or HH:MM',
      enterDurationGreaterThanZero: 'Enter a duration greater than 0',
      copy: 'Copy',
      paste: 'Paste',
      delete: 'Delete',
      copied: 'Copied',
      copiedText: '"{{title}}" was copied.',
      pasted: 'Pasted',
      activityCreated: 'Activity created',
      activityMoved: 'Activity moved',
      unknownError: 'Unknown error',
      errorTitle: 'Error',
      missingAssignedAthlete: 'Missing destination athlete (assignedTo).',
      couldNotCreateActivity: 'Could not create the activity.\n{{message}}',
      couldNotDeleteActivity: 'Could not delete the activity.',
      couldNotMoveActivity: 'Could not move the activity.',
      pasteActivityTitle: 'Paste activity?',
      pasteActivityText: 'Do you want to paste "{{title}}" on this date?',
      yesPaste: 'Yes, paste',
      deleteActivityText: 'This action will delete the activity "{{title}}".',
      yesDelete: 'Yes, delete',
      pasteCopiedActivityOn: 'Paste copied activity on<br><b>{{date}}</b>?',
      completedActivityWithFit: 'Completed activity with FIT file ✅',
      pendingActivity: 'Pending activity',
      completedAria: 'completed'
    },

	activityLabels: {
	  running: 'Running',
	  cycling: 'Cycling',
	  swimming: 'Swimming',
	  rest: 'Rest day',
	  strength: 'Strength',
	  walking: 'Walking',
	  other: 'Other',
	  competition: 'Competition',
	  lab: {
	    tabs: { dashboard: 'Dashboard', calendar: 'Calendar', profile: 'Profile', pmc: 'PMC', zones: 'HR Zones', wellness: 'Wellness', ia: 'AI', banister: 'Banister', competitions: 'Competitions' },
	    currentState: 'Current State · Season',
	    fitness: 'CTL (Fitness)',
	    fatigue: 'ATL (Fatigue)',
	    form: 'TSB (Form)',
	    tssTotal: 'TSS Total',
	    formPositive: 'Positive form — ready to compete',
	    formNeutral: 'Neutral form',
	    formFatigue: 'High fatigue — recovery recommended',
	    weeklyTss: 'Weekly TSS — Last 8 weeks',
	    seasonSummary: 'Season summary',
	    kmRun: 'km run',
	    kmBike: 'km biked',
	    mSwim: 'm swum',
	    hoursRun: 'Hours running',
	    hoursBike: 'Hours cycling',
	    hoursSwim: 'Hours swimming',
	    hoursStrength: 'Hours strength',
	    pmcTitle: 'Performance Management Chart — Last 8 weeks',
	    pmcInterpretation: 'PMC Interpretation',
	    ctlCurrent: 'Current CTL',
	    atlCurrent: 'Current ATL',
	    tsbCurrent: 'Current TSB',
	    hrDistribution: 'HR Distribution — Full season',
	    hrAvgBySport: 'Avg HR by sport',
	    hrChart: 'Chart distribution',
	    monitorForm: 'Monitor form.',
	    positiveForm: 'Positive form.',
	    wellnessTitle: 'Wellness Log',
	    today: 'Today',
	    sleepQuality: 'Sleep quality',
	    energy: 'Energy',
	    muscleTension: 'Muscle tension',
	    mentalState: 'Mental state',
	    restHR: 'Resting HR',
	    perceivedStress: 'Perceived stress',
	    wellnessScore: 'Wellness Score',
	    moderate: 'Moderate — monitor',
	    banisterTitle: 'Banister Model — Fitness-Fatigue',
	    ctlFitness: 'CTL Fitness',
	    atlFatigue: 'ATL Fatigue',
	    tsbForm: 'TSB Form',
	    competitionsTitle: 'Scheduled competitions',
	    noCompetitions: 'No scheduled competitions',
	    compDate: 'Date', compEvent: 'Event', compSport: 'Sport', compDistance: 'Distance', compPriority: 'Priority', compCity: 'City', compTarget: 'Target',
	    iaTitle: 'AI Analysis · Primer Umbral LAB',
	    iaBasedOn: 'Analysis based on current data.',
	    iaForm: 'Form:',
	    coachReport: 'Coach report',
	    generateReport: 'Generate analysis',
	    reportPlaceholder: 'Press "Generate analysis" to get an interpretive report based on athlete data.',
	    askIA: 'Ask the AI',
	    noPmcData: 'Not enough PMC data. Import activities and recalculate PMC.',
	    noBanisterData: 'Not enough data for Banister model. Import activities and recalculate PMC.',
	    generating: 'Generating...',
	  },
	  training: 'Training',
	  untitled: 'untitled',
	  untitledActivity: 'untitled activity',
	},
	activitySelector: {
	  selectActivityType: 'Select an activity type'
	},
	


    groupsPanel: {
      groups: 'Groups',
      newGroup: '+ New group',
      detailEdit: 'Details and editing',
      name: 'Name',
      sport: 'Sport',
      description: 'Description',
      optional: '(optional)',
      members: 'Members',
      loadingGroups: 'Loading groups…',
      noGroups: 'No groups. Create one with "+ New group".',
      newUnsaved: 'New group (unsaved)',
      addAthletesPlaceholder: 'Add athletes…',
      dropHint: 'You can also drag athletes here to add them.',
      saving: 'Saving…',
      savedChanges: 'Changes saved ✓',
      noResults: 'No results',
      viewAll: 'View all ({{count}})',
      addAll: 'Add all',
      removeAll: 'Remove all',
      noAthletes: 'No athletes were found for this coach.',
      noChanges: 'No changes',
      confirmDelete: 'Delete this group? This action cannot be undone.',
      triathlon: 'Triathlon',
      applyPlan: 'Apply plan…',
      hideList: 'Hide list',
      all: 'All',
      run: 'Run',
      cycling: 'Cycling',
      swim: 'Swim',
      strength: 'Strength',
      other: 'Other',
      defaultGroup: 'Group',
      errorLoadingGroups: 'Could not load groups.',
      athlete: 'Athlete',
      athletesShort: 'ath.',
      localGroupCreated: '⚠️ There is no create endpoint. A local group was created (Unsaved). Press "Save" when the backend is ready.',
      saveError: '❌ Could not save. Check the create/update endpoints.',
      deleteError: '❌ Could not delete the group (no endpoint available).',
      localGroupWarningPrefix: 'This group is local (not saved on the server). Press',
      localGroupWarningSuffix: 'when the backend is ready.',
      groupNamePlaceholder: 'Group name',
      descriptionPlaceholder: 'Notes, group goals, rules, etc.',
      remove: 'Remove',
      member: 'Member',
      addAtLeastOneAthlete: 'Add at least one athlete to the group to apply a plan.',
      saveAsNew: 'Save as new',
      appliedToAthletes: 'Applied to {{okCount}}/{{total}} athletes.',
      couldNotApplyTemplate: 'Could not apply the template.',
      viewDetails: 'View details'
    },
	
	inviteAthlete: {
	  title: "Invite athlete",
	  placeholder: "Athlete email",
	  send: "Send invitation",
	  errorTitle: "Error",
	  successTitle: "Success",
	  invalidEmail: "Please enter a valid email address.",
	  successMessage: "Invitation sent successfully.",
	  errorMessage: "An error occurred while sending the invitation."
	},

    trainerTemplates: {
      library: 'Workout Library',
      openManager: 'Open manager',
      searchTemplate: 'Search template…',
      noResults: 'No results.',
      viewActivitiesDays: 'View activities / days',
      noCategory: '(no category)',
      oneDay: '1 day',
      multipleDays: '{{count}} days',
      noPlanning: 'no planning',
      edit: 'EDIT',
      configure: 'CONFIGURE',
      applyTemplate: 'Apply…',
      loadingActivities: 'Loading activities…',
      templateWithoutPlanning: 'This template does not include planning. Use “CONFIGURE” or import it from Excel.',
      day: 'Day',
      dragToCalendar: 'Drag to calendar',
      untitled: '(untitled)',
      applyTemplateTitle: 'Apply template',
      template: 'Template',
      startDate: 'Start date',
      destination: 'Destination',
      currentAthlete: 'Current athlete',
      selectAthlete: 'select an athlete',
      group: 'Group',
      noGroupsOption: '(no groups)',
      applying: 'Applying…',
      apply: 'Apply',
      selectStartDate: 'Select a start date.',
      selectAthleteOrGroup: 'Select an athlete or choose "Group".',
      chooseGroup: 'Choose a group.',
      groupHasNoMembers: 'That group has no members.',
      templateAppliedToAthletes: '✅ Template applied to {{count}} athlete(s).',
      backendApplyMissing: '⚠️ The backend does not have /cycles/apply-template yet. The payload was logged to console.',
      backendApplyEndpointMissing: '⚠️ The /cycles/apply-template endpoint is missing on the backend. The payload is already generated correctly.',
      errorApplyingTemplate: '❌ Error applying template. {{message}}',
      metricDuration: 'Duration (min)',
      metricDistance: 'Distance (km)',
      metricElevation: 'Elevation (m)',
      metricTss: 'TSS'
    },

    trainerLibrary: {
      title: 'Activity Library',
      useIAWeek: 'Use AI (week)',
      baseAerobic: 'Aerobic base',
      thresholds: 'Thresholds',
      noTemplates: 'No templates',
      local: 'local',
      add: 'Add',
      selectAthlete: 'Select an athlete.',
      activityAddedBackend: '✅ Activity added to calendar (backend/AI)',
      activityCreatedLocal: '✅ Activity created from local template',
      weeklyPlanApplied: '🤖✅ Weekly AI plan applied'
    },
	
	trainingLibraryPanel: {
	  mini: 'Mini',
	  compact: 'Compact',
	  showLibrary: 'Show library',
	  hideLibrary: 'Hide library',
	  libraryShort: 'Library',
	  easyRun: 'Easy run',
	  z2Easy: 'Easy Z2',
	  threshold: 'Threshold',
	  thresholdBlocks: 'Threshold blocks',
	  strength: 'Strength',
	  fullBody: 'Full body',
	  localTemplate: 'Local template',
	  untitled: 'Untitled',
	  days: 'days',
	  daysShort: 'd',
	  hideDetail: 'Hide detail',
	  viewDetail: 'View detail',
	  loadingDetail: 'Loading detail…',
	  hide: 'Hide'
	},
	
	trainingPlans: {
	  filters: 'Filters',
	  filtersAll: 'All',
	  sport: 'Sport',
	  distanceType: 'Distance/Type',
	  level: 'Level',
	  search: 'Search',
	  searchPlaceholder: 'Name, notes...',
	  title: 'Training Plans',
	  empty: 'No templates found for these filters.',
	  untitled: 'Untitled',
	  weeksShort: 'wk',
	  sportLabel: 'Sport',
	  distanceLabel: 'Distance',
	  phase: 'Phase',
	  preview: 'Preview',
	  apply: 'Apply',
	  selectTemplateForPreview: 'Select a template to view details.',
	  triathlon: 'Triathlon',
	  levelNovice: 'Novice',
	  levelIntermediate: 'Intermediate',
	  levelAdvanced: 'Advanced',
	  distanceAll: 'All',
	  ultra50k: 'Ultra 50K',
	  ultra7080k: 'Ultra 70–80K',
	  ultra90120k: 'Ultra 90–120K',
	  ultra160k: 'Ultra 160K',
	  sprint: 'Sprint',
	  olympic: 'Olympic',
	  middle703: 'Middle (70.3)',
	  ironman1406: 'Ironman (140.6)'
	},

	trainerLibraryManager: {
	  title: 'Workout Library',
	  back: 'Back',
	  backToDashboardTitle: 'Back to Coach Dashboard (Esc)',
	  filters: 'Filters',
	  scope: 'Scope',
	  scopeMine: 'My templates',
	  scopeClub: 'Club templates',
	  scopeAll: 'All',
	  sport: 'Sport',
	  tag: 'Tag',
	  tagBase: 'Base',
	  tagThreshold: 'Threshold',
	  tagVo2: 'VO2 max',
	  search: 'Search',
	  searchPlaceholder: 'Name or description… ( / to focus )',
	  limit: 'Limit',
	  applying: 'Applying…',
	  applyFilters: 'Apply filters',
	  editTemplate: 'Edit template',
	  newTemplate: 'New template',
	  name: 'Name',
	  intensityText: 'Intensity (text)',
	  durationMin: 'Duration (min)',
	  distanceKm: 'Distance (Km)',
	  tss: 'TSS',
	  description: 'Description',
	  descriptionPlaceholder: 'Write the training guidance…',
	  update: 'Update',
	  templates: 'Templates',
	  of: 'of',
	  previous: 'Previous',
	  next: 'Next',
	  noTemplatesForFilters: 'No templates for the current filters.',
	  edit: 'Edit',
	  duplicate: 'Duplicate',
	  disable: 'Disable',
	  updatedShort: 'upd.',
	  page: 'Page',
	  template: 'Template',
	  copy: 'copy',
	  templateNameRequired: 'Please give the template a name',
	  templateUpdated: '✅ Template updated',
	  templateCreated: '✅ Template created',
	  templateSaveError: 'Could not save the template',
	  confirmDisableTemplate: 'Disable this template?',
	  templateDisabled: '🗑️ Template disabled',
	  templateDisableError: 'Could not disable the template'
	},
	
	trainerProfile: {
	  loading: 'Loading profile...',
	  photos: 'Photos',
	  profilePhoto: 'Profile photo',
	  profilePhotoAlt: 'Coach profile photo',
	  clubPhoto: 'Club photo',
	  clubPhotoAlt: 'Club photo',
	  generalInfo: 'General information',
	  username: 'Username',
	  email: 'Email',
	  club: 'Club',
	  trainer: 'Coach',
	  firstName: 'First name',
	  lastName: 'Last name',
	  gender: 'Gender',
	  country: 'Country',
	  city: 'City',
	  disciplines: 'Disciplines',
	  changePassword: 'Change password',
	  currentPasswordPlaceholder: 'Current password',
	  newPasswordPlaceholder: 'New password',
	  update: 'Update',
	  saveChanges: 'Save changes',
	  editProfile: 'Edit profile',
	  backToDashboard: 'Back to Dashboard',
	  select: 'Select an option',
	  notSpecified: 'Not specified',
	  genderOptions: {
		male: 'Male',
		female: 'Female',
		other: 'Other'
	  },
	  disciplinesLabels: {
		trail: 'Trail',
		running: 'Running',
		cycling: 'Cycling',
		swimming: 'Swimming',
		triathlon: 'Triathlon'
	  },
	  messages: {
		userIdNotFound: 'Error: user ID not found.',
		loadError: 'Could not load the coach profile.',
		profilePhotoUpdated: '✅ Profile photo updated.',
		clubPhotoUpdated: '✅ Club photo updated.',
		profilePhotoUploadError: '❌ Error uploading profile photo.',
		clubPhotoUploadError: '❌ Error uploading club photo.',
		profileSaved: '✅ Profile saved successfully.',
		saveError: '❌ Error saving profile.',
		passwordFieldsRequired: 'You must complete both password fields.',
		passwordMismatch: 'Passwords do not match.',
		passwordUpdated: '✅ Password updated successfully.',
		passwordUpdateError: '❌ Error updating password.'
	  },
	  
	  disciplineOptions: {
		  Trail: 'Trail',
		  Running: 'Running',
		  Ciclismo: 'Cycling',
		  Natación: 'Swimming',
		  Triatlón: 'Triathlon'
	  }
	},
		
	
	cycleTemplatesPanel: {
	  title: 'Training Plan Template Manager',
	  downloadTemplate: 'Download template + guide',
	  downloadTemplateTitle: 'Download the empty spreadsheet with guide and examples',
	  importExcel: 'Import Excel',
	  backToDashboard: 'Back to Dashboard',
	  createTemplate: 'Create new template',
	  editTemplate: 'Edit template',
	  planName: 'Plan name',
	  distanceCategory: 'Distance / category (10K, 21K, 42K, 70.3…)',
	  totalDays: 'Total days',
	  notes: 'Notes / block objective (optional)',
	  activities: 'Template activities',
	  totalActivities: 'Total activities',
	  noPlanningYet: 'This template has no planning yet. Add activities manually or import an Excel file.',
	  day: 'Day',
	  sport: 'Sport',
	  activityTitle: 'Title / Task',
	  metric: 'Planned metric',
	  value: 'Value',
	  valuePlaceholder: 'min / km / m / pts',
	  description: 'Description',
	  activityTitlePlaceholder: 'Ex. Easy run, 6x1000 intervals, lower body strength…',
	  activityDescriptionPlaceholder: 'Detailed session description',
	  addActivity: 'Add activity',
	  saveActivity: 'Save',
	  validationDuration: 'Duration must be hh:mm:ss (e.g. 01:30:00).',
	  validationDistance: 'Distance must be a number in km (e.g. 13 or 13.5).',
	  createButton: 'Create template',
	  saveChanges: 'Save changes',
	  cancelEdit: 'Cancel editing',
	  loading: 'Loading…',
	  loadingShort: 'Loading...',
	  noTemplatesYet: 'There are no templates yet.',
	  copy: 'Copy',
	  move: 'Move',
	  selectActivityType: 'Select an activity type',
	  serverPlanMissing:
		'The server is not returning the planning for this template. If you created it in this browser, a local copy was saved; otherwise, import an Excel file to rebuild it.',
	  confirmDeleteTemplate: 'Delete template?',
	  alerts: {
		activityTitleRequired: 'You must enter a title/task.',
		activityDescriptionRequired: 'Description is required.',
		activityValueRequired: 'You must enter a planned value.',
		completeTitleDescriptionValue: 'Complete title, description, and value.',
		excelNoRows: 'The Excel file does not contain rows.',
		importedActivities: 'Imported {{count}} activities in {{days}} days.',
		excelReadError: 'I could not read the Excel file. Please check the file.',
		planNameRequired: 'You must enter the plan name.',
		addAtLeastOneActivityToTemplate: 'Add at least one activity to the template.',
		addAtLeastOneActivity: 'Add at least one activity.',
		templateCreated: 'Template created with planning.',
		templateUpdated: 'Template updated.',
		updateError: 'The template could not be updated.',
		editLoadError: 'I could not load the template for editing.',
		deleteError: 'I could not delete the template.',
		copyPending: 'Copy pending',
		movePending: 'Move pending'
	  },
	  errors: {
		loadingTemplates: 'Error loading templates',
		createTemplate: 'The template could not be created',
		unauthenticatedReload: 'Not authenticated (401). Log in again and reload this screen.',
		unauthenticatedCreate: 'Not authenticated (401). Log in again and try creating it once more.',
		unauthenticatedEdit: 'Not authenticated (401). Log in again and try editing once more.',
		unauthenticatedSave: 'Not authenticated (401). Log in again and try saving changes once more.',
		unauthenticatedDelete: 'Not authenticated (401). Log in again and try deleting it once more.'
	  }
	},
	
	trainerEmailPanel: {
	  title: "Email notifications",
	  subtitle: "Set when and to whom emails are sent (digest / weekly / on create).",
	  sendMode: "Send mode",
	  rollingDays: "Rolling days",
	  onlyTheseWeekdays: "Only these weekdays",
	  hour: "Hour",
	  minute: "Minute",
	  protectionWindow: "Protection window (min)",
	  digestCreateHint: "\"On create/update\" sends almost immediately, but only if it is outside the protection window.",
	  digestDailyHint: "\"Daily digest\" sends today and the next 2 days (if they exist).",
	  protectionExample: "Example: if the digest is scheduled at 07:00 and you change a session at 06:40, no extra email is triggered. If you change it at 07:20, one is triggered.",
	  sendTo: "Send to",
	  targets: {
		all: "All my athletes",
		groups: "Only these groups",
		athletes: "Only these athletes"
	  },
	  noGroups: "No groups available for this trainer.",
	  noAthletes: "No athletes assigned to this trainer.",
	  options: {
		digest3d: "3-day daily digest (like TP)",
		digest1d: "Daily digest (1 day)",
		weekly: "Weekly summary",
		onCreate: "Send on create / update"
	  },
	  onComplete: {
		title: "Email on training completion",
		enabled: "Send results email when athlete marks as completed"
	  },
	  metrics: {
		duration: "Duration",
		distance: "Distance",
		calories: "Calories",
		pace: "Average pace",
		hr: "Average HR"
	  },
	  warnings: {
		defaultPrefs: "Preferences could not be loaded (using default values)."
	  },
	  success: {
		saved: "✅ Preferences saved.",
		testSent: "✓ Test email sent successfully."
	  },
	  errors: {
		noTrainerInSession: "No trainerId found in session.",
		saveNoEndpoint: "⚠️ Could not save to any endpoint. Check that the backend route exists.",
		saveGeneric: "❌ Error saving preferences.",
		testSendFailed: "⚠️ Could not send the test. Check the backend."
	  },
	  sending: "Sending..."
	},
	
	weekSelector: {
	  week: 'Week',
	groupApplyPlan: {
		title: 'Apply plan to group',
		searchPlan: 'Search plan…',
		templatePlan: 'Template / Plan',
		startDate: 'Start date',
		overwrite: 'Overwrite if exists',
		applyToGroup: 'Apply to group',
		loading: 'Loading…',
		noResults: 'No results',
		successSummary: '✅ Plan applied to {{athletes}} athlete(s). Activities created/updated: {{createdOrUpdated}}{{skipped}}',
		skipped: 'skipped',
		noMembers: 'This group has no members.',
		generalError: 'Could not apply the template.',
		haveIdQuestion: 'Have an ID?',
		enterManually: 'Enter manually',
		backToList: 'Back to list',
		idPlaceholder: 'Template / plan ID',
		includeLibrary: 'Include public library',
		selected: 'Selected',
		session: 'Session'
	},
	  selectDate: 'Select a date (week anchor)',
	  today: 'Today',
	  prev: 'PREV',
	  next: 'NEXT'
	},
	
	activitySummary: {
	  loading: 'Loading...',
	  noData: 'No data found',
	  loadError: 'There was an error loading the data',
	  title: 'Activity Summary',
	  routeMap: 'Route Map',
     charts: 'Consolidated Activity Chart',
	  altimetry: 'Altimetry Summary',
	  elevationGain: 'Elevation gain',
	  zones: 'Zone Distribution',
	  trainingEffects: 'Training Effects',
	  laps: 'Lap Details',
	  indicator: 'Indicator',
	  value: 'Value',
	  interpretation: 'Interpretation',
	  notAvailable: 'Not available',
	  vo2max: 'VO₂ max',
	  vo2Description: 'Estimated based on distance and duration.'
	},

	pmcPane: {
	  title: 'Banister Model – CTL / ATL / TSB',
	  range: 'Range',
	  rangeDaysAriaLabel: 'Day range',
	  whatIf: 'What-if (projection)',
	  days: 'Days',
	  totalTss: 'Total TSS (upcoming days)',
	  pattern: 'Pattern',
	  patternEven: 'Even',
	  patternPolarized: 'Polarized (pronounced peaks)',
	  todayTsb: 'Today TSB',
	  ctlToday: 'CTL today',
	  whatIfLabel: 'What-if',
	  whatIfDisabled: 'Disabled',
	  whatIfProjection: 'Projected TSB in {{days}}d: {{tsb}} (TSS {{tss}}, pattern {{pattern}})',
	  whatIfHint: 'Use the projection to adjust volume/intensity.',
	  loading: 'Loading…',
	  noData: 'No data in the selected range.',
	  chartAriaLabel: 'CTL, ATL (left axis) and TSB (right axis, with bands) chart – amCharts 5',
	  chartAriaLabelAmCharts: 'ATL/CTL (left axis) and TSB (right axis) chart with shaded weekends and projection – amCharts 5',
	  chartFootnote: 'Left axis: CTL/ATL. Right axis: TSB with color bands (≤−20 risk, −20…−10 tired, −10…+10 optimal, ≥+10 fresh). Dashed lines = projection.',
	  chartFootnoteAmCharts: 'Left axis: CTL/ATL. Right axis: TSB with ±10 guide lines. Honey background = weekends. Blue background = projection.',
	  seriesFitness: 'Fitness (CTL)',
	  seriesFatigue: 'Fatigue (ATL)',
	  seriesForm: 'Form (TSB)',
	  seriesCtlProj: 'CTL (projection)',
	  seriesAtlProj: 'ATL (projection)',
	  seriesTsbProj: 'TSB (projection)',
	  seriesProjection: 'Projection',
	  yLeftLabel: 'CTL / ATL',
	  yRightLabel: 'TSB',
	  tsb: {
	    highRiskLevel: 'High risk',
	    highRiskMsg: 'High fatigue, reduce load (rest/easy run).',
	    tiredLevel: 'Tired',
	    tiredMsg: 'Monitor; keep intensity controlled.',
	    optimalLevel: 'Optimal',
	    optimalMsg: 'Good range for key sessions.',
	    freshLevel: 'Fresh',
	    freshMsg: 'Fresh; you can plan intense load if the cycle requires it.',
	  },
	  ramp: {
	    highLevel: 'High',
	    highMsg: 'CTL increase > +8 in 7d (aggressive).',
	    moderateLevel: 'Moderate',
	    moderateMsg: 'Moderate CTL increase (+5 to +8).',
	    softLevel: 'Soft',
	    softMsg: 'Soft CTL increase.',
	    declineLevel: 'Declining',
	    declineMsg: 'CTL declining (possible taper/recovery).',
	  },
	  diagButton: 'AI Diagnosis',
	  diagAnalyzing: 'Analyzing…',
	  diagButtonTitle: 'Analyze CTL/ATL/TSB and suggest actions',
	  diagMarkersLabel: 'Chart markers',
	  diagTitle: 'AI Diagnosis:',
	  diagSourceLLM: 'LLM Model',
	  diagSourceHeuristic: 'Local heuristic',
	  diagFindings: 'Findings',
	  diagSuggestions: 'Suggestions',
	  diagLegendRisk: 'Risk',
	  diagLegendTired: 'Tired',
	  diagLegendFresh: 'Fresh',
	  diagErrorTimeout: 'AI took too long; showing heuristic diagnosis.',
	  diagErrorDemoMode: 'Groq active as AI provider.',
	  diagErrorNoText: 'No AI text.',
	  diagError401: 'OpenAI key lacks sufficient permissions (401). Use an API key with the right scope.',
	  diagError429: 'OpenAI quota exceeded (429). Check plan and billing.',
	  diagErrorFrontTimeout: 'AI call timed out (timeout).',
	  diagErrorGeneric: 'Diagnosis error',
	},

	activityDetails: {
	  // ActivityActions
	  copyNotImplemented: 'Copy activity function not yet implemented.',
	  movePrompt: 'Enter the new date (YYYY-MM-DD):',
	  movedTo: 'Activity moved to: {{date}}',
	  saving: 'Saving...',
	  close: 'Close',
	  // ActivityDetailsForm
	  titleLabel: 'Title',
	  untitled: 'Untitled',
	  descriptionLabel: 'Description',
	  descriptionPlaceholder: 'Enter a description',
	  preComments: 'Pre-activity comments',
	  postComments: 'Post-activity comments',
	  // ActivityDuration
	  durationLabel: 'Duration',
	  // ActivityFileUpload / ActivityProfile
	  uploadFit: 'Upload FIT File',
	  profileAlt: 'Profile',
	  nameNotAvailable: 'Name not available',
	  dateNotSelected: 'Date not selected',
	  // ActivityHeader
	  detailsOf: 'Activity Details: {{title}}',
	  // ActivityMetricsTable
	  additionalMetrics: 'Additional metrics',
	  metricLabel: 'Metric',
	  avgLabel: 'Avg',
	  maxLabel: 'Max',
	  unitLabel: 'Unit',
	  avgPaceMetric: 'Avg Pace',
	  heartRateMetric: 'Heart Rate',
	  cadenceMetric: 'Cadence',
	  speedMetric: 'Speed',
	  vo2maxMetric: 'Estimated VO₂ max',
	  gapMetric: 'GAP (adjusted pace)',
	  gapAdjusted: 'Adjusted GAP',
	  gapAdjustedFormula: 'Pace + GAP',
	  gapTitle: 'GAP (Grade Adjusted Pace)',
	  gapDescription: 'estimates what your pace would be on flat terrain. The adjusted GAP is the sum of your average pace plus that altimetry-based adjustment.',
	  // ActivityPlannedCompletedTable
	  plannedVsCompleted: 'Planned vs Completed',
	  plannedLabel: 'Planned',
	  completedLabel: 'Completed',
	  durationField: 'Duration',
	  distanceField: 'Distance',
	  avgPaceField: 'Avg pace',
	  caloriesField: 'Calories',
	  elevationGainField: 'Elevation gain',
	  // RunningActivityModal
	  fitFileLoaded: '.fit file loaded',
	  noFitFile: 'No .fit file',
	  sportsTabsAriaLabel: 'Sports',
	  // RunningActivityModal
	  loadingActivity: '⏳ Loading activity...',
	  activityModalTitle: 'Activity: {{title}}',
	  // Validations
	  validationDescriptionRequired: 'Description is required.',
	  validationPlannedRequired: 'You must fill in at least one field in "Planned".',
	  validationTitleRequired: 'Title is required.',
	  validationTypeRequired: 'Activity type is required.',
	  validationAthleteNotFound: 'Athlete not found (assignedTo).',
	},

	running: {
	  // RunningActivityModal
	  plannedVsCompleted: 'Planned vs Completed (Running)',
	},

	cycling: {
	  // CyclingMetricsTable & CyclingMetricsSummary
	  metricsTitle: 'Cycling Metrics',
	  metric: 'Metric',
	  value: 'Value',
	  maxLabel: 'Maximum',
	  unit: 'Unit',
	  speed: 'Speed',
	  cadence: 'Cadence',
	  heartRate: 'Heart Rate',
	  temperature: 'Temperature',
	  power: 'Power',
	  vo2max: 'Estimated VO₂ max',
	  normalizedPower: 'Normalized Power (NP)',
	  ftp: 'FTP',
	  intensityFactor: 'Intensity Factor (IF)',
	  totalWork: 'Total Work',
	  wkg: 'W/kg',
	  tss: 'Training Stress Score (TSS)',
	  lthr: 'Threshold HR (LTHR)',
	  maxHR: 'Max HR',
	  ftpZones: 'FTP (Zones)',
	  avgSpeed: 'Avg Speed',
	  maxSpeed: 'Max Speed',
	  avgCadence: 'Avg Cadence',
	  maxCadence: 'Max Cadence',
	  avgHR: 'Avg HR',
	  aerobicTE: 'Aerobic TE',
	  anaerobicTE: 'Anaerobic TE',
	  avgGap: 'Avg GAP',
	  // PlannedVsCompletedCycling
	  plannedVsCompleted: 'Planned vs Completed (Cycling)',
	  planned: 'Planned',
	  completed: 'Completed',
	  duration: 'Duration',
	  distance: 'Distance',
	  avgPace: 'Avg pace',
	  calories: 'Calories',
	  elevationGain: 'Elevation gain',
	  // CyclingSummary
	  summaryTitle: 'Cycling Summary',
	  // CyclingActivityModal
	  activityMetrics: 'Activity Metrics',
	  activitySummary: 'Activity Summary',
	  tssInterpretation: 'TSS Interpretation:',
	  geoMap: 'Geolocation Map',
	  elevationProfile: 'Elevation Profile',
	  powerChart: 'Power Chart',
	  lapsDetail: 'Lap Details',
	  zoneDistribution: 'Zone Distribution',
	  physiologicalAnalysis: 'Physiological Analysis',
	  validationTitle: 'Title is required.',
	  validationDescription: 'Description is required.',
	  validationPlanned: 'Complete at least one field in "Planned".',
	  saveError: 'Could not save',
	  // CyclingSummary fields
	  date: 'Date:',
	  sport: 'Sport:',
	  durationLabel: 'Duration:',
	  distanceLabel: 'Distance:',
	  caloriesLabel: 'Calories:',
	  ascentLabel: 'Ascent:',
	  descentLabel: 'Descent:',
	  tempAvg: 'Avg Temp:',
	  tempMax: 'Max Temp:',
	  tssLabel: 'TSS:',
	  ftpLabel: 'FTP:',
	  thrLabel: 'THR:',
	  avgHRLabel: 'Avg HR:',
	  maxHRLabel: 'Max HR:',
	  avgSpeedLabel: 'Avg Speed:',
	  maxSpeedLabel: 'Max Speed:',
	  avgCadenceLabel: 'Avg Cadence:',
	  maxCadenceLabel: 'Max Cadence:',
	  avgPowerLabel: 'Avg Power:',
	  maxPowerLabel: 'Max Power:',
	  npLabel: 'NP:',
	  ifLabel: 'IF:',
	  vo2maxLabel: 'VO₂max:',
	  wkgLabel: 'W/kg:',
	},

	laps: {
	  // LapsTable (running)
	  dashboardTitle: 'Lap Dashboard',
	  dashboardCyclingTitle: 'Lap Dashboard - Cycling',
	  gapFormula: 'GAP Formula:',
	  total: 'Total',
	  lap: 'Lap',
	  duration: 'Duration',
	  accumulatedTime: 'Accumulated Time',
	  distance: 'Distance',
	  distanceKm: 'Distance (km)',
	  avgPace: 'Avg Pace',
	  maxPace: 'Max Pace',
	  avgGap: 'Avg GAP',
	  calories: 'Calories',
	  ascent: 'Ascent',
	  ascentM: 'Ascent (m)',
	  descent: 'Descent',
	  descentM: 'Descent (m)',
	  avgHR: 'Avg Heart Rate',
	  maxHR: 'Max Heart Rate',
	  avgHRShort: 'Avg HR',
	  maxHRShort: 'Max HR',
	  avgSpeed: 'Avg Speed',
	  maxSpeed: 'Max Speed',
	  avgSpeedKmh: 'Avg Speed (km/h)',
	  maxSpeedKmh: 'Max Speed (km/h)',
	  avgSpeedShort: 'Avg Speed (km/h)',
	  maxSpeedShort: 'Max Speed (km/h)',
	  avgCadence: 'Avg Cadence',
	  avgCadenceShort: 'Avg Cadence',
	  avgTemp: 'Avg Temp.',
	  maxTemp: 'Max Temp.',
	  avgTempShort: 'Avg Temp.',
	  maxTempShort: 'Max Temp.',
	  np: 'NP',
	  avgPower: 'Avg Power',
	  maxPower: 'Max Power',
	  wkg: 'W/kg',
	},

	swimming: {
		strokeExcellent: '🥇 Excellent technique',
		strokeGood: '👍 Good efficiency',
		strokeAcceptable: '👌 Acceptable',
		strokeImprove: '⚠️ Can improve',
	  metricsTitle: 'Swimming Metrics',
	  summaryTitle: 'Swimming Summary',
	  plannedVsCompleted: 'Planned vs Completed (Swimming)',
	  lapsTitle: '🏊 Lap Dashboard - Swimming',
	  metric: 'Metric',
	  planned: 'Planned',
	  completed: 'Completed',
	  unit: 'Unit',
	  avg: 'Avg',
	  max: 'Max',
	  speed: 'Speed',
	  cadence: 'Cadence',
	  heartRate: 'Heart Rate',
	  power: 'Power',
	  loading: 'Loading...',
	  noData: 'No data found',
	  loadError: 'There was an error loading the data',
	  notAvailable: 'Not available',
	  notCalculated: 'Not calculated',
	  date: 'Date:',
	  sport: 'Sport:',
	  totalTime: 'Total time:',
	  movingTime: 'Moving time:',
	  elapsedTime: 'Elapsed time:',
	  distance: 'Distance:',
	  calories: 'Calories:',
	  avgHR: 'Avg HR:',
	  maxHR: 'Max HR:',
	  cadenceLabel: 'Cadence:',
	  laps: 'Laps:',
	  lengths: 'Lengths:',
	  poolLength: 'Pool length:',
	  tte: 'TTE:',
	  tea: 'TEA:',
	  tss: 'TSS:',
	  vo2max: 'VO₂max:',
	  avgPace: 'Avg pace:',
	  swolf: 'Swolf:',
	  totalStrokes: 'Total strokes:',
	  strokesPer100m: 'Strokes/100m:',
	  strokesPerMin: 'Stroke rate:',
	  duration: 'Duration',
	  distanceM: 'Distance (m)',
	  avgHRShort: 'Avg HR',
	  maxHRShort: 'Max HR',
	  avgSpeedKmh: 'Avg Speed (km/h)',
	  maxSpeedKmh: 'Max Speed (km/h)',
	  avgCadence: 'Cadence',
	  strokes: 'Strokes',
	  accumulatedTime: 'Accumulated Time',
	  lap: 'Lap',
	  total: 'Total',
	  durationField: 'Duration',
	  distanceField: 'Distance',
	  avgPaceField: 'Avg pace',
	  caloriesField: 'Calories',

	  // SwimmingHeartRateHistogram
	  heartRateHistogramTitle: 'Heart Rate Histogram (per Lap)',
	  heartRateAxisLabel: 'Avg HR (bpm)',
	  heartRateSeries: 'Avg HR',
	  // SwimmingDashboard
	  dashboardTitle: 'Swimming Training Summary',
	  paceLabel: 'Pace (s/100m)',
	  strokesLabel: 'Total Strokes',
	  hrLabel: 'Avg HR',
	  distanceLabel: 'Distance (m)',
	  swolfLabel: 'Swolf',
	  paceAxisLabel: 'Pace (s/100m)',
	  rightAxisLabel: 'Strokes / HR / Distance',
	  swolfAxisLabel: 'Swolf',
	  // SwimmingMetricsTable
	  sessionMetrics: 'Session Metrics',
	  avgSpeed: 'Avg Speed',
	  maxSpeed: 'Max Speed',
	  avgCadenceLabel: 'Avg Cadence',
	  trainingEffect: 'Training Effect',
	  // SwimmingPhysiologicalAnalysis
	  physiologicalTitle: '📊 Swimming Physiological Analysis',
	  physiologicalChartTitle: '📈 Physiological Metrics Visualization',
	  physioP1: 'During this session, the athlete swam {{distance}} meters in {{duration}}, achieving an average pace of {{pace}}.',
	  physioP2TTE: 'The Training Effect (TTE) was {{tte}}, indicating {{ttInterp}}. The Anaerobic Effect (TEA) reached {{tea}}, suggesting {{teaInterp}}.',
	  physioP3TSS: 'The TSS was {{tss}}, representing a {{load}} training load over a {{duration}}-minute session.',
	  physioLoadHigh: 'high',
	  physioLoadModHigh: 'moderate-high',
	  physioLoadMod: 'moderate or low',
	  physioP4VO2: 'Estimated VO₂ max was {{vo2}} ml/kg/min{{msg}}, useful for evaluating aerobic capacity. The average Swolf was {{swolf}}, an indicator of technical efficiency.',
	  physioP5HR: 'Average heart rate was {{avgHR}} bpm, reaching a maximum of {{maxHR}} bpm.',
	  validationTitle: 'Title is required.',
	  validationDescription: 'Description is required.',
	  validationPlanned: 'Complete at least one field in "Planned".',
	  saveError: 'Could not save',
	  activityMetrics: 'Activity Metrics',
	  activitySummary: 'Activity Summary',
	  tssInterpretation: 'TSS Interpretation:',
	  lapsDetail: 'Lap Details',
	  zoneDistribution: 'Zone Distribution',
	  physiologicalAnalysis: 'Physiological Analysis',
	},

	strength: {
		noHRZones: 'No heart rate zone data recorded for this session.',
	  metricsTitle: 'Strength Metrics',
	  summaryTitle: 'Strength Summary',
	  plannedVsCompleted: 'Planned vs Completed (Strength)',
	  lapsTitle: '💪 Lap Dashboard - Strength',
	  metric: 'Metric',
	  planned: 'Planned',
	  completed: 'Completed',
	  unit: 'Unit',
	  avg: 'Avg',
	  max: 'Max',
	  loading: 'Loading...',
	  noData: 'No data found',
	  loadError: 'There was an error loading the data',
	  notAvailable: 'Not available',
	  date: 'Date:',
	  sport: 'Sport:',
	  totalTime: 'Total time:',
	  movingTime: 'Moving time:',
	  elapsedTime: 'Elapsed time:',
	  calories: 'Calories:',
	  avgHR: 'Avg HR:',
	  maxHR: 'Max HR:',
	  tempAvg: 'Avg Temp:',
	  tempMax: 'Max Temp:',
	  totalCycles: 'Total Cycles:',
	  numLaps: 'Number of Laps:',
	  tte: 'TTE:',
	  tea: 'TEA:',
	  hrTss: 'hrTSS:',
	  ftp: 'FTP:',
	  maxHRTarget: 'Max HR Target:',
	  thresholdHR: 'Threshold HR:',
	  duration: 'Duration',
	  repetitions: 'Repetitions',
	  sets: 'Sets',
	  caloriesField: 'Calories',
	  te: 'TE',
	  lap: 'Lap',
	  total: 'Total',
	  distanceM: 'Distance (m)',
	  avgHRShort: 'Avg HR',
	  maxHRShort: 'Max HR',
	  avgSpeedKmh: 'Avg Speed (km/h)',
	  maxSpeedKmh: 'Max Speed (km/h)',
	  avgCadence: 'Cadence',
	  strokes: 'Strokes',
	  accumulatedTime: 'Accumulated Time',
	  validationTitle: 'Title is required.',
	  validationDescription: 'Description is required.',
	  validationPlanned: 'Complete at least one field in "Planned".',
	  saveError: 'Could not save',
	  activityMetrics: 'Activity Metrics',
	  activitySummary: 'Activity Summary',
	  tssInterpretation: 'TSS Interpretation:',
	  lapsDetail: 'Lap Details',
	  zoneDistribution: 'Zone Distribution',
	  physiologicalAnalysis: 'Physiological Analysis',
	},

	trainingZones: {
	  thresholdValues: 'Threshold Values',
	  thresholdHR: 'Threshold Speed',
	  thresholdPower: 'Threshold Power (CP)',
	  thresholdSwim: 'Critical Swim Speed (CSS)',
	  thresholdHeartRate: 'Threshold Heart Rate',
	  maxHeartRate: 'Max Heart Rate',
	  restingHeartRate: 'Resting Heart Rate',
	  thresholdSpeed: 'Threshold Speed (mm:ss)',
	  ftpWatts: 'FTP (Watts)',
	  cssLabel: 'CSS (min/100m)',
	  ftpPlaceholder: 'Ex: 220',
	  cssPlaceholder: 'Ex: 1:45',
	  speedPlaceholder: 'mm:ss',
	  calcFC: 'Calculate Heart Rate Zones',
	  saveFC: 'Save HR Data',
	  calcVP: 'Calculate Speed/Pace Zones',
	  saveVP: 'Save Speed/Pace Data',
	  calcCP: 'Calculate Power Zones',
	  saveCP: 'Save Power Data',
	  calcSWIM: 'Calculate Swimming Zones',
	  saveSWIM: 'Save Swimming Data',
	  backToDashboard: 'Back to Dashboard',
	  colZone: 'Zone',
	  colMin: 'Min',
	  colMax: 'Max',
	  thresholdBpm: 'Threshold: {{value}} bpm',
	  thresholdMinKm: 'Threshold: {{value}} min/km',
	  thresholdWatts: 'Threshold: {{value}} watts',
	  thresholdMinPer100m: 'Threshold: {{value}} min/100m',
	  invalidUserId: 'Error: invalid user ID',
	  noZonesFC: 'Please calculate HR zones before saving.',
	  noZonesVP: 'Please calculate Speed/Pace zones before saving.',
	  noZonesCP: 'Please calculate Power zones before saving.',
	  noZonesSWIM: 'Please calculate Swimming zones before saving.',
	  invalidFtp: 'Please enter a valid FTP value.',
	  invalidCss: 'Please enter a valid time in mm:ss format',
	  savedFC: 'Heart Rate data saved successfully.',
	  savedVP: 'Speed/Pace data saved successfully.',
	  savedCP: 'Power data saved successfully.',
	  savedSWIM: 'Swimming Pace data saved successfully.',
	  saveError: 'Error saving data: {{message}}',
	  // Zone names FC
	  zoneFC: {
	    z1: 'Z1 Recovery',
	    z2: 'Z2 Aerobic',
	    z3: 'Z3 Tempo',
	    z4: 'Z4 Sub-Threshold',
	    z5a: 'Z5a Super-Threshold',
	    z5b: 'Z5b Aerobic Capacity',
	    z5c: 'Z5c Anaerobic Capacity',
	  },
	  // Zone names VP
	  zoneVP: {
	    z1: 'Z1 Recovery',
	    z2: 'Z2 Aerobic',
	    z3: 'Z3 Tempo',
	    z4: 'Z4 Sub-Threshold',
	    z5a: 'Z5a Super-Threshold',
	    z5b: 'Z5b Aerobic Capacity',
	    z5c: 'Z5c Anaerobic Capacity',
	  },
	  // Zone names CP
	  zoneCP: {
	    z1: 'Z1 Recovery',
	    z2: 'Z2 Aerobic',
	    z3: 'Z3 Tempo',
	    z4: 'Z4 Sub-Threshold',
	    z5: 'Z5 Threshold Limit',
	    z6: 'Z6 Anaerobic Capacity',
	    z7: 'Z7 Neuromuscular Power',
	  },
	  // Zone names SWIM
	  zoneSWIM: {
	    z1: 'Z1 Recovery',
	    z2: 'Z2 Aerobic',
	    z3: 'Z3 Tempo',
	    z4: 'Z4 Threshold',
	    z5: 'Z5 Speed',
	    z6: 'Z6 Anaerobic',
	  },
	},

	elevationProfile: {
          axisPowerBpm: 'W / bpm',
          seriesAltitudePlain: 'Altitude (m)',
          seriesSpeed: 'Speed (KPH)',
          seriesPowerCycling: 'Power (W)',
          axisAltFcTemp: 'Altitude / HR / Temp',
          axisSpeedCadPower: 'Speed / Cadence / Power',
          axisPower: 'Power (W)',
          axisLap: 'Lap',
          axisAltitude: 'Altitude (m)',
          axisCadence: 'Cadence (rpm)',
          axisTemp: 'Temp (°C)',
          seriesAltitudeImproved: 'Improved altitude (m)',
          seriesPaceAvg: 'Avg. pace (min/km)',
          seriesCadence: 'Cadence (rpm)',
          seriesTemp: 'Temperature (°C)',
          altMax: 'Max alt.',
          altMin: 'Min alt.',
          hrLapSeriesLabel: 'Average HR per lap',
          axisDistance: 'Distance (km)',
          axisElevation: 'Elevation (m)',
          axisBpm: 'bpm',
          axisPaceMinKm: 'min/km',
          seriesElevation: 'Elevation (m)',
          seriesHr: 'HR (bpm)',
          seriesPaceReal: 'Real pace (min/km)',
          seriesGapAdjusted: 'Adjusted pace — GAP',
          consolidatedChartTitle: 'Consolidated Activity Chart',
          hrLapHistogramTitle: 'Heart Rate Histogram (by Lap)',
          hrTimeChartTitle: 'Heart Rate (by Time)',
	  loading: 'Loading elevation profile...',
	  loadingCycling: 'Loading cycling elevation profile...',
	  title: 'Elevation Profile',
	  titleCycling: 'Cycling Elevation Profile with Power',
	  totalDistance: 'Total Distance:',
	  maxElevation: 'Max Elevation:',
	  minElevation: 'Min Elevation:',
	  positiveSlope: 'Accumulated Positive Slope:',
	  normalizedPower: 'Normalized Power (NP):',
	  intensityFactor: 'Relative Intensity (IF):',
	},

	social: {
	  tzoneCommunity: 'Tzone Community',
	  myCommunityProfile: 'My Tzone Community Profile',
	  community: 'Community',
	  myAthlete: 'My athlete',
	  backToCommunity: 'Back to Community',
	  backToCommunityHome: 'Back to Community Home',
	  backToTzoneCommunity: 'Back to Tzone Community',
	  publishOnSocialMedia: 'Post on social media',
	  shareRoute: 'Share route (FIT)',
	  shareActivityFit: 'Share activity (FIT)',
	  shareInChat: 'Share in chat',
	  shareWithContact: 'Share with a contact',
	  share: 'Share',
	  generating: 'Generating…',
	  shareSession: 'Share session',
	  sharePng: 'Share PNG (Web Share if available)',
	  shareSelectedEvent: 'Share selected event',


	  loadingResumen: 'Loading summary...',
	  duracion: 'Duration',
	  verDetalleDia: 'View day detail',
	  diaDescanso: 'Rest Day',
	  sesionLabel: 'Session',
	  elvMas: 'ELV +',
	  comparteConContactos: 'Share a session with your match contacts.',
	  compartirSesionTitle: 'Share session',
	  compartirSesionSteps: '1) Choose session - 2) Choose contact - 3) Send',
	  sesionDelDia: 'Session of the day',
	  cargandoContactos: 'Loading contacts...',
	  escribeMensaje: 'Write a message...',
	  generaPng: 'Generate PNG (without sending)',
	  vistaPrevia: 'Preview (this is captured)',
	  tzoneDomain: 'tzone.run',
	  generaCard: 'Generate the 1080x1920 card and share it',
	  noSoportaCompartir: 'Your browser does not support file sharing. The PNG was downloaded.',
	  noPudoCompartir: 'Could not share. Try Download PNG.',
	  seleccionaContacto: 'Select a contact first.',
	  selectRequiredOption: 'Select the required option:',
	  pasteActivityText: 'Paste copied activity on',

	  descriptionRequired: 'Description is required.',
	  indicateValue: 'Please indicate the planned value.',
	  durationFormat: 'Duration must be hh:mm:ss (e.g. 01:30:00).',
	  distanceFormat: 'Distance must be a number in kilometers (e.g. 13 or 13.5).',
	  completeTitleDescriptionValue: 'Please complete description and value.',
	  excelReadError: 'Could not read the Excel file. Please check the file.',
	  planNameRequired: 'Please enter the plan name.',
	  totalDaysMustBePositive: 'Total days must be greater than 0.',
	  addAtLeastOneActivity: 'Add at least one activity.',
	  templateCreatedWithPlanning: 'Template created with planning.',
	  couldNotCreateTemplate: 'Could not create the template.',
	  activityTitlePlaceholder: 'E.g. Easy run, 6x1000 intervals, Lower body strength...',
	  plannedMetric: 'Planned metric',
	  activityDescriptionPlaceholder: 'Detailed description of the session',
	  supportsValueRight: 'Supports value to the right of Planned.',
	  planWizard: {
	    step1: '1. Goal',
	    step2: '2. Anchor and Availability',
	    step3: '3. Parameters',
	    step4: '4. Preview',
	    includesBricks: 'Includes bricks and distribution by discipline.',
	    wednesday: 'Wednesday',
	    saturday: 'Saturday',
	    elevPlaceholder: 'e.g. 1200',
	    elevGoal: 'm+ goal',
	  },
	  importExcel: {
	    title: 'Excel Import Guide',
	    sportRequired: 'Sport (required) must be written exactly as shown in this list.',
	    sportExample: 'E.g.: Swim correct, Swimming incorrect.',
	    allowedValues: 'Allowed values (as shown)',
	    expectedColumns: 'Expected columns',
	    exampleBySpot: 'Example by sport',
	  },
	  elevationProfile: {
          axisPowerBpm: 'W / bpm',
          seriesAltitudePlain: 'Altitude (m)',
          seriesSpeed: 'Speed (KPH)',
          seriesPowerCycling: 'Power (W)',
          axisAltFcTemp: 'Altitude / HR / Temp',
          axisSpeedCadPower: 'Speed / Cadence / Power',
          axisPower: 'Power (W)',
          axisLap: 'Lap',
          axisAltitude: 'Altitude (m)',
          axisCadence: 'Cadence (rpm)',
          axisTemp: 'Temp (°C)',
          seriesAltitudeImproved: 'Improved altitude (m)',
          seriesPaceAvg: 'Avg. pace (min/km)',
          seriesCadence: 'Cadence (rpm)',
          seriesTemp: 'Temperature (°C)',
          altMax: 'Max alt.',
          altMin: 'Min alt.',
          hrLapSeriesLabel: 'Average HR per lap',
          axisDistance: 'Distance (km)',
          axisElevation: 'Elevation (m)',
          axisBpm: 'bpm',
          axisPaceMinKm: 'min/km',
          seriesElevation: 'Elevation (m)',
          seriesHr: 'HR (bpm)',
          seriesPaceReal: 'Real pace (min/km)',
          seriesGapAdjusted: 'Adjusted pace — GAP',
          consolidatedChartTitle: 'Consolidated Activity Chart',
          hrLapHistogramTitle: 'Heart Rate Histogram (by Lap)',
          hrTimeChartTitle: 'Heart Rate (by Time)',
	    loading: 'Loading elevation profile...',
	    loadingCycling: 'Loading cycling elevation profile...',
	    title: 'Elevation Profile',
	    titleCycling: 'Cycling Elevation Profile with Power',
	    totalDistance: 'Total Distance:',
	    maxElevation: 'Max Elevation:',
	    minElevation: 'Min Elevation:',
	    positiveSlope: 'Accumulated Positive Slope:',
	    normalizedPower: 'Normalized Power (NP):',
	    intensityFactor: 'Relative Intensity (IF):',
	  },
	  shareBoard: {
	    availableEvents: 'Available events (drag or click)',
	    dragToAthlete: 'Drag to an athlete (or click to select)',
	    myAthletes: 'My athletes (drop or button)',
	    noAthletes: 'You have no assigned athletes or could not load.',
	    dropEvent: 'Drop an event here',
	  },
	  meetupForm: {
	    gpxFile: 'GPX file (optional)',
	    showAddressOnly: 'Show exact address and phone only to registered participants',
	  },
	  messagesInbox: {
	    sharedMessages: 'Shared messages will appear here (text + map).',
	    loadingConversation: 'Loading conversation...',
	  },
	  adminPanel: {
	    noPermission: 'You do not have permission to view this panel.',
	    confirmDelete: 'Are you sure you want to delete this trainer?',
	    enterEmail: 'Please enter an email to invite.',
	    title: 'Trainer Administration',
	    emailPlaceholder: 'Trainer email address',
	    searchPlaceholder: 'Search by name or email...',
	  },

    superAdmin: {
      title: "Super Admin",
      users: "users",
      trainers: "trainers",
      withLab: "with LAB",
      blocked: "blocked",
      logout: "Log out",
      allRoles: "All roles",
      refresh: "Refresh",
      results: "results",
      searchPlaceholder: "Search by name, email, username...",
      colUser: "User",
      colEmail: "Email",
      colRole: "Role",
      colStatus: "Status",
      colLab: "LAB",
      colRegistered: "Registered",
      colActions: "Actions",
      active: "active",
      block: "Block",
      unblock: "Activate",
      delete: "Delete",
      protected: "Protected",
      noUsers: "No users found",
      confirmDelete: "Delete {{name}}? This action cannot be undone.",
      confirmDeleteTitle: "Confirm deletion",
      confirmDeleteBtn: "Yes, delete",
      cancel: "Cancel",
      labActivated: "LAB access activated",
      labRevoked: "LAB access revoked",
      labError: "Error updating LAB access",
      actionError: "Error executing action",
      loadError: "Error loading users",
    },
	  lapsStrength: {
	    distanceM: 'Distance (m)',
	    avgHR: 'Avg HR',
	    maxHR: 'Max HR',
	  },
	  meetupDetail: {
	    emergencyPhone: 'Emergency phone:',
	    meetingMap: 'Meeting map:',
	  },
	  physio: {
	    vo2max: 'Estimated VO2 max',
	    intensityFactor: 'Intensity Factor (IF)',
	    tss: 'Training Stress Score (TSS)',
	    avgHR: 'Average heart rate',
	    normalizedPower: 'Normalized Power (NP)',
	    tte: 'Time to exhaustion (TTE)',
	    anaerobicTE: 'Anaerobic Training Effect (TEA)',
	    trainingEffect: 'Training Effect (TTE)',
	  },
	  cycleWizard: {
	    swimming: 'Swimming',
	    triathlon: 'Triathlon',
	    raceDay: 'Race day (recommended)',
	    longDay: 'Long day (run)',
	    timeGoal: 'Time goal (optional)',
	    back: 'Back',
	  },
	  shareTrainingCard: {
	    autoPhoto: 'Auto: photo if available; otherwise map',
	    generatingMap: 'Generating map...',
	  },
	  activityMetrics: {
	    cycling: 'Cycling Metrics',
	    metric: 'Metric',
	    additional: 'Additional Metrics',
	  },
	  insights: {
	    next24h: 'Next 24-48h',
	    nextKeySession: 'Next key session',
	  },
	  workoutModal: {
	    selectWorkout: 'Select a workout:',
	  },
	  summary: {
	    vo2max: 'VO2 max:',
	    debugTss: 'Debug TSS:',
	  },
	  trainerLibrary: {
	    intensityPlaceholder: 'base | threshold | vo2 | easy | tempo...',
	  },
	  guest: 'Guest',
	  athleteFallback: 'Athlete',
	  trainerFallback: 'Coach',
	  tzoneUser: 'Tzone User',
	  searchPartner: 'Find partner',
	  myContacts: 'My contacts',
	  messages: 'Messages',
	  meetups: 'Meetups',
	  myProfile: 'My profile',
	  logout: 'Log out',
	  findTrainingPartner: 'Find your training partner',
	  heroDescription: 'Connect with athletes who share your sport, level, and goals: running, cycling, triathlon, fitness training, and more. Only for registered Tzone users.',
	  organizeMeetup: 'Organize meetup',
	  viewMeetupsBoard: 'View meetups board',
	  heroNote: 'We will use your training data (pace, distance, general location) only to suggest compatible partners.',
	  last7DaysResult: 'Your results from the last 7 days.',

	  weeklySpotlight: {
	    title: 'Your week',
	    weekRange: 'Week: {{start}} → {{end}} (Mon–Sun)',
	    weekNavAriaLabel: 'Week navigation',
	    goToBoard: 'Go to board',
	    backToBoard: 'Back to board',
	    share: 'Share',
	    shareWithContact: 'Share with a contact',
	    generating: 'Generating…'
	  },
	  contact: 'Contact',
	  loadingMutualContacts: 'Loading mutual contacts...',
	  viewMutualContacts: 'View mutual contacts',
	  searchingMutualContacts: 'Searching mutual contacts…',
	  mutualContacts: 'mutual contacts',
	  connectedBy: 'Connected by:',
	  and: 'and',
	  viewAll: 'View all',
	  goal: 'Goal',
	  noMorePartners: 'No more partners to show right now.',
	  loadingRecommendations: 'Loading recommendations…',
	  mutualConnections: 'Mutual connections',
	  mutualConnectionsDescription: 'These contacts have a match with you and with {{name}}.',
	  connectionPath: 'You ↔ {{name}} ↔ {{currentCardName}}',
	  close: 'Close',
	  itsAMatch: "It's a match!",
	  matchDescription: {
		before: 'You can now chat in',
		after: 'In male–female matches, the woman sends the first message.'
	  },
	  goToMessages: 'Go to messages',
	  keepSearching: 'Keep searching',

	  search: 'Search',
	  closeSearch: 'Close search',
	  searchPartnersPlaceholder: 'Search partners...',
	  explore: 'Explore',
	  results: 'Results',
	  searching: 'searching…',
	  noResultsFound: 'No results found.',
	  noUsersToExplore: 'No users to explore.',
	  ignore: 'Ignore',
	  connect: 'Connect',
	  block: 'Block',
	  report: 'Report',
	  userFallback: 'User',
	  invalidSessionUserId: 'Invalid session: userId not found or corrupted (localStorage).',
	  matchReviewMessages: "It's a match! Check Messages 😉",
	  requestSent: 'Request sent ✅',
	  blockPendingEndpoint: 'Block: endpoint pending ✅',
	  reportPendingEndpoint: 'Report: endpoint pending ✅',
	  partner: 'Partner',
	  partnerTzone: 'Tzone Partner',
	  loading: 'Loading…',

	  errors: {
		loadRecommendations: 'We could not load recommendations. Please try again later.',
		searchFailed: 'We could not perform the search right now.',
		connectFailed: 'Could not connect.',
		sendRequestFailed: 'Error sending request.'
	  },

	  profile: {
		loading: 'Loading your profile…',
		subtitle: 'Enable your profile to appear in training partner searches.',
		savedSuccess: 'Profile updated successfully.',
		enableProfile: 'Enable my community profile',
		displayName: 'Display name',
		displayNamePlaceholder: 'Ex: Carla, runner from Las Condes',
		city: 'City',
		cityPlaceholder: 'City',
		country: 'Country',
		countryPlaceholder: 'Country',
		bio: 'Bio',
		bioPlaceholder: 'Tell others how you train and what you are looking for in a partner.',
		partnerPreferences: 'Partner preferences',
		partnerPreferencesHint: 'Who are you interested in connecting with in the community?',
		basicInfo: 'Basic info',
		sportsSection: 'Sports',
		sportsHint: 'Select the sports you practice. This helps find better partners.',
		sportsOptions: {
		  running: 'Running',
		  cycling: 'Cycling',
		  trail: 'Trail',
		  swimming: 'Swimming',
		  strength: 'Strength',
		  triathlon: 'Triathlon'
		},
		addCustomSportPlaceholder: 'Another sport…',
		addCustomSport: '+ Add',
		removeSport: 'Remove {{sport}}',
		preview: 'This is how other athletes will see you',
		previewDisabledHint: 'Your profile is disabled. Turn it on to appear in community search results.',
		preferredGender: {
		  any: 'Any gender',
		  women: 'Women only',
		  men: 'Men only'
		},
		privacy: 'Privacy',
		showAge: 'Show my age',
		showGender: 'Show my gender',
		showCity: 'Show my city',
		saving: 'Saving…',
		saveProfile: 'Save profile',
		errors: {
		  userIdNotFound: 'userId was not found in localStorage.',
		  loadProfile: 'Could not load your community profile.',
		  serverConnectionLoad: 'Could not connect to the Tzone server. Check that the backend is running and CORS is configured correctly.',
		  loadGeneric: 'Error loading profile.',
		  userIdMissingSave: 'userId was not found to save the profile.',
		  saveProfile: 'Could not save your community profile.',
		  serverConnectionSave: 'Could not connect to the Tzone server while saving. Check that it is running and reachable.',
		  saveGeneric: 'Error saving profile.'
		}
	  },

	  contacts: {
		myContactsCount: 'My contacts ({{count}})',
		activeCount: 'Active ({{count}})',
		blockedCount: 'Blocked ({{count}})',
		noContacts: 'You do not have contacts yet.',
		noContactsYet: 'You do not have contacts yet.',
		loading: 'Loading contacts…',
		loadingContacts: 'Loading contacts…',
		errorLoad: 'We could not load your contacts.',
		emptyState: 'You do not have contacts or active matches yet.',
		message: 'Message',
		block: 'Block',
		unblock: 'Unblock',
		delete: 'Delete',
		deleteMatch: 'Delete match',
		communityBadge: 'Community',
		mutualContacts: 'mutual contacts',
		connectedBy: 'Connected by:',
		viewProfile: 'View profile',
		relationship: 'Relationship',
		blocked: 'Blocked',
		openChat: 'Open chat',
		chatUnavailable: 'Chat unavailable',
		notCommunityMatchShort: 'Not a community match',
		confirmDeleteMatch: 'Do you want to delete the match with {{name}}?',
		errors: {
		  currentUserNotFound: 'Current user was not found.',
		  loadContacts: 'We could not load your contacts.',
		  blockUser: 'Could not block the user.',
		  unblockUser: 'Could not unblock the user.',
		  notCommunityMatch: 'This contact is not a community match.',
		  deleteMatch: 'Could not delete the match.'
		}
	  },

	  messagesPage: {
		sharedRoute: '📍 Shared route',
		activity: 'Activity',
		loadingSummary: 'Loading summary…',
		you: 'You',
		athleteTzone: 'Tzone Athlete',
		conversations: 'Conversations',
		noConversations: 'You do not have conversations yet. Start by liking someone in the community!',
		user: 'User',
		selectConversation: 'Select a conversation to start chatting.',
		matchNowCanChat: "🔔 It's a match! You can now chat.",
		startChat: 'Start chatting',
		blockedUserNoMessages: 'Blocked user (you will not receive messages)',
		trainingPartner: 'Training partner',
		loadingMessages: 'Loading messages…',
		viewMap: 'View map',
		viewSummary: 'View summary',
		downloadGpx: 'Download GPX',
		copyFileId: 'Copy fileId',
		copy: 'Copy',
		writeMessage: 'Write a message…',
		unblockToWrite: 'This user is blocked. Unblock them to write.',
		activityDetail: 'Activity detail',
		map: 'Map',
		summaryTab: 'Summary',
		noFileIdToShow: 'There is no fileId to display.',
		title: 'Title',
		fileIdFit: 'fileId (FIT)',
		routeTitlePlaceholder: 'Ex: 🏁 Long run Chamisero',
		fileIdPlaceholder: 'Ex: 1765676279504.fit or 66f3abc123...',
		fileIdHint: 'Tip: if you already uploaded the FIT in Activities, copy its fileId and paste it here.',
		optionalUploadFitNow: '(Optional) Upload .fit now',
		uploading: 'Uploading…',
		preview: 'Preview',
		defaultRouteCaption: '🏁 Shared route',
		unblockToShareRoutes: 'This user is blocked. Unblock them to share routes.',
		confirmUnblockUser: 'Do you want to unblock this user and allow messages again?',
		confirmBlockUser: 'Are you sure you want to block this user? You will not be able to keep chatting and they will not appear in your recommendations.',
		confirmReportUser: 'Do you want to report this user for inappropriate behavior?',
		reportSuccess: 'Thanks, we have received your report.',
		summary: {
		  title: 'Summary',
		  date: 'Date',
		  sport: 'Sport',
		  duration: 'Duration',
		  distance: 'Distance',
		  avgPace: 'Avg pace',
		  avgSpeed: 'Avg speed',
		  maxSpeed: 'Max speed',
		  calories: 'Calories',
		  ascent: 'Ascent',
		  descent: 'Descent',
		  avgHeartRate: 'Avg HR',
		  maxHeartRate: 'Max HR',
		  avgCadence: 'Avg cadence',
		  maxCadence: 'Max cadence',
		  avgPower: 'Avg power',
		  maxPower: 'Max power'
		},
		errors: {
		  loadActivitySummary: 'We could not load the summary for this activity.',
		  userIdNotFound: 'userId was not found in localStorage.',
		  uploadFit: 'Could not upload the .fit file. If your backend requires activityId, upload the FIT from Activities and paste the fileId here.',
		  serverDidNotReturnFileId: 'The server did not return a fileId.',
		  blockedUserCannotMessage: 'You cannot send messages to a blocked user. Unblock them first.',
		  invalidMatchId: 'Cannot send: invalid matchId.',
		  cannotSendYet: 'You cannot send this message yet.',
		  invalidConversationMatchId: 'This conversation does not have a valid matchId to load messages.',
		  loadMessages: 'We could not load the messages for this conversation.',
		  currentUserNotFound: 'Current user was not found.',
		  loadConversations: 'We could not load your conversations.',
		  sendMessage: 'We could not send the message.',
		  validFileIdRequired: 'You must provide a valid fileId.',
		  shareRoute: 'We could not share the route. Please try again.',
		  blockUser: 'We could not block this user. Please try again.',
		  unblockUser: 'We could not unblock this user. Please try again.',
		  reportUser: 'We could not send the report. Please try again.',
		  downloadGpx: 'Could not download GPX'
		}
	  },
	  

	  
	  
	  geoLocation: {
		  loading: 'Loading...',
		  emptySession: 'No session data was found.',
		  noCoordinates: 'There are no coordinates to display on the map.',
		  elevation: {
			title: 'Route Elevation Profile',
			max: 'Maximum elevation',
			min: 'Minimum elevation'
		  },
		  map: {
			location: 'Location',
			startPoint: 'Route start point',
			endPoint: 'Route end point'
		  },
		  errors: {
			fetch: 'Error fetching the data. Please try again later.',
			missingFileId: 'No fileId was provided.'
		  }
		},

	  groupApplyPlan: {
		title: 'Apply plan to group',
		searchPlan: 'Search plan…',
		templatePlan: 'Template / Plan',
		startDate: 'Start date',
		overwrite: 'Overwrite if exists',
		applyToGroup: 'Apply to group',
		loading: 'Loading…',
		noResults: 'No results',
		successSummary: '✅ Plan successfully applied to {{athletes}} athlete(s). Activities created/updated: {{createdOrUpdated}}{{skipped}}',
		skipped: 'skipped',
		noMembers: 'This group has no members.',
		generalError: 'Could not apply the template.',
		haveIdQuestion: 'Do you have an ID?',
		enterManually: 'Enter manually',
		backToList: 'Back to list',
		idPlaceholder: 'Template / plan ID',
		includeLibrary: 'Include public library',
		selected: 'Selected',
		session: 'Session'
	  },
	  
	  

	  meetupsBoard: {
		title: 'Meetups board',
		subtitle: '1) Drag contacts into a group. 2) Drag a meetup into a group.',
		loading: 'Loading groups, meetups, and contacts…',

		actions: {
		  refresh: 'Refresh',
		  refreshing: 'Refreshing…',
		  reloadData: 'Reload data',
		  openMeetupForm: 'Open full meetup form'
		},

		tabs: {
		  all: 'All',
		  groups: 'My groups',
		  meetups: 'Meetups library',
		  contacts: 'Contacts & Match'
		},

		groups: {
		  title: 'My groups',
		  hint: 'Drop a contact here to add them to the group, or a meetup to associate it.',
		  create: 'Create group',
		  createTooltip: 'Create a new group',
		  empty: 'You do not have any groups yet.',
		  dropHere: 'Drop here',
		  dropContact: 'Drop to add contact',
		  dropMeetup: 'Drop to attach meetup',
		  unnamed: 'Unnamed group',
		  athletesCount: '{{count}} athletes',
		  meetupsCount: '{{count}} meetups',
		  manageMembers: 'Manage members',
		  closeManagement: 'Close management',
		  members: 'Members',
		  remove: 'Remove'
		},

		meetups: {
		  title: 'Meetups library',
		  hint: 'Drag a meetup into a group.',
		  empty: 'You have not created any meetups yet.',
		  untitled: 'Untitled meetup',
		  noPermissionEdit: 'No permission (different organizer)',
		  fullFormEdit: 'Edit in full form',
		  deleteTitle: 'Delete meetup',
		  dragToGroup: 'Drag into a group →',
		  thisMeetup: 'this meetup'
		},

		contacts: {
		  title: 'Contacts & Match',
		  hint: 'Drag a contact into a group to add them.',
		  empty: 'As you create matches, they will appear here.',
		  athleteFallback: 'Tzone athlete',
		  origin: 'Source',
		  unknownOrigin: 'unknown',
		  originTitle: 'Source: {{source}}',
		  matchSource: 'Match',
		  nextStep: 'Next step: add “Coached” athletes (trainer athlete list) and show both sources.'
		},

		modals: {
		  createGroup: 'Create group',
		  editGroup: 'Edit group',
		  groupName: 'Name',
		  description: 'Description',
		  backendNote: 'Note: if your backend does not yet support PUT/POST /api/social/groups, you will get an HTTP error.',
		  deleteGroupTitle: 'Delete group',
		  deleteGroupConfirm: 'Are you sure you want to delete {{name}}?',
		  deleteMeetupTitle: 'Delete meetup',
		  deleteMeetupConfirm: 'Are you sure you want to delete {{title}}?'
		},

		messages: {
		  loadingGroupsError: 'Error loading groups (HTTP {{status}})',
		  attachingMeetup: '⏳ Attaching meetup to group…',
		  meetupAttached: '✅ Meetup attached to group.',
		  addingContact: '⏳ Adding "{{name}}" to group…',
		  contactAdded: '✅ "{{name}}" added to group.',
		  draggedContactNotFound: 'Dragged contact was not found.',
		  dropWithoutPayload: 'DROP arrived without payload (no meetupId or contactId).',
		  groupNameRequired: 'Group name is required.',
		  groupCreated: '✅ Group created.',
		  groupUpdated: '✅ Group updated.',
		  groupDeleted: '✅ Group deleted.',
		  meetupDeleted: '✅ Meetup deleted.',
		  removeMemberLoading: '⏳ Removing member...',
		  memberRemoved: '✅ Member removed.',
		  missingMemberId: 'Empty memberId.',
		  missingContactUserId: 'Could not determine contact ID (empty userId).',
		  noAddMemberEndpoint: 'No add-member endpoint available'
		},

		memberLabel: 'Member',
		lastResponse: 'Last response',
		log: 'Log'
	  },

	  meetupsPanel: {
		title: 'Community meetups',
		subtitleLine1: 'Create/edit meetup + invitations + maps.',
		subtitleLine2: 'Groups and drag & drop are managed in the Board.',
		activeGroup: 'Active group:',
		backToBoard: 'Back to Board',

		form: {
		  title: 'Create or edit social meetup',
		  create: 'Create meetup',
		  saveChanges: 'Save meetup changes',
		  newEvent: '+ New meetup',
		  currentGpx: 'Current GPX:',
		  download: 'Download',
		  fields: {
			title: 'Title',
			sport: 'Sport',
			description: 'Description',
			dateTime: 'Date and time',
			maxParticipants: 'Max participants (0 = unlimited)',
			meetingAddress: 'Meeting address',
			city: 'City',
			commune: 'Commune / area',
			country: 'Country',
			emergencyPhone: 'Emergency / contact phone',
			routeUrl: 'Route URL (Strava, GPX, etc.)',
			gpxFile: 'GPX file (optional)',
			registeredOnly: 'Show exact address and phone only to registered participants'
		  },
		  sports: {
			running: 'Running',
			cycling: 'Cycling',
			swimming: 'Swimming',
			trailrunning: 'Trail',
			strength: 'Strength',
			walking: 'Walking',
			other: 'Other'
		  },
		  placeholders: {
			title: 'Sunday long run 20K',
			description: 'Easy pace 5:30-6:00/km, suitable for intermediate level...',
			meetingAddress: 'Parque Bicentenario 3236',
			city: 'Santiago',
			commune: 'Vitacura',
			country: 'Chile',
			emergencyPhone: '+56 9 1234 5678',
			routeUrl: 'https://www.strava.com/routes/...'
		  }
		},

		events: {
		  title: 'Meetups for this group',
		  noActiveGroup: 'There is no active group. Go back to the Board.',
		  loading: 'Loading meetups…',
		  empty: 'There are no meetups for this group yet.',
		  edit: 'Edit'
		},

		location: {
		  title: 'Meeting Location',
		  mapTitle: 'Meetup map',
		  viewOnMap: 'View on OpenStreetMap',
		  previewTitle: 'Location preview',
		  previewError: 'This address could not be located on the map. Check country / city / address, save the meetup and try again.'
		},

		route: {
		  title: 'Route map (GPX)',
		  points: 'Route points: {{count}}',
		  downloadGpx: 'Download GPX'
		},

		invites: {
		  title: 'Invite members to the meetup',
		  additionalEmails: 'Additional emails',
		  emailsLabel: 'Athlete emails (one per line or separated by commas)',
		  emailsPlaceholder: 'athlete1@mail.com\nathlete2@mail.com\nathlete3@mail.com',
		  send: 'Send invitations'
		},

		tips: {
		  title: 'Tzone safety tips',
		  item1: 'Prefer public, well-lit meeting points.',
		  item2: 'Share your route and schedule with a trusted contact.',
		  item3: 'Do not publish your exact address on open social networks.',
		  item4: 'Always keep an emergency contact phone available.'
		},

		messages: {
		  noActiveGroup: 'There is no active group. Go back to the Board and open the meetup from a group.',
		  eventCreated: '✅ Meetup created.',
		  eventUpdated: '✅ Meetup updated.',
		  gpxUploaded: 'GPX attached successfully.',
		  editingExisting: 'Editing existing meetup. Adjust it and save your changes.',
		  creatingNew: 'Ready to create a new meetup.',
		  saveBeforeInvites: 'Create or save a meetup first.',
		  enterAtLeastOneEmail: 'Enter at least one athlete email.',
		  invitesSent: '✅ Invitations sent successfully.'
		},

		errors: {
		  loadGroups: 'We could not load your groups.',
		  loadEvents: 'Error loading meetups.',
		  createEvent: 'Error creating meetup',
		  updateEvent: 'Error updating meetup',
		  uploadGpx: 'Error uploading GPX',
		  saveEvent: 'Error saving meetup.',
		  sendInvites: 'Error sending invitations.'
		}
	  }
	} 
  }
};
